import React, { createContext, useContext, useState, useEffect } from 'react';

const STRINGS = {
  es: {
    'nav.verify': 'Verificar',
    'nav.panel': 'Panel',
    'nav.login': 'Entrar',
    'common.loading': 'Cargando…',
    'common.verifyingIdentity': 'Verificando identidad…',
    'common.backToPanel': 'Volver al panel',
    'common.goToPanel': 'Ir a mi panel',

    'landing.tag': 'Anclado en Bitcoin · Verificable por cualquiera · Co-firma ML-DSA-87 desde una máquina sin red',
    'landing.betaBanner': 'Beta cerrada. X-39 Acuerdos está en fase de integración: la creación de acuerdos no está abierta al público todavía. Las pruebas ya emitidas se verifican con herramientas independientes. No sustituye a la notaría pública ni a una firma electrónica cualificada.',
    'ag.pqAuthFail': 'La clave de cifrado de la otra parte no está firmada o su firma no es válida. Por seguridad, el chat queda bloqueado hasta resolverlo.',
    'landing.h1': 'Prueba que existió. Compruébalo sin confiar en nadie.',
    'landing.h1b': 'Cada prueba se ancla en Bitcoin y se verifica con herramientas independientes, sin depender de nosotros. Puede llevar además una co-firma ML-DSA-87 (FIPS 204) producida en una máquina que nunca toca la red, verificable contra la huella pública de X-39.',
    'landing.chipPq': 'ML-DSA-87 · FIPS-204',
    'landing.chipBtc': 'Bitcoin · OpenTimestamps',
    'landing.chipTrust': 'SHA-256 en tu navegador',
    'landing.chipCold': 'Clave COLD · Pi air-gapped',
    'landing.chipNode': 'Ancla verificada · nodo propio',
    'landing.ctaVerifySelf': 'Verifícalo tú mismo →',
    'landing.sub': 'Dos personas o empresas cierran un acuerdo con un chat cifrado en el navegador, ambas lo aceptan, y queda un certificado con sello de tiempo en Bitcoin.',
    'landing.ctaPrimary': 'Crear mi primer acuerdo (beta)',
    'landing.ctaSecondary': 'Ver una prueba ya verificada',
    'landing.ctaVerify': 'Verificar una prueba',
    'landing.certTitle': 'Certificado de Acuerdo',
    'landing.certHashLabel': 'Hash del contenido (SHA-256)',
    'landing.certAnchorLabel': 'Ancla Bitcoin',
    'landing.certMockBadge': 'Confirmado en bloque Bitcoin (ejemplo)',
    'landing.sealedStamp': 'SELLADO',
    'landing.s1t': 'Escribe o sube el acuerdo',
    'landing.s1d': 'Texto o archivo. El hash SHA-256 se calcula en tu navegador. Si es un archivo, solo viaja el hash; si escribes el texto aquí, el texto se envía al servicio para habilitar el acuerdo y la evidencia.',
    'landing.s2t': 'Acuerden y acepten',
    'landing.s2d': 'Un chat cifrado en el navegador entre las dos partes. Al aceptar ambas, la conversación se congela y su hash entra en la prueba.',
    'landing.s3t': 'Queda sellado en Bitcoin',
    'landing.s3d': 'Un certificado público que cualquiera puede verificar, sin cuenta y sin coste.',
    'landing.forWhoTitle': 'Para quién',
    'landing.forWho': 'Periodistas, fuentes y organizaciones de derechos humanos que necesitan demostrar que un documento existía —y qué decía— antes de que alguien lo niegue, lo confisque o lo borre, sin depender de una plataforma que pueda ser presionada o apagada. También freelancers y clientes, pymes que cierran tratos, y quien quiera fechar una idea o patente antes de compartirla.',
    'landing.priceTitle': 'Precio',
    'landing.priceBody': 'Gratis. Sin comisiones. No cobramos por crear, aceptar, sellar ni verificar. El código es libre (AGPL-3.0).',
    'landing.soon': 'Próximamente',
    'protect.title': 'Cómo te protege',
    'protect.b1t': 'Anclado en Bitcoin',
    'protect.b1d': 'El acuerdo y el chat congelado se anclan a un bloque de Bitcoin vía OpenTimestamps. La prueba demuestra que el hash existía antes de ese bloque, y la verificas sin nosotros.',
    'protect.b2t': 'Co-firma ML-DSA-87 en frío',
    'protect.b2d': 'Las pruebas pueden llevar una co-firma ML-DSA-87 (FIPS 204) producida en una máquina que nunca toca la red. Se verifica contra la huella pública de la clave COLD de X-39, no solo contra la clave incluida en la evidencia. No hay ninguna clave de firma del operador en un servidor conectado: la firma WARM histórica se retiró en julio de 2026.',
    'protect.b3t': 'Verificable por cualquiera',
    'protect.b3d': 'Gratis y sin comisiones. Descarga la prueba .ots y valídala con herramientas independientes: no hace falta confiar en nosotros.',
    'protect.b4t': 'Segundo reloj: sello de tiempo cualificado',
    'protect.b4d': 'Además de Bitcoin, X-39 añade un sello de tiempo cualificado RFC 3161 emitido por ANF AC, prestador cualificado de servicios de confianza bajo eIDAS (presunción de exactitud de la fecha y de integridad en toda la UE, art. 41). Hoy lo lleva el Evidence Bundle público y se verifica sin conexión con openssl contra la raíz de ANF incluida en el propio bundle. Los acuerdos de la beta llevan, por ahora, el ancla de Bitcoin.',
    'protect.viewBlock': 'Ver el bloque en mempool.space',
    'landing.certOpen': 'Pulsar para corroborar este certificado',
    'landing.certRealBadgePending': 'Sellado · Pendiente de confirmación en Bitcoin',
    'landing.honestyTitle': 'Honestidad verificable',
    'landing.honestyBody': 'No custodiamos fondos ni vendemos tokens. Los archivos no se suben: viaja su huella SHA-256. El texto escrito en la web sí se envía al servicio. El estado «Confirmado» solo aparece con una atestación de bloque Bitcoin real.',
    'landing.footer': 'X-39 Acuerdos — beta cerrada de acuerdos verificables, anclados en Bitcoin.',
    'panel.kicker': 'Panel',
    'panel.title': 'Mis acuerdos',
    'panel.new': 'Nuevo acuerdo',
    'panel.emptyTitle': 'Todavía no tienes acuerdos.',
    'panel.emptyBody': 'Crea el primero y comparte el enlace de invitación con la otra parte.',
    'panel.emptyCta': 'Crear mi primer acuerdo',
    'panel.waitingOther': 'esperando a la otra parte',
    'panel.badgePending': 'Pendiente de aceptación',
    'panel.badgeConfirmed': 'Confirmado · bloque #',
    'panel.badgeSealedPending': 'Sellado · ancla pendiente',

    'crear.kicker': 'Nuevo acuerdo',
    'crear.title': '¿Qué queréis sellar?',
    'crear.titleLabel': 'Título del acuerdo',
    'crear.titlePh': 'p. ej. Contrato de diseño web — entrega y pago',
    'crear.tabText': 'Texto',
    'crear.tabFile': 'Archivo',
    'crear.contentLabel': 'Contenido del acuerdo',
    'crear.textPh': 'Escribe aquí los términos exactos del acuerdo.\nEl texto quedará registrado y su SHA-256 será la huella sellada.',
    'crear.dropTitle': 'Arrastra un archivo o haz clic para elegirlo',
    'crear.dropNote': 'El archivo no se sube: solo se calcula su SHA-256 en tu navegador.',
    'crear.hashLabel': 'Huella SHA-256 (calculada en tu dispositivo)',
    'crear.submit': 'Crear acuerdo y generar enlace de invitación',
    'crear.submitting': 'Creando…',
    'crear.afterNote': 'Después de crear el acuerdo compartirás un enlace de un solo uso con la otra parte.',
    'crear.toastCreated': 'Acuerdo creado. Comparte el enlace de invitación.',

    'ag.badgePending': 'Pendiente de aceptación',
    'ag.badgeConfirmedIn': 'Confirmado en bloque Bitcoin #',
    'ag.badgeSealedPendingBtc': 'Sellado · Pendiente de confirmación en Bitcoin',
    'ag.kicker': 'Acuerdo',
    'ag.contentLabel': 'Contenido del acuerdo',
    'ag.fileLabel': 'Archivo sellado',
    'ag.fileNote': '(el archivo nunca se subió; solo su huella)',
    'ag.hashLabel': 'Huella SHA-256 del contenido',
    'ag.parties': 'Partes',
    'ag.partyA': 'Parte A',
    'ag.partyB': 'Parte B',
    'ag.signed': 'aceptó',
    'ag.notSigned': 'sin aceptar',
    'ag.pendingJoin': 'pendiente de unirse',
    'ag.inviteLabel': 'Enlace de invitación (un solo uso)',
    'ag.copyLink': 'Copiar enlace',
    'ag.copied': 'Enlace copiado',
    'ag.inviteNote': 'La primera persona que entre con este enlace quedará fijada como Parte B. Nadie más podrá usarlo.',
    'ag.signBtn': 'Aceptar este acuerdo',
    'ag.signing': 'Registrando aceptación y preparando la evidencia…',
    'ag.signNote': 'Cuando ambas partes aceptan, el chat se congela y la prueba se ancla en Bitcoin vía OpenTimestamps.',
    'ag.alreadySigned': 'Ya has aceptado. Esperando a la otra parte para sellar y anclar.',
    'ag.sealedProof': 'Prueba sellada',
    'ag.sealedAt': 'Sellado (UTC)',
    'ag.proofHash': 'Hash de la prueba',
    'ag.chatHash': 'Hash del chat congelado',
    'ag.pqSig': 'Firma histórica ML-DSA-87 del operador (WARM, retirada)',
    'ag.checkAnchor': 'Comprobar ancla Bitcoin',
    'ag.certPdf': 'Certificado PDF',
    'ag.otsProof': 'Prueba .ots',
    'ag.publicCert': 'Certificado público',
    'ag.chatHead': 'Chat cifrado en el navegador · solo las partes',
    'ag.chatFrozenSuffix': ' · congelado',
    'ag.chatEmpty': 'Sin mensajes. Negociad los términos aquí: el hilo quedará sellado con el acuerdo.',
    'ag.you': 'tú',
    'ag.chatFrozenNote': 'Hilo sellado. Su hash forma parte de la prueba.',
    'ag.chatPh': 'Escribe un mensaje…',
    'ag.e2eWaiting': 'Cifrado: esperando la clave pública de la contraparte…',
    'ag.chainMismatch': 'Firma bloqueada: la cadena de mensajes del servidor no coincide con tu copia local (posible omisión o reordenación). Recarga y revisa el chat.',
    'ag.chainLabel': 'Integridad del chat',
    'ag.chainOk': 'Cadena verificada localmente',
    'ag.chainFail': 'La cadena NO coincide con tu copia local',
    'ag.msgLocked': 'cifrado — sin clave en este dispositivo',
    'pay.section': 'Pago (opcional)',
    'pay.toggle': 'Añadir un pago al acuerdo',
    'pay.amount': 'Monto (BTC)',
    'pay.address': 'Dirección Bitcoin de cobro',
    'pay.who': '¿Quién paga?',
    'pay.bPaysA': 'La otra parte me paga a mí',
    'pay.aPaysB': 'Yo pago a la otra parte',
    'pay.terms': 'Términos de pago',
    'pay.payTo': 'Pagar a',
    'pay.amountLabel': 'Monto',
    'pay.payerLabel': 'Paga',
    'pay.scan': 'Escanea o copia para pagar. Peer-to-peer, sin custodia.',
    'pay.copyAddr': 'Copiar dirección',
    'pay.openWallet': 'Abrir en wallet',
    'pay.checkStatus': 'Comprobar estado de pago',
    'pay.received': 'Recibido',
    'pay.expected': 'Esperado',
    'pay.paid': 'Pagado',
    'pay.unpaid': 'Pendiente',
    'pay.noncustodial': 'La app nunca toca los fondos. El pago va directo entre las partes por la red Bitcoin.',
    'pay.invalidAddr': 'Dirección Bitcoin no válida',
    'verify.title': 'Verifícalo tú mismo (sin confiar en nosotros)',
    'verify.intro': 'Estas comprobaciones no dependen de X-39. Cualquiera puede reproducirlas con software libre.',
    'verify.checking': 'Comprobando el contenido contra el hash anclado…',
    'verify.hashOk': 'El contenido coincide con el hash anclado en Bitcoin',
    'verify.hashFail': 'El contenido NO coincide con el hash anclado',
    'verify.warm': 'Firma histórica ML-DSA-87 (WARM · operador, retirada en 2026)',
    'verify.cold': 'Co-firma ML-DSA-87 producida fuera de línea (COLD)',
    'verify.runbook': 'Runbook de la ceremonia (PDF)',
    'verify.btc': 'Ancla temporal en Bitcoin (OpenTimestamps)',
    'verify.pubkey': 'Clave pública',
    'verify.signature': 'Firma',
    'verify.fp': 'Huella',
    'verify.runPy': 'Verificar la firma ML-DSA-87 (Python)',
    'verify.runOts': 'Verificar el ancla Bitcoin (ots)',
    'verify.dlProof': 'Descargar prueba (.json)',
    'verify.dlOts': 'Descargar .ots',
    'verify.noCold': 'Esta prueba no incluye co-firma COLD.',
    'verify.sovereign': 'Verificación soberana ejecutada: el ancla del acuerdo demo fue verificada el 2026-07-31 contra un nodo Bitcoin propio y podado (bloque #957242) — cero exploradores, cero calendarios, cero terceros.',
    'verify.sovereignProof': 'Ver captura →',
    'verify.copy': 'Copiar',
    'verify.copied': 'Copiado',
    'ag.toastSealed': 'Acuerdo sellado. Prueba enviada a OpenTimestamps.',
    'ag.toastSigned': 'Aceptación registrada. Falta la de la otra parte.',
    'ag.toastStillPending': 'Aún sin confirmación en bloque. OpenTimestamps suele tardar horas.',

    'join.kicker': 'Invitación',
    'join.title': 'Te han invitado a un acuerdo',
    'join.body': 'Entra con tu llave para quedar vinculado como Parte B. Este enlace es de un solo uso: quedará fijado a tu identidad.',
    'join.cta': 'Entrar con mi llave y unirme',
    'join.progress': 'Vinculándote al acuerdo…',

    'ver.kicker': 'Verificación pública · sin cuenta',
    'ver.title': 'Verificar una prueba',
    'ver.sub': 'Comprueba si un archivo, un texto o un hash corresponde a un acuerdo sellado. En la verificación web, la huella SHA-256 se calcula en tu navegador. La petición de verificación envía únicamente esa huella, no el archivo ni el texto original.',
    'ver.tabFile': 'Archivo',
    'ver.tabText': 'Texto',
    'ver.tabHash': 'Hash',
    'ver.tabBundle': 'Evidence Bundle (.zip)',
    'ver.bundleDrop': 'Arrastra el bundle x39-evidencia-<id>.zip',
    'ver.bundleNote': 'Verificación 100% local en tu navegador: nada se envía a ningún servidor.',
    'ver.bundleErr': 'ZIP inválido o incompleto',
    'ver.bverifying': 'Verificando…',
    'ver.bcheck.files': 'Archivos del bundle',
    'ver.bcheck.integrity': 'Integridad — SHA-256 del proof.json',
    'ver.bcheck.consistency': 'Consistencia de campos',
    'ver.bcheck.chain': 'Cadena de mensajes del chat',
    'ver.bcheck.msgsigs': 'Firmas Ed25519 por mensaje',
    'ver.bcheck.mldsa_cold': 'Co-firma soberana ML-DSA-87 (COLD)',
    'ver.bcheck.mldsa_warm': 'Firma histórica ML-DSA-87 (WARM)',
    'ver.bcheck.manifest': 'Manifiesto de ficheros (README congelado al sellar)',
    'ver.bcheck.ots_present': 'Ancla Bitcoin presente en el bundle (no verificada aquí)',
    'ver.bverdict.valid': 'EVIDENCIA VÁLIDA',
    'ver.bverdict.consistent': 'CONSISTENTE — cuadra todo lo comprobable aquí; el ancla Bitcoin no se verifica en el navegador',
    'ver.bverdict.consistent_nocold': 'CONSISTENTE SIN CO-FIRMA — falta la co-firma soberana, y el ancla Bitcoin tampoco se verifica aquí',
    'ver.bverdict.fail': 'INVÁLIDA O MANIPULADA',
    'ver.botsNote': 'Ancla Bitcoin: el navegador no puede verificarla sin un nodo. Descarga el .ots y ejecuta: ots verify proof.json.ots',
    'ver.bdocTitle': 'Vincular tu documento original (opcional)',
    'ver.bdocNote': 'El documento nunca sale de tu equipo: solo se calcula su SHA-256.',
    'ver.bdocOk': 'Tu documento coincide con el content_hash anclado',
    'ver.bdocBad': 'Tu documento NO coincide con el content_hash',
    'ver.dropTitle': 'Arrastra el archivo a verificar',
    'ver.dropNote': 'Se calcula el SHA-256 localmente y se busca entre los acuerdos sellados.',
    'ver.textPh': 'Pega aquí el texto exacto del acuerdo (byte a byte).',
    'ver.verifyTextBtn': 'Calcular SHA-256 y verificar',
    'ver.verifyHashBtn': 'Verificar hash',
    'ver.verifying': 'Verificando…',
    'ver.hashPh': 'hash sha-256 de 64 caracteres (contenido o prueba)',
    'ver.invalidHash': 'Introduce un SHA-256 válido (64 caracteres hex).',
    'ver.foundTitle': 'Prueba encontrada',
    'ver.matchedBy': 'Coincidencia por',
    'ver.matchedContent': 'hash del contenido',
    'ver.matchedProof': 'hash de la prueba',
    'ver.fTitle': 'Título',
    'ver.anchor': 'Ancla Bitcoin',
    'ver.pendingConf': 'Pendiente de confirmación',
    'ver.pq': 'Firma post-cuántica (ML-DSA-87)',
    'ver.pqValid': 'Válida — verificada en servidor',
    'ver.pqInvalid': 'NO VÁLIDA',
    'ver.cold': 'Firma COLD soberana',
    'ver.contentHash': 'Hash del contenido',
    'ver.notFoundTitle': 'Sin coincidencia',
    'ver.notFoundBody': 'Ningún acuerdo sellado corresponde a este hash. Un solo byte distinto produce un hash totalmente diferente.',

    'cert.sub': 'Prueba de contenido y fecha anclada en Bitcoin',
    'cert.pendingOts': 'Pendiente de confirmación (OpenTimestamps)',
    'cert.downloadPdf': 'Descargar PDF',
    'cert.payloadJson': 'Payload .json',
    'cert.bundle': 'Evidence Bundle (.zip)',
    'cert.share': 'Compartir',
    'cert.shareCopied': 'Enlace público copiado',
    'cert.indepNote': 'Verificación independiente: descarga el payload .json y la prueba .ots y valídalos con cualquier cliente OpenTimestamps. No necesitas confiar en nosotros.',
    'cert.legalScope': 'Alcance legal honesto: esta prueba es evidencia criptográfica de existencia, integridad y fecha: un sello de tiempo en Bitcoin y, cuando la incluye, una cofirma post-cuántica ML-DSA-87 (NIST FIPS 204) de X-39 como operador, hecha en una máquina sin conexión a la red. No sustituye a la notaría pública.',
    'footer.github': 'GitHub · código y evidencia',
    'landing.codeLink': 'Ver el código en GitHub →',
    'footer.contact': 'Contacto',
    'footer.privacy': 'Privacidad',
    'cert.notFound': 'Prueba no encontrada',
    'meta.title': 'X-39 Evidencia — Pruebas de existencia ancladas en Bitcoin',
    'meta.desc': 'Huella y fecha de tus archivos ancladas en Bitcoin vía OpenTimestamps. Verificador de código abierto (AGPL-3.0): cualquiera puede comprobarlo todo sin depender de nosotros.',
    'privacy.title': 'Privacidad y datos',
    'privacy.p1': 'Qué guardamos: el hash SHA-256 de lo que sellas, el título del acuerdo, las claves públicas de las partes, la fecha de sellado, la prueba OpenTimestamps y, si el acuerdo incluye un pago, su importe en BTC y la dirección de cobro. Si escribes el texto del acuerdo en la web, ese texto se guarda para habilitar el acuerdo. Si eliges un archivo para sellarlo o verificarlo, su huella SHA-256 se calcula localmente. Se envía la huella al servicio, sin subir el archivo.',
    'privacy.p2': 'Qué no guardamos: ni correo, ni contraseña, ni nombre. Tu identidad es una llave criptográfica que vive en tu navegador. El chat entre las partes se cifra en el navegador y el servidor solo almacena texto cifrado.',
    'privacy.p3': 'Cookies: una cookie de sesión (httponly, 7 días) tras entrar con tu llave, y la preferencia de idioma en tu navegador. Sin analítica, sin rastreadores, sin terceros: esta web no carga nada de otros dominios.',
    'privacy.p4': 'Dónde y quién: el servidor está en España y lo opera José Luis Olivares (security@x39matrix.org). Bitcoin registra un compromiso criptográfico, nunca el documento. La prueba pública de un acuerdo también incluye su título, identificadores seudónimos de las partes, fechas y, si el acuerdo incluye un pago, su importe en BTC y la dirección de cobro, pero no el documento ni el contenido del chat. El anclaje confirmado puede verificarse independientemente. El compromiso registrado en Bitcoin no puede retirarse de la cadena. Para cualquier consulta sobre tus datos: security@x39matrix.org.',
    'cert.goVerify': 'Ir a verificación',
    'comms.title': 'X-39 Comunicaciones',
    'comms.sub': 'Llamadas, videollamadas y mensajes cifrados entre dos teléfonos. Una app aparte de X-39 Evidencia, del mismo proyecto.',
    'comms.howT': 'Cómo funciona',
    'comms.how1': 'La clave de cada llamada se acuerda entre los dos teléfonos con ML-KEM-1024 (FIPS 203) y se firma con ML-DSA-87 (FIPS 204). El audio y el vídeo se cifran de extremo a extremo con esa clave, que el servidor no tiene. Esto no ha sido auditado por terceros todavía.',
    'comms.how2': 'El tráfico puede ir por un túnel WireGuard opcional hasta un servidor nuestro. Sin cuenta de correo ni número de teléfono: la identidad es una clave que se crea en el teléfono y no sale de él. Cada contacto muestra la huella de su clave, para compararla en persona o por teléfono.',
    'comms.statusT': 'Estado: beta cerrada, por invitación',
    'comms.status1': 'El código y la descarga pública llegan en noviembre de 2026, junto con el modelo de amenazas, la guía de despliegue y la página de privacidad. Hasta entonces, la app se entrega a mano a quien la pide y la prueba con nosotros.',
    'comms.statusMail': 'Para pedir acceso:',
    'comms.dlT': 'Cuando se publique',
    'comms.dl1': 'Aquí estarán el APK, su SHA-256, la huella del certificado de firma y los comandos para comprobarlos, como en [[la página de Evidencia]].',
    'comms.whyT': 'Por qué son dos apps',
    'comms.why1': 'Al sellar o anclar desde Evidencia, solo se envía a los calendarios un compromiso de 32 bytes derivado de la huella. Si eliges enviar una cápsula a un móvil emparejado, el original viaja cifrado de extremo a extremo. Comunicaciones necesita micrófono, cámara y una conexión abierta mientras hablas. Desde Evidencia, un botón abre Comunicaciones si está instalada o te trae a esta página.',
    'comms.limitsT': 'Lo que no es',
    'comms.limits1': 'Con el túnel activado, quien vigile tu red no ve con quién hablas ni qué dices: ve tráfico cifrado hacia nuestro servidor. Pero ve que usas X-39, puede deducir por el ritmo del tráfico que hay una llamada, y puede bloquear el túnel, como hacen ya varios países con WireGuard. El servidor no conoce el contenido, pero sí que dos claves hablaron, cuándo y cuánto. Si tu teléfono está comprometido, nada de esto te protege. No es anónima. Es una beta sin auditoría externa: puede fallar.',
    'comms.backEvidencia': '← Volver a X-39 Evidencia',
    'footer.comms': 'Comunicaciones (beta)',
    'appe.title': 'X-39 Evidencia para Android',
    'appe.sub': 'Fotos, audio, vídeo o cualquier archivo, sellados en tu teléfono. Versión 0.3.4, publicada el 12 de octubre de 2026, en siete idiomas. Android 9 o posterior.',
    'appe.whatT': 'Qué hace',
    'appe.what1': 'Haces una foto, grabas audio o vídeo, o eliges un archivo. Se guarda cifrado en tu teléfono. Al sellar o anclar, solo se envía a los calendarios un compromiso de 32 bytes derivado de la huella. Si eliges enviar una cápsula a un móvil emparejado, el original viaja cifrado de extremo a extremo.',
    'appe.what2': 'Cada elemento se firma con ML-DSA-87 (FIPS 204) con una clave creada en el teléfono. No hay cuenta ni copia en la nube.',
    'appe.what3': 'El hash se ancla en Bitcoin mediante OpenTimestamps. Cualquiera puede verificar el recibo con herramientas públicas, sin esta app y sin confiar en nosotros. Es prueba de existencia, integridad y fecha; no sustituye a un notario ni a una firma electrónica cualificada.',
    'appe.dlT': 'Descarga',
    'appe.dl1': 'El APK se descarga desde esta web, y se publica también en GitHub con su SHA-256, la huella del certificado de firma, el sello de tiempo cualificado y la prueba OpenTimestamps. Comprueba las huellas antes de instalar.',
    'appe.dlLink': 'Descargar x39-0.3.4-release.apk (6,3 MB) desde x39matrix.org',
    'appe.dlLink2': 'La misma versión en GitHub, con los ficheros de verificación',
    'appe.prevT': 'Versión anterior',
    'appe.prev1': 'La 0.3.3 (8 de octubre de 2026), firmada con el mismo certificado y anclada en el bloque 970517, sigue disponible durante una versión más.',
    'appe.prevLink': 'Descargar x39-0.3.3-release.apk',
    'appe.prevGh': 'La 0.3.3 en GitHub, con sus ficheros de verificación',
    'appe.clocksT': 'Dos relojes sobre el mismo APK',
    'appe.clock1': 'Sello de tiempo cualificado (RFC 3161, eIDAS) emitido por ANF AC el 2026-10-12 a las 15:12:15 UTC, verificable con openssl contra la raíz de ANF, que se publica junto al APK.',
    'appe.clock2': 'Ancla en Bitcoin: bloque 971111 (2026-10-12 15:26:58 UTC), comprobado contra nuestro propio nodo. Se verifica con el cliente OpenTimestamps y cualquier nodo Bitcoin.',
    'appe.verifyT': 'Verifica el APK',
    'appe.verify1': 'Con los ficheros del release en la misma carpeta:',
    'appe.permsT': 'Permisos (7)',
    'appe.perms1': 'INTERNET, ACCESS_NETWORK_STATE, CAMERA, RECORD_AUDIO, FOREGROUND_SERVICE, FOREGROUND_SERVICE_SPECIAL_USE y POST_NOTIFICATIONS.',
    'appe.perms2': 'Internet se usa para enviar a los calendarios de OpenTimestamps un compromiso de 32 bytes derivado de la huella y recoger las pruebas (opcionalmente solo por Tor, con Orbot), y para el chat cifrado. Si eliges enviar una cápsula a un móvil emparejado, el original viaja cifrado de extremo a extremo. Sin Google y sin AndroidX: ni Play Services, ni Firebase.',
    'appe.srcT': 'Código',
    'appe.src1': 'El verificador, la web y la API están en GitHub (x39-Evidencia, AGPL-3.0). El código de la app se publicará en su propio repositorio; cada versión sale con sus huellas y sus dos sellos.',
    'appe.toComms': 'X-39 Comunicaciones (app aparte) →',
    'appe.back': '← Volver a X-39 Evidencia',
    'footer.app': 'App Android',
    'landing.commsT': 'App hermana: X-39 Comunicaciones',
    'landing.commsBody': 'Del mismo proyecto: llamadas, videollamadas y mensajes cifrados entre dos teléfonos, con clave de llamada post-cuántica. En beta cerrada por invitación; el código y la descarga pública llegan en noviembre de 2026.',
    'landing.commsLink': 'Saber más y pedir acceso →',
    'landing.ctaDownload': 'Descargar Evidencia (Android)',
    'landing.ctaCreateBeta': 'Crear acuerdo · beta cerrada',
    'landing.proofsT': 'X-39 Evidencia y sus pruebas',
    'landing.proofsApk': 'APK para Android, con su SHA-256, la huella del certificado de firma y los dos relojes (Bitcoin y sello cualificado de ANF)',
    'landing.proofsRepo': 'Código fuente, licencia AGPL-3.0',
    'landing.proofsBundle': 'Evidence Bundle v1.1, su verificador y el resultado VALID contra nodo Bitcoin propio',
    'landing.proofsSevilla': 'Los 40 documentos de Sevilla, sellados y verificables',
    'landing.leavesT': 'Qué sale de tu móvil',
    'landing.leaves': 'Al anclar, solo sale la huella (un compromiso de 32 bytes derivado de ella), hacia los calendarios de OpenTimestamps. Si envías una cápsula a un móvil emparejado, viaja el original cifrado de extremo a extremo, y solo cuando tú la envías.',
    'landing.notProveT': 'Qué no prueba',
    'landing.notProve': 'Prueba que un archivo exacto existía en una fecha y que no ha cambiado desde entonces. No prueba quién es su autor ni que lo que dice sea verdad.',
    'landing.commsLine': 'X-39 Comunicaciones es una app aparte, en beta cerrada y pública en noviembre; Evidencia trae un botón opcional para abrirla, pero funciona sin ella: no necesita VPN y solo usa cámara y micrófono cuando tú haces una foto o grabas.',
  },
  en: {
    'nav.verify': 'Verify',
    'nav.panel': 'Dashboard',
    'nav.login': 'Sign in',
    'common.loading': 'Loading…',
    'common.verifyingIdentity': 'Verifying identity…',
    'common.backToPanel': 'Back to dashboard',
    'common.goToPanel': 'Go to my dashboard',

    'landing.tag': 'Anchored in Bitcoin · Verifiable by anyone · ML-DSA-87 co-signature from an air-gapped machine',
    'landing.betaBanner': 'Closed beta. X-39 Agreements is being integrated: creating agreements is not open to the public yet. Proofs already issued can be verified with independent tools. It does not replace a public notary or a qualified electronic signature.',
    'ag.pqAuthFail': 'The other party\'s encryption key is unsigned or its signature is invalid. For safety, the chat stays locked until this is resolved.',
    'landing.h1': 'Prove it existed. Verify it without trusting anyone.',
    'landing.h1b': 'Every proof is anchored in Bitcoin and can be verified with independent tools, without relying on us. It may also carry an ML-DSA-87 (FIPS 204) co-signature produced on a machine that never touches the network, verifiable against the published X-39 fingerprint.',
    'landing.chipPq': 'ML-DSA-87 · FIPS-204',
    'landing.chipBtc': 'Bitcoin · OpenTimestamps',
    'landing.chipTrust': 'SHA-256 in your browser',
    'landing.chipCold': 'COLD key · air-gapped Pi',
    'landing.chipNode': 'Anchor verified · own node',
    'landing.ctaVerifySelf': 'Verify it yourself →',
    'landing.sub': 'Two people or companies close a deal over a chat encrypted in the browser, both accept it, and a certificate with a Bitcoin timestamp remains.',
    'landing.ctaPrimary': 'Create my first agreement (beta)',
    'landing.ctaSecondary': 'See an already verified proof',
    'landing.ctaVerify': 'Verify a proof',
    'landing.certTitle': 'Certificate of Agreement',
    'landing.certHashLabel': 'Content hash (SHA-256)',
    'landing.certAnchorLabel': 'Bitcoin anchor',
    'landing.certMockBadge': 'Confirmed in Bitcoin block (example)',
    'landing.sealedStamp': 'SEALED',
    'landing.s1t': 'Write or upload the agreement',
    'landing.s1d': 'Text or file. The SHA-256 hash is computed in your browser. For a file, only the hash travels; if you type the text here, the text is sent to the service to enable the agreement and the evidence.',
    'landing.s2t': 'Agree and accept',
    'landing.s2d': 'A chat encrypted in the browser between the two parties. When both accept, the conversation freezes and its hash becomes part of the proof.',
    'landing.s3t': 'Sealed on Bitcoin',
    'landing.s3d': 'A public certificate anyone can verify, with no account and at no cost.',
    'landing.forWhoTitle': "Who it's for",
    'landing.forWho': 'Journalists, sources and human-rights organisations that need to prove a document existed — and what it said — before someone denies, seizes or deletes it, without relying on a platform that can be pressured or switched off. Also freelancers and clients, small businesses closing deals, and anyone who wants to date-stamp an idea or patent before sharing it.',
    'landing.priceTitle': 'Pricing',
    'landing.priceBody': 'Free. No fees. We do not charge for creating, accepting, sealing or verifying. The code is free software (AGPL-3.0).',
    'landing.soon': 'Coming soon',
    'protect.title': 'How it protects you',
    'protect.b1t': 'Anchored in Bitcoin',
    'protect.b1d': 'The agreement and the frozen chat are anchored to a Bitcoin block via OpenTimestamps. The proof shows the hash existed before that block, and you verify it without us.',
    'protect.b2t': 'Air-gapped ML-DSA-87 co-signature',
    'protect.b2d': 'Proofs may carry an ML-DSA-87 (FIPS 204) co-signature produced on a machine that never touches the network. It is verified against the published fingerprint of the X-39 COLD key, not only against the key included in the evidence. No operator signing key lives on any connected server: the historic WARM signature was retired in July 2026.',
    'protect.b3t': 'Verifiable by anyone',
    'protect.b3d': 'Free, no fees. Download the .ots proof and validate it with independent tools: no need to trust us.',
    'protect.b4t': 'Second clock: qualified timestamp',
    'protect.b4d': 'Besides Bitcoin, X-39 adds an RFC 3161 qualified timestamp issued by ANF AC, a qualified trust service provider under eIDAS (presumption of date accuracy and integrity across the EU, art. 41). Today it is carried by the public Evidence Bundle and verified offline with openssl against the ANF root included in the bundle itself. Beta agreements carry the Bitcoin anchor for now.',
    'protect.viewBlock': 'View the block on mempool.space',
    'landing.certOpen': 'Click to corroborate this certificate',
    'landing.certRealBadgePending': 'Sealed · Awaiting Bitcoin confirmation',
    'landing.honestyTitle': 'Verifiable honesty',
    'landing.honestyBody': 'We custody no funds and sell no tokens. Files are not uploaded: only their SHA-256 fingerprint travels. Text typed on the site is sent to the service. The "Confirmed" state only appears with a real Bitcoin block attestation.',
    'landing.footer': 'X-39 Agreements — closed beta of verifiable agreements, anchored on Bitcoin.',
    'panel.kicker': 'Dashboard',
    'panel.title': 'My agreements',
    'panel.new': 'New agreement',
    'panel.emptyTitle': 'You have no agreements yet.',
    'panel.emptyBody': 'Create your first one and share the invite link with the other party.',
    'panel.emptyCta': 'Create my first agreement',
    'panel.waitingOther': 'waiting for the other party',
    'panel.badgePending': 'Awaiting acceptance',
    'panel.badgeConfirmed': 'Confirmed · block #',
    'panel.badgeSealedPending': 'Sealed · anchor pending',

    'crear.kicker': 'New agreement',
    'crear.title': 'What do you want to seal?',
    'crear.titleLabel': 'Agreement title',
    'crear.titlePh': 'e.g. Web design contract — delivery and payment',
    'crear.tabText': 'Text',
    'crear.tabFile': 'File',
    'crear.contentLabel': 'Agreement content',
    'crear.textPh': 'Write the exact terms of the agreement here.\nThe text will be recorded and its SHA-256 will be the sealed fingerprint.',
    'crear.dropTitle': 'Drag a file or click to choose one',
    'crear.dropNote': 'The file is never uploaded: its SHA-256 is computed in your browser.',
    'crear.hashLabel': 'SHA-256 fingerprint (computed on your device)',
    'crear.submit': 'Create agreement and generate invite link',
    'crear.submitting': 'Creating…',
    'crear.afterNote': 'After creating the agreement you will share a single-use link with the other party.',
    'crear.toastCreated': 'Agreement created. Share the invite link.',

    'ag.badgePending': 'Awaiting acceptance',
    'ag.badgeConfirmedIn': 'Confirmed in Bitcoin block #',
    'ag.badgeSealedPendingBtc': 'Sealed · Awaiting Bitcoin confirmation',
    'ag.kicker': 'Agreement',
    'ag.contentLabel': 'Agreement content',
    'ag.fileLabel': 'Sealed file',
    'ag.fileNote': '(the file was never uploaded; only its fingerprint)',
    'ag.hashLabel': 'Content SHA-256 fingerprint',
    'ag.parties': 'Parties',
    'ag.partyA': 'Party A',
    'ag.partyB': 'Party B',
    'ag.signed': 'accepted',
    'ag.notSigned': 'not accepted',
    'ag.pendingJoin': 'pending to join',
    'ag.inviteLabel': 'Invite link (single use)',
    'ag.copyLink': 'Copy link',
    'ag.copied': 'Link copied',
    'ag.inviteNote': 'The first person to open this link will be locked in as Party B. No one else will be able to use it.',
    'ag.signBtn': 'Accept this agreement',
    'ag.signing': 'Recording acceptance and preparing the evidence…',
    'ag.signNote': 'When both parties accept, the chat freezes and the proof is anchored on Bitcoin via OpenTimestamps.',
    'ag.alreadySigned': 'You have accepted. Waiting for the other party to seal and anchor.',
    'ag.sealedProof': 'Sealed proof',
    'ag.sealedAt': 'Sealed (UTC)',
    'ag.proofHash': 'Proof hash',
    'ag.chatHash': 'Frozen chat hash',
    'ag.pqSig': 'Historic operator ML-DSA-87 signature (WARM, retired)',
    'ag.checkAnchor': 'Check Bitcoin anchor',
    'ag.certPdf': 'PDF certificate',
    'ag.otsProof': '.ots proof',
    'ag.publicCert': 'Public certificate',
    'ag.chatHead': 'Chat encrypted in the browser · parties only',
    'ag.chatFrozenSuffix': ' · frozen',
    'ag.chatEmpty': 'No messages. Negotiate the terms here: the thread will be sealed with the agreement.',
    'ag.you': 'you',
    'ag.chatFrozenNote': 'Thread sealed. Its hash is part of the proof.',
    'ag.chatPh': 'Type a message…',
    'ag.e2eWaiting': 'Encryption: waiting for the counterparty public key…',
    'ag.chainMismatch': 'Signature blocked: the server message chain does not match your local copy (possible omission or reordering). Reload and review the chat.',
    'ag.chainLabel': 'Chat integrity',
    'ag.chainOk': 'Chain verified locally',
    'ag.chainFail': 'Chain does NOT match your local copy',
    'ag.msgLocked': 'encrypted — no key on this device',
    'pay.section': 'Payment (optional)',
    'pay.toggle': 'Add a payment to the agreement',
    'pay.amount': 'Amount (BTC)',
    'pay.address': 'Bitcoin receiving address',
    'pay.who': 'Who pays?',
    'pay.bPaysA': 'The other party pays me',
    'pay.aPaysB': 'I pay the other party',
    'pay.terms': 'Payment terms',
    'pay.payTo': 'Pay to',
    'pay.amountLabel': 'Amount',
    'pay.payerLabel': 'Payer',
    'pay.scan': 'Scan or copy to pay. Peer-to-peer, non-custodial.',
    'pay.copyAddr': 'Copy address',
    'pay.openWallet': 'Open in wallet',
    'pay.checkStatus': 'Check payment status',
    'pay.received': 'Received',
    'pay.expected': 'Expected',
    'pay.paid': 'Paid',
    'pay.unpaid': 'Pending',
    'pay.noncustodial': 'The app never touches the funds. Payment goes directly between the parties over the Bitcoin network.',
    'pay.invalidAddr': 'Invalid Bitcoin address',
    'verify.title': 'Verify it yourself (without trusting us)',
    'verify.intro': 'These checks do not depend on X-39. Anyone can reproduce them with free software.',
    'verify.checking': 'Checking the content against the anchored hash…',
    'verify.hashOk': 'The content matches the hash anchored in Bitcoin',
    'verify.hashFail': 'The content does NOT match the anchored hash',
    'verify.warm': 'Historic ML-DSA-87 signature (WARM · operator, retired in 2026)',
    'verify.cold': 'Offline ML-DSA-87 co-signature (COLD)',
    'verify.runbook': 'Key ceremony runbook (PDF)',
    'verify.btc': 'Bitcoin timestamp anchor (OpenTimestamps)',
    'verify.pubkey': 'Public key',
    'verify.signature': 'Signature',
    'verify.fp': 'Fingerprint',
    'verify.runPy': 'Verify the ML-DSA-87 signature (Python)',
    'verify.runOts': 'Verify the Bitcoin anchor (ots)',
    'verify.dlProof': 'Download proof (.json)',
    'verify.dlOts': 'Download .ots',
    'verify.noCold': 'This proof does not include a COLD co-signature.',
    'verify.sovereign': 'Sovereign verification executed: the demo agreement anchor was verified on 2026-07-31 against a self-hosted pruned Bitcoin node (block #957242) — zero explorers, zero calendars, zero third parties.',
    'verify.sovereignProof': 'View capture →',
    'verify.copy': 'Copy',
    'verify.copied': 'Copied',
    'ag.toastSealed': 'Agreement sealed. Proof submitted to OpenTimestamps.',
    'ag.toastSigned': 'Acceptance recorded. Waiting for the other party.',
    'ag.toastStillPending': 'No block confirmation yet. OpenTimestamps usually takes hours.',

    'join.kicker': 'Invitation',
    'join.title': "You've been invited to an agreement",
    'join.body': 'Sign in with your key to be bound as Party B. This link is single-use: it will be locked to your identity.',
    'join.cta': 'Sign in with my key and join',
    'join.progress': 'Linking you to the agreement…',

    'ver.kicker': 'Public verification · no account',
    'ver.title': 'Verify a proof',
    'ver.sub': 'Check whether a file, a text or a hash matches a sealed agreement. In web verification, the SHA-256 digest is computed in your browser. The verification request sends only that digest, not the original file or text.',
    'ver.tabFile': 'File',
    'ver.tabText': 'Text',
    'ver.tabHash': 'Hash',
    'ver.tabBundle': 'Evidence Bundle (.zip)',
    'ver.bundleDrop': 'Drop the x39-evidencia-<id>.zip evidence bundle',
    'ver.bundleNote': '100% local verification in your browser: nothing is sent to any server.',
    'ver.bundleErr': 'Invalid or incomplete ZIP',
    'ver.bverifying': 'Verifying…',
    'ver.bcheck.files': 'Bundle files',
    'ver.bcheck.integrity': 'Integrity — SHA-256 of proof.json',
    'ver.bcheck.consistency': 'Field consistency',
    'ver.bcheck.chain': 'Chat message chain',
    'ver.bcheck.msgsigs': 'Per-message Ed25519 signatures',
    'ver.bcheck.mldsa_cold': 'Sovereign ML-DSA-87 co-signature (COLD)',
    'ver.bcheck.mldsa_warm': 'Historic ML-DSA-87 signature (WARM)',
    'ver.bcheck.manifest': 'File manifest (README frozen at sealing)',
    'ver.bcheck.ots_present': 'Bitcoin anchor present in the bundle (not verified here)',
    'ver.bverdict.valid': 'EVIDENCE VALID',
    'ver.bverdict.consistent': 'CONSISTENT — everything checkable here matches; the Bitcoin anchor is not verified in the browser',
    'ver.bverdict.consistent_nocold': 'CONSISTENT, NO CO-SIGNATURE — the sovereign co-signature is missing, and the Bitcoin anchor is not verified here either',
    'ver.bverdict.fail': 'INVALID OR TAMPERED',
    'ver.botsNote': 'Bitcoin anchor: the browser cannot verify it without a node. Download the .ots and run: ots verify proof.json.ots',
    'ver.bdocTitle': 'Link your original document (optional)',
    'ver.bdocNote': 'The document never leaves your device: only its SHA-256 is computed.',
    'ver.bdocOk': 'Your document matches the anchored content_hash',
    'ver.bdocBad': 'Your document does NOT match the content_hash',
    'ver.dropTitle': 'Drag the file to verify',
    'ver.dropNote': 'The SHA-256 is computed locally and matched against sealed agreements.',
    'ver.textPh': 'Paste the exact agreement text here (byte for byte).',
    'ver.verifyTextBtn': 'Compute SHA-256 and verify',
    'ver.verifyHashBtn': 'Verify hash',
    'ver.verifying': 'Verifying…',
    'ver.hashPh': '64-character sha-256 hash (content or proof)',
    'ver.invalidHash': 'Enter a valid SHA-256 (64 hex characters).',
    'ver.foundTitle': 'Proof found',
    'ver.matchedBy': 'Matched by',
    'ver.matchedContent': 'content hash',
    'ver.matchedProof': 'proof hash',
    'ver.fTitle': 'Title',
    'ver.anchor': 'Bitcoin anchor',
    'ver.pendingConf': 'Awaiting confirmation',
    'ver.pq': 'Post-quantum signature (ML-DSA-87)',
    'ver.pqValid': 'Valid — verified server-side',
    'ver.pqInvalid': 'INVALID',
    'ver.cold': 'Sovereign COLD signature',
    'ver.contentHash': 'Content hash',
    'ver.notFoundTitle': 'No match',
    'ver.notFoundBody': 'No sealed agreement matches this hash. A single different byte produces a completely different hash.',

    'cert.sub': 'Proof of content and date anchored on Bitcoin',
    'cert.pendingOts': 'Awaiting confirmation (OpenTimestamps)',
    'cert.downloadPdf': 'Download PDF',
    'cert.payloadJson': '.json payload',
    'cert.bundle': 'Evidence Bundle (.zip)',
    'cert.share': 'Share',
    'cert.shareCopied': 'Public link copied',
    'cert.indepNote': "Independent verification: download the .json payload and the .ots proof and validate them with any OpenTimestamps client. You don't need to trust us.",
    'cert.legalScope': 'Honest legal scope: this proof is cryptographic evidence of existence, integrity and date: a Bitcoin timestamp and, when included, a post-quantum ML-DSA-87 (NIST FIPS 204) co-signature by X-39 as operator, produced on an air-gapped machine. It does not replace a public notary.',
    'footer.github': 'GitHub · code & evidence',
    'landing.codeLink': 'See the code on GitHub →',
    'footer.contact': 'Contact',
    'footer.privacy': 'Privacy',
    'cert.notFound': 'Proof not found',
    'meta.title': 'X-39 Evidencia — Proof of existence anchored in Bitcoin',
    'meta.desc': 'Fingerprint and date of your files anchored in Bitcoin via OpenTimestamps. Open-source verifier (AGPL-3.0): anyone can check everything without relying on us.',
    'privacy.title': 'Privacy and data',
    'privacy.p1': 'What we store: the SHA-256 hash of what you seal, the agreement title, the parties\' public keys, the sealing date, the OpenTimestamps proof and, if the agreement includes a payment, its BTC amount and the receiving address. If you type the agreement text on the site, that text is stored to enable the agreement. If you choose a file to seal or verify, its SHA-256 digest is computed locally. The digest is sent to the service without uploading the file.',
    'privacy.p2': 'What we do not store: no e-mail, no password, no name. Your identity is a cryptographic key that lives in your browser. The chat between the parties is encrypted in the browser; the server only stores ciphertext.',
    'privacy.p3': 'Cookies: one session cookie (httponly, 7 days) after signing in with your key, and your language preference in your browser. No analytics, no trackers, no third parties: this site loads nothing from other domains.',
    'privacy.p4': 'Where and who: the server runs in Spain and is operated by José Luis Olivares (security@x39matrix.org). Bitcoin records a cryptographic commitment, never the document. A public agreement proof also includes its title, the parties\' pseudonymous identifiers, dates and, if the agreement includes a payment, its BTC amount and the receiving address, but not the document or chat contents. The confirmed anchor can be verified independently. The commitment recorded in Bitcoin cannot be removed from the chain. For any question about your data: security@x39matrix.org.',
    'cert.goVerify': 'Go to verification',
    'comms.title': 'X-39 Comunicaciones',
    'comms.sub': 'Encrypted calls, video calls and messages between two phones. A separate app from X-39 Evidencia, by the same project.',
    'comms.howT': 'How it works',
    'comms.how1': 'The key for each call is agreed between the two phones with ML-KEM-1024 (FIPS 203) and signed with ML-DSA-87 (FIPS 204). Audio and video are end-to-end encrypted with that key, which the server does not have. This has not yet been audited by a third party.',
    'comms.how2': 'Traffic can go through an optional WireGuard tunnel to a server of ours. No e-mail account and no phone number: your identity is a key created on the phone that never leaves it. Each contact shows the fingerprint of their key, to be compared in person or over the phone.',
    'comms.statusT': 'Status: closed beta, by invitation',
    'comms.status1': 'The code and the public download arrive in November 2026, together with the threat model, the deployment guide and the privacy page. Until then the app is handed out by hand to those who ask for it and test it with us.',
    'comms.statusMail': 'To request access:',
    'comms.dlT': 'When it is published',
    'comms.dl1': 'This page will carry the APK, its SHA-256, the signing-certificate fingerprint and the commands to check them, as on [[the Evidencia page]].',
    'comms.whyT': 'Why two apps',
    'comms.why1': 'When sealing or anchoring from Evidencia, only a 32-byte commitment derived from the fingerprint is sent to the calendars. If you choose to send a capsule to a paired phone, the original travels end-to-end encrypted. Comunicaciones needs the microphone, camera and an open connection while you talk. From Evidencia, a button opens Comunicaciones if installed, or brings you to this page.',
    'comms.limitsT': 'What it is not',
    'comms.limits1': 'With the tunnel on, whoever watches your network does not see who you talk to or what you say: they see encrypted traffic to our server. But they do see that you use X-39, they can infer from the traffic pattern that a call is going on, and they can block the tunnel, as several countries already do with WireGuard. The server does not know the content, but it does know that two keys talked, when and for how long. If your phone is compromised, none of this protects you. It is not anonymous. It is a beta with no external audit yet: it can fail.',
    'comms.backEvidencia': '← Back to X-39 Evidencia',
    'footer.comms': 'Comunicaciones (beta)',
    'appe.title': 'X-39 Evidencia for Android',
    'appe.sub': 'Photos, audio, video or any file, sealed on your phone. Version 0.3.4, published on 12 October 2026, in seven languages. Android 9 or later.',
    'appe.whatT': 'What it does',
    'appe.what1': 'You take a photo, record audio or video, or pick a file. It is stored encrypted on your phone. When sealing or anchoring, only a 32-byte commitment derived from the fingerprint is sent to the calendars. If you choose to send a capsule to a paired phone, the original travels end-to-end encrypted.',
    'appe.what2': 'Every item is signed with ML-DSA-87 (FIPS 204) using a key created on the phone. No account and no cloud copy.',
    'appe.what3': 'The hash is anchored in Bitcoin through OpenTimestamps. Anyone can verify the receipt with public tools, without this app and without trusting us. It is proof of existence, integrity and date; it does not replace a notary or a qualified electronic signature.',
    'appe.dlT': 'Download',
    'appe.dl1': 'The APK is downloaded from this site, and is also published on GitHub with its SHA-256, the signing-certificate fingerprint, the qualified timestamp and the OpenTimestamps proof. Check the fingerprints before installing.',
    'appe.dlLink': 'Download x39-0.3.4-release.apk (6.3 MB) from x39matrix.org',
    'appe.dlLink2': 'The same version on GitHub, with the verification files',
    'appe.prevT': 'Previous version',
    'appe.prev1': '0.3.3 (8 October 2026), signed with the same certificate and anchored in block 970517, remains available for one more release.',
    'appe.prevLink': 'Download x39-0.3.3-release.apk',
    'appe.prevGh': '0.3.3 on GitHub, with its verification files',
    'appe.clocksT': 'Two clocks on the same APK',
    'appe.clock1': 'Qualified timestamp (RFC 3161, eIDAS) issued by ANF AC on 2026-10-12 at 15:12:15 UTC, verifiable with openssl against the ANF root, published next to the APK.',
    'appe.clock2': 'Bitcoin anchor: block 971111 (2026-10-12 15:26:58 UTC), checked against our own node. Verifiable with the OpenTimestamps client and any Bitcoin node.',
    'appe.verifyT': 'Verify the APK',
    'appe.verify1': 'With the release files in the same folder:',
    'appe.permsT': 'Permissions (7)',
    'appe.perms1': 'INTERNET, ACCESS_NETWORK_STATE, CAMERA, RECORD_AUDIO, FOREGROUND_SERVICE, FOREGROUND_SERVICE_SPECIAL_USE and POST_NOTIFICATIONS.',
    'appe.perms2': 'Internet is used to send a 32-byte commitment derived from the fingerprint to the OpenTimestamps calendars and fetch proofs (optionally only over Tor, with Orbot), and for encrypted chat. If you choose to send a capsule to a paired phone, the original travels end-to-end encrypted. No Google and no AndroidX: no Play Services, no Firebase.',
    'appe.srcT': 'Code',
    'appe.src1': 'The verifier, the web and the API are on GitHub (x39-Evidencia, AGPL-3.0). The app code will be published in its own repository; every version ships with its fingerprints and its two seals.',
    'appe.toComms': 'X-39 Comunicaciones (separate app) →',
    'appe.back': '← Back to X-39 Evidencia',
    'footer.app': 'Android app',
    'landing.commsT': 'Companion app: X-39 Comunicaciones',
    'landing.commsBody': 'From the same project: encrypted calls, video calls and messages between two phones, with a post-quantum call key. In closed beta by invitation; the code and the public download arrive in November 2026.',
    'landing.commsLink': 'Learn more and request access →',
    'landing.ctaDownload': 'Download Evidencia (Android)',
    'landing.ctaCreateBeta': 'Create agreement · closed beta',
    'landing.proofsT': 'X-39 Evidencia and its proofs',
    'landing.proofsApk': 'Android APK, with its SHA-256, the signing certificate fingerprint and both clocks (Bitcoin and ANF qualified timestamp)',
    'landing.proofsRepo': 'Source code, AGPL-3.0 licence',
    'landing.proofsBundle': 'Evidence Bundle v1.1, its verifier and the VALID result against our own Bitcoin node',
    'landing.proofsSevilla': 'The 40 Seville documents, sealed and verifiable',
    'landing.leavesT': 'What leaves your phone',
    'landing.leaves': 'When anchoring, only the fingerprint leaves (a 32-byte commitment derived from it), sent to the OpenTimestamps calendars. If you send a capsule to a paired phone, the original travels end-to-end encrypted, and only when you send it.',
    'landing.notProveT': 'What it does not prove',
    'landing.notProve': 'It proves that an exact file existed at a given date and has not changed since. It does not prove who wrote it, or that what it says is true.',
    'landing.commsLine': 'X-39 Comunicaciones is a separate app, in closed beta and public in November; Evidencia has an optional button to open it, but works without it: it needs no VPN and only uses the camera and microphone when you take a photo or record.',
  },
  zh: {
    'nav.verify': '验证',
    'nav.panel': '控制台',
    'nav.login': '登录',
    'common.loading': '加载中…',
    'common.verifyingIdentity': '正在验证身份…',
    'common.backToPanel': '返回控制台',
    'common.goToPanel': '进入我的控制台',
    'landing.tag': '锚定比特币 · 任何人皆可验证 · 来自离线机器的 ML-DSA-87 联合签名',
    'landing.betaBanner': '封闭测试版。X-39 Agreements 正在集成中：协议创建功能尚未向公众开放。已签发的证明可用独立工具验证。它不能替代公证处或合格电子签名。',
    'ag.pqAuthFail': '对方的加密密钥未签名或签名无效。为安全起见，聊天将保持锁定，直到问题解决。',
    'landing.h1': '证明它存在过。无需信任任何人，自己验证。',
    'landing.h1b': '每份证明都锚定在比特币上，可用独立工具验证，无需依赖我们。证明还可带有在从不联网的机器上生成的 ML-DSA-87（FIPS 204）联合签名，并可对照 X-39 公开的密钥指纹进行验证。',
    'landing.chipPq': 'ML-DSA-87 · FIPS-204',
    'landing.chipBtc': 'Bitcoin · OpenTimestamps',
    'landing.chipTrust': 'SHA-256 在你的浏览器中计算',
    'landing.chipCold': 'COLD 密钥 · 气隙树莓派',
    'landing.chipNode': '锚点已验证 · 自有节点',
    'landing.ctaVerifySelf': '亲自验证 →',
    'landing.sub': '两个人或两家公司通过在浏览器中加密的聊天达成协议，双方接受后，即生成带有比特币时间戳的证书。',
    'landing.ctaPrimary': '创建我的第一份协议（测试版）',
    'landing.ctaSecondary': '查看一份已验证的证明',
    'landing.ctaVerify': '验证一份证明',
    'landing.certTitle': '协议证书',
    'landing.certHashLabel': '内容哈希（SHA-256）',
    'landing.certAnchorLabel': '比特币锚定',
    'landing.certMockBadge': '已在比特币区块中确认（示例）',
    'landing.sealedStamp': '已盖章',
    'landing.s1t': '撰写或上传协议',
    'landing.s1d': '文本或文件。SHA-256 哈希在你的浏览器中计算。如果是文件，只传输哈希；如果在此处输入文本，文本会发送到服务端以创建协议和证据。',
    'landing.s2t': '协商并接受',
    'landing.s2d': '双方之间在浏览器中加密的聊天。双方接受后，对话被冻结，其哈希纳入证明。',
    'landing.s3t': '封存于比特币',
    'landing.s3d': '一份任何人都可以验证的公开证书，无需账户，完全免费。',
    'landing.forWhoTitle': '适合谁',
    'landing.forWho': '需要证明某份文件在被否认、没收或删除之前确实存在、以及其内容为何的记者、消息来源和人权组织——无需依赖任何可能受到施压或被关闭的平台。也适用于自由职业者与客户、达成交易的中小企业，以及任何想在分享前为创意或专利留下时间戳的人。',
    'landing.priceTitle': '价格',
    'landing.priceBody': '免费，无手续费。创建、接受、封存和验证均不收费。代码是自由软件（AGPL-3.0）。',
    'landing.soon': '即将推出',
    'landing.honestyTitle': '可验证的诚实',
    'landing.honestyBody': '我们不托管资金，也不出售代币。文件不会上传，只传输其 SHA-256 指纹。在网站上输入的文本会发送到服务端。只有在存在真实的比特币区块证明时，才会显示“已确认”状态。',
    'landing.footer': 'X-39 Agreements — 可验证协议的封闭测试版，锚定于比特币。',
    'landing.certOpen': '点击核验此证书',
    'landing.certRealBadgePending': '已封存 · 等待比特币确认',
    'protect.title': '如何保护你',
    'protect.b1t': '锚定于比特币',
    'protect.b1d': '协议和冻结的聊天通过 OpenTimestamps 锚定到比特币区块。证明表明该哈希在该区块之前已存在，且你无需依赖我们即可验证。',
    'protect.b2t': '离线 ML-DSA-87 联合签名',
    'protect.b2d': '证明可带有在从不联网的机器上生成的 ML-DSA-87（FIPS 204）联合签名。验证时不仅对照证据中包含的公钥，还要对照 X-39 公开的 COLD 密钥指纹。任何联网服务器上都没有运营方的签名密钥：历史上的 WARM 签名已于 2026 年 7 月停用。',
    'protect.b3t': '任何人皆可验证',
    'protect.b3d': '免费，无手续费。下载 .ots 证明并用独立工具验证：无需信任我们。',
    'protect.b4t': '第二时钟：合格时间戳',
    'protect.b4d': '除比特币之外，X-39 还加入由 ANF AC 签发的 RFC 3161 合格时间戳。ANF AC 是 eIDAS 框架下的合格信任服务提供者，其时间戳在欧盟范围内享有日期准确性与完整性的法律推定（eIDAS 第 41 条）。目前公开的 Evidence Bundle 已带有该时间戳，可用 openssl 离线验证，对照 bundle 内附带的 ANF 根证书。测试版协议目前仅带有比特币锚定。',
    'protect.viewBlock': '在 mempool.space 查看区块',
    'panel.kicker': '控制台',
    'panel.title': '我的协议',
    'panel.new': '新建协议',
    'panel.emptyTitle': '你还没有任何协议。',
    'panel.emptyBody': '创建第一份协议，并将邀请链接分享给对方。',
    'panel.emptyCta': '创建我的第一份协议',
    'panel.waitingOther': '等待对方加入',
    'panel.badgePending': '等待接受',
    'panel.badgeConfirmed': '已确认 · 区块 #',
    'panel.badgeSealedPending': '已封存 · 等待锚定',
    'crear.kicker': '新建协议',
    'crear.title': '你们想封存什么？',
    'crear.titleLabel': '协议标题',
    'crear.titlePh': '例如：网页设计合同——交付与付款',
    'crear.tabText': '文本',
    'crear.tabFile': '文件',
    'crear.contentLabel': '协议内容',
    'crear.textPh': '在此写下协议的确切条款。\n文本将被记录，其 SHA-256 将成为封存的指纹。',
    'crear.dropTitle': '拖入文件或点击选择',
    'crear.dropNote': '文件不会上传：仅在你的浏览器中计算其 SHA-256。',
    'crear.hashLabel': 'SHA-256 指纹（在你的设备上计算）',
    'crear.submit': '创建协议并生成邀请链接',
    'crear.submitting': '创建中…',
    'crear.afterNote': '创建协议后，你将与对方分享一个一次性链接。',
    'crear.toastCreated': '协议已创建。请分享邀请链接。',
    'ag.badgePending': '等待接受',
    'ag.badgeConfirmedIn': '已在比特币区块中确认 #',
    'ag.badgeSealedPendingBtc': '已封存 · 等待比特币确认',
    'ag.kicker': '协议',
    'ag.contentLabel': '协议内容',
    'ag.fileLabel': '已封存的文件',
    'ag.fileNote': '（文件从未上传；仅有其指纹）',
    'ag.hashLabel': '内容的 SHA-256 指纹',
    'ag.parties': '双方',
    'ag.partyA': '甲方',
    'ag.partyB': '乙方',
    'ag.signed': '已接受',
    'ag.notSigned': '未接受',
    'ag.pendingJoin': '等待加入',
    'ag.inviteLabel': '邀请链接（仅限一次使用）',
    'ag.copyLink': '复制链接',
    'ag.copied': '链接已复制',
    'ag.inviteNote': '第一个通过此链接进入的人将被固定为乙方。其他人将无法使用。',
    'ag.signBtn': '接受此协议',
    'ag.signing': '正在记录接受并准备证据…',
    'ag.signNote': '双方接受后，聊天将被冻结，证明通过 OpenTimestamps 锚定到比特币。',
    'ag.alreadySigned': '你已接受。等待另一方以封存并锚定。',
    'ag.sealedProof': '已封存的证明',
    'ag.sealedAt': '封存时间（UTC）',
    'ag.proofHash': '证明哈希',
    'ag.chatHash': '冻结聊天的哈希',
    'ag.pqSig': '运营方历史 ML-DSA-87 签名（WARM，已停用）',
    'ag.checkAnchor': '检查比特币锚定',
    'ag.certPdf': 'PDF 证书',
    'ag.otsProof': '.ots 证明',
    'ag.publicCert': '公开证书',
    'ag.chatHead': '浏览器端加密聊天 · 仅限双方',
    'ag.chatFrozenSuffix': ' · 已冻结',
    'ag.chatEmpty': '暂无消息。在此协商条款：对话将与协议一同封存。',
    'ag.you': '你',
    'ag.chatFrozenNote': '对话已封存。其哈希是证明的一部分。',
    'ag.chatPh': '输入消息…',
    'ag.e2eWaiting': '加密：等待对方的公钥…',
    'ag.chainMismatch': '签名已阻止：服务器的消息链与您的本地副本不一致（可能存在遗漏或重排）。请刷新并检查聊天记录。',
    'ag.chainLabel': '聊天完整性',
    'ag.chainOk': '链已在本地验证',
    'ag.chainFail': '链与您的本地副本不一致',
    'ag.msgLocked': '已加密 — 此设备无密钥',
    'pay.section': '付款（可选）',
    'pay.toggle': '为协议添加付款',
    'pay.amount': '金额（BTC）',
    'pay.address': '比特币收款地址',
    'pay.who': '谁付款？',
    'pay.bPaysA': '对方付款给我',
    'pay.aPaysB': '我付款给对方',
    'pay.terms': '付款条款',
    'pay.payTo': '付款至',
    'pay.amountLabel': '金额',
    'pay.payerLabel': '付款方',
    'pay.scan': '扫描或复制以付款。点对点，无托管。',
    'pay.copyAddr': '复制地址',
    'pay.openWallet': '在钱包中打开',
    'pay.checkStatus': '查询付款状态',
    'pay.received': '已收到',
    'pay.expected': '预期',
    'pay.paid': '已付款',
    'pay.unpaid': '待付款',
    'pay.noncustodial': '本应用从不接触资金。付款通过比特币网络在双方之间直接进行。',
    'pay.invalidAddr': '比特币地址无效',
    'verify.title': '自行验证（无需信任我们）',
    'verify.intro': '这些验证不依赖 X-39。任何人都可用自由软件复现。',
    'verify.checking': '正在将内容与锚定哈希比对…',
    'verify.hashOk': '内容与锚定在比特币中的哈希一致',
    'verify.hashFail': '内容与锚定哈希不一致',
    'verify.warm': '历史 ML-DSA-87 签名（WARM · 运营方，2026 年停用）',
    'verify.cold': '离线生成的 ML-DSA-87 联合签名（COLD）',
    'verify.runbook': '密钥仪式手册（PDF）',
    'verify.btc': '比特币时间戳锚定（OpenTimestamps）',
    'verify.pubkey': '公钥',
    'verify.signature': '签名',
    'verify.fp': '指纹',
    'verify.runPy': '验证 ML-DSA-87 签名（Python）',
    'verify.runOts': '验证比特币锚定（ots）',
    'verify.dlProof': '下载证明（.json）',
    'verify.dlOts': '下载 .ots',
    'verify.noCold': '此证明不包含 COLD 联合签名。',
    'verify.sovereign': '主权验证已执行：演示协议的锚点已于 2026-07-31 通过自有修剪版比特币节点验证（区块 #957242）——零区块浏览器、零日历服务器、零第三方。',
    'verify.sovereignProof': '查看截图 →',
    'verify.copy': '复制',
    'verify.copied': '已复制',
    'ag.toastSealed': '协议已封存。证明已提交至 OpenTimestamps。',
    'ag.toastSigned': '已记录接受。等待另一方。',
    'ag.toastStillPending': '尚未在区块中确认。OpenTimestamps 通常需要数小时。',
    'join.kicker': '邀请',
    'join.title': '你被邀请加入一份协议',
    'join.body': '使用你的密钥登录，即可绑定为乙方。此链接仅限一次使用：将与你的身份绑定。',
    'join.cta': '使用我的密钥登录并加入',
    'join.progress': '正在将你绑定到协议…',
    'ver.kicker': '公开验证 · 无需账户',
    'ver.title': '验证一份证明',
    'ver.sub': '检查文件、文本或哈希是否对应某份已封存的协议。网页验证时，SHA-256 哈希值在你的浏览器中计算。验证请求只发送该哈希值，不发送原始文件或文本。',
    'ver.tabFile': '文件',
    'ver.tabText': '文本',
    'ver.tabHash': '哈希',
    'ver.dropTitle': '拖入要验证的文件',
    'ver.dropNote': '在本地计算 SHA-256，并在已封存的协议中查找。',
    'ver.textPh': '在此粘贴协议的确切文本（逐字节）。',
    'ver.verifyTextBtn': '计算 SHA-256 并验证',
    'ver.verifyHashBtn': '验证哈希',
    'ver.verifying': '验证中…',
    'ver.hashPh': '64 位十六进制 sha-256 哈希（内容或证明）',
    'ver.invalidHash': '请输入有效的 SHA-256（64 位十六进制字符）。',
    'ver.foundTitle': '找到证明',
    'ver.matchedBy': '匹配方式：',
    'ver.matchedContent': '内容哈希',
    'ver.matchedProof': '证明哈希',
    'ver.fTitle': '标题',
    'ver.anchor': '比特币锚定',
    'ver.pendingConf': '等待确认',
    'ver.pq': '后量子签名（ML-DSA-87）',
    'ver.pqValid': '有效 — 服务器端已验证',
    'ver.pqInvalid': '无效',
    'ver.cold': '主权 COLD 签名',
    'ver.contentHash': '内容哈希',
    'ver.notFoundTitle': '无匹配',
    'ver.notFoundBody': '没有任何已封存的协议对应此哈希。哪怕一个字节不同，哈希也会完全不同。',
    'cert.sub': '内容与日期的证明，锚定于比特币',
    'cert.pendingOts': '等待确认（OpenTimestamps）',
    'cert.downloadPdf': '下载 PDF',
    'cert.payloadJson': '.json 载荷',
    'cert.bundle': 'Evidence Bundle (.zip)',
    'cert.share': '分享',
    'cert.shareCopied': '公开链接已复制',
    'cert.indepNote': '独立验证：下载 .json 载荷和 .ots 证明，用任何 OpenTimestamps 客户端验证。无需信任我们。',
    'cert.legalScope': '诚实的法律范围：此证明是关于存在性、完整性和日期的加密证据：比特币时间戳，以及（如包含）X-39 作为运营方在离线设备上生成的抗量子 ML-DSA-87（NIST FIPS 204）联署签名。它不能替代公证处。',
    'cert.goVerify': '前往验证',
    'footer.github': 'GitHub · 代码与证据',
    'landing.codeLink': '在 GitHub 上查看代码 →',
    'footer.contact': '联系',
    'footer.privacy': '隐私',
    'cert.notFound': '未找到证明',
    'meta.title': 'X-39 Evidencia — 锚定于比特币的存在证明',
    'meta.desc': '通过 OpenTimestamps 将文件的指纹和日期锚定在比特币上。开源验证器（AGPL-3.0）：任何人都可自行验证，无需依赖我们。',
    'privacy.title': '隐私与数据',
    'privacy.p1': '我们存储什么：你所封存内容的 SHA-256 哈希、协议标题、双方的公钥、封存日期、OpenTimestamps 证明，以及（如果协议包含付款）以 BTC 计的金额和收款地址。如果你在网站上输入协议文本，该文本会被保存以启用协议。如果你选择一个文件进行封存或验证，其 SHA-256 哈希值会在本地计算。发送给服务的是哈希值，文件不会被上传。',
    'privacy.p2': '我们不存储什么：没有电子邮件、没有密码、没有姓名。你的身份是保存在浏览器中的密码学密钥。双方之间的聊天在浏览器中加密；服务器只保存密文。',
    'privacy.p3': 'Cookie：使用密钥登录后有一个会话 Cookie（httponly，7 天），以及保存在浏览器中的语言偏好。没有分析、没有跟踪器、没有第三方：本网站不从其他域名加载任何内容。',
    'privacy.p4': '在哪里、由谁：服务器位于西班牙，由 José Luis Olivares 运营（security@x39matrix.org）。比特币记录的是一个密码学承诺，绝不是文档本身。协议的公开证明还包括其标题、双方的假名标识符、日期，以及（如果协议包含付款）以 BTC 计的金额和收款地址，但不包括文档或聊天内容。已确认的锚定可以独立验证。记录在比特币中的承诺无法从链上移除。关于你的数据的任何问题：security@x39matrix.org。',
    'ver.bcheck.files': '证据包文件',
    'ver.bcheck.integrity': '完整性 — proof.json 的 SHA-256',
    'ver.bcheck.consistency': '字段一致性',
    'ver.bcheck.chain': '聊天消息链',
    'ver.bcheck.msgsigs': '每条消息的 Ed25519 签名',
    'ver.bcheck.mldsa_cold': '主权 ML-DSA-87 联合签名（COLD）',
    'ver.bcheck.mldsa_warm': '历史 ML-DSA-87 签名（WARM）',
    'ver.bcheck.manifest': '文件清单（封印时冻结的 README）',
    'ver.bcheck.ots_present': '证据包内含比特币锚定文件（此处未验证）',
    'ver.tabBundle': 'Evidence Bundle (.zip)',
    'ver.bundleDrop': '拖入 Evidence Bundle x39-evidencia-<id>.zip',
    'ver.bundleNote': '在你的浏览器中 100% 本地验证：不会向任何服务器发送任何内容。',
    'ver.bundleErr': 'ZIP 无效或不完整',
    'ver.bverifying': '正在验证…',
    'ver.bverdict.valid': '证据有效',
    'ver.bverdict.consistent': '一致 — 浏览器内可核对的部分全部相符；此处不验证比特币锚定',
    'ver.bverdict.consistent_nocold': '一致但无联合签名 — 缺少主权联合签名，且此处同样不验证比特币锚定',
    'ver.bverdict.fail': '无效或已被篡改',
    'ver.botsNote': '比特币锚定：浏览器无法在没有节点的情况下验证。请下载 .ots 并运行：ots verify proof.json.ots',
    'ver.bdocTitle': '关联你的原始文件（可选）',
    'ver.bdocNote': '文件永远不会离开你的设备：只计算其 SHA-256。',
    'ver.bdocOk': '你的文件与锚定的 content_hash 一致',
    'ver.bdocBad': '你的文件与 content_hash 不一致',
    'comms.title': 'X-39 Comunicaciones',
    'comms.sub': '两部手机之间的加密通话、视频通话和消息。这是独立于 X-39 Evidencia 的另一款应用，出自同一项目。',
    'comms.howT': '工作原理',
    'comms.how1': '每次通话的密钥由两部手机通过 ML-KEM-1024（FIPS 203）协商，并用 ML-DSA-87（FIPS 204）签名。音频和视频用这把密钥进行端到端加密，服务器没有这把密钥。这尚未经过第三方审计。',
    'comms.how2': '流量可以经由一条可选的 WireGuard 隧道到达我们的服务器。无需电子邮箱账户，也无需电话号码：身份是一把在手机上生成、从不离开手机的密钥。每个联系人都会显示其密钥的指纹，可以当面或通过电话核对。',
    'comms.statusT': '状态：封闭测试版，仅限受邀',
    'comms.status1': '代码和公开下载将于 2026 年 11 月推出，同时发布威胁模型、部署指南和隐私页面。在此之前，应用以人工方式交给提出申请并与我们一起测试的人。',
    'comms.statusMail': '申请访问：',
    'comms.dlT': '发布之后',
    'comms.dl1': '这里将提供 APK、它的 SHA-256、签名证书指纹以及核对它们的命令，与 [[Evidencia 页面]]相同。',
    'comms.whyT': '为什么是两款应用',
    'comms.why1': '在 Evidencia 中封存或锚定时，日历服务器只会收到由指纹派生的 32 字节承诺。如果你选择向已配对手机发送胶囊，原文件会以端到端加密方式传输。Comunicaciones 在通话时需要麦克风、摄像头和保持打开的连接。',
    'comms.limitsT': '它不是什么',
    'comms.limits1': '开启隧道后，监视你网络的人看不到你在和谁通话，也看不到你说了什么：他们看到的是发往我们服务器的加密流量。但他们能看到你在使用 X-39，能从流量的节奏推断出正在通话，还能封锁隧道，就像一些国家已经对 WireGuard 所做的那样。服务器不知道内容，但知道两把密钥进行了通话、在什么时候、持续多久。如果你的手机已被入侵，这些都无法保护你。它不是匿名的。这是一个没有外部审计的测试版：它可能出错。',
    'comms.backEvidencia': '← 返回 X-39 Evidencia',
    'footer.comms': 'Comunicaciones（测试版）',
    'appe.title': 'X-39 Evidencia Android 版',
    'appe.sub': '照片、音频、视频或任何文件，在你的手机上封存。0.3.4 版，发布于 2026 年 10 月 12 日，支持七种语言。需要 Android 9 或更高版本。',
    'appe.whatT': '它做什么',
    'appe.what1': '你拍照、录制音频或视频，或者选择文件。内容会加密保存在手机上。封存或锚定时，日历服务器只会收到由指纹派生的 32 字节承诺。如果你选择向已配对手机发送胶囊，原文件会以端到端加密方式传输。',
    'appe.what2': '每一项都用 ML-DSA-87（FIPS 204）签名，所用的密钥在手机上生成。没有账户，也没有云端副本。',
    'appe.what3': '哈希值通过 OpenTimestamps 锚定在 Bitcoin 上。任何人都可以用公开工具验证这份回执，无需本应用，也无需信任我们。它证明的是存在性、完整性和日期；它不能替代公证人，也不能替代合格电子签名。',
    'appe.dlT': '下载',
    'appe.dl1': 'APK 从本网站下载，同时也发布在 GitHub 上，附带它的 SHA-256、签名证书指纹、合格时间戳和 OpenTimestamps 证明。安装前请核对指纹。',
    'appe.dlLink': '从 x39matrix.org 下载 x39-0.3.4-release.apk（6.3 MB）',
    'appe.dlLink2': 'GitHub 上的同一版本，附带验证文件',
    'appe.prevT': '上一版本',
    'appe.prev1': '0.3.3 版（2026 年 10 月 8 日）使用同一证书签名，锚定于区块 970517，将再保留一个版本。',
    'appe.prevLink': '下载 x39-0.3.3-release.apk',
    'appe.prevGh': 'GitHub 上的 0.3.3 版，附带验证文件',
    'appe.clocksT': '同一个 APK 上的两个时钟',
    'appe.clock1': '合格时间戳（RFC 3161，eIDAS），由 ANF AC 于 2026-10-12 15:12:15 UTC 签发，可用 openssl 对照 ANF 根证书验证；该根证书与 APK 一同发布。',
    'appe.clock2': 'Bitcoin 锚定：区块 971111 (2026-10-12 15:26:58 UTC)，已对照我们自己的节点核实。可用 OpenTimestamps 客户端和任意 Bitcoin 节点验证。',
    'appe.verifyT': '验证 APK',
    'appe.verify1': '把发布文件放在同一个文件夹中：',
    'appe.permsT': '权限（7 项）',
    'appe.perms1': 'INTERNET、ACCESS_NETWORK_STATE、CAMERA、RECORD_AUDIO、FOREGROUND_SERVICE、FOREGROUND_SERVICE_SPECIAL_USE 和 POST_NOTIFICATIONS。',
    'appe.perms2': '联网用于向 OpenTimestamps 日历服务器发送由指纹派生的 32 字节承诺并取回证明（可选择只经由 Tor，配合 Orbot），也用于加密聊天。如果你选择向已配对手机发送胶囊，原文件会以端到端加密方式传输。不含 Google，也不含 AndroidX：没有 Play Services，没有 Firebase。',
    'appe.srcT': '代码',
    'appe.src1': '验证器、网站和 API 都在 GitHub 上（x39-Evidencia，AGPL-3.0）。应用的代码将发布在它自己的代码仓库中；每个版本发布时都附带它的指纹和两个时间戳。',
    'appe.toComms': 'X-39 Comunicaciones（另一款应用）→',
    'appe.back': '← 返回 X-39 Evidencia',
    'footer.app': 'Android 应用',
    'landing.commsT': '姊妹应用：X-39 Comunicaciones',
    'landing.commsBody': '出自同一项目：两部手机之间的加密通话、视频通话和消息，采用抗量子的通话密钥。目前为受邀封闭测试；代码和公开下载将于 2026 年 11 月推出。',
    'landing.commsLink': '了解更多并申请访问 →',
    'landing.ctaDownload': '下载 Evidencia（Android）',
    'landing.ctaCreateBeta': '创建协议 · 封闭测试',
    'landing.proofsT': 'X-39 Evidencia 及其证明',
    'landing.proofsApk': 'Android APK，附 SHA-256、签名证书指纹和两个时钟（Bitcoin 与 ANF 合格时间戳）',
    'landing.proofsRepo': '源代码，AGPL-3.0 许可',
    'landing.proofsBundle': 'Evidence Bundle v1.1、其验证器，以及在我们自有 Bitcoin 节点上得到的 VALID 结果',
    'landing.proofsSevilla': '塞维利亚的 40 份文件，已封存且可验证',
    'landing.leavesT': '什么会离开你的手机',
    'landing.leaves': '锚定时，只有指纹离开手机（由指纹派生的 32 字节承诺），发送到 OpenTimestamps 日历服务器。如果你向已配对手机发送胶囊，原文件会以端到端加密方式传输，且仅在你主动发送时。',
    'landing.notProveT': '它不能证明什么',
    'landing.notProve': '它证明某个确切的文件在某个日期已经存在，且此后未被更改。它不能证明作者是谁，也不能证明内容属实。',
    'landing.commsLine': 'X-39 Comunicaciones 是一个独立的应用，目前为封闭测试，11 月公开；Evidencia 提供一个可选按钮来打开它，但没有它也能正常使用：不需要 VPN，只有在你拍照或录制时才使用摄像头和麦克风。',
  },
  ja: {
    'nav.verify': '検証',
    'nav.panel': 'ダッシュボード',
    'nav.login': 'ログイン',
    'common.loading': '読み込み中…',
    'common.verifyingIdentity': '本人確認中…',
    'common.backToPanel': 'ダッシュボードに戻る',
    'common.goToPanel': 'マイダッシュボードへ',
    'landing.tag': 'ビットコインにアンカー · 誰でも検証可能 · ネットワークに接続しない機器による ML-DSA-87 副署名',
    'landing.betaBanner': 'クローズドベータ。X-39 Agreements は統合中のため、合意の作成はまだ一般公開されていません。発行済みの証明は独立したツールで検証できます。公証人や適格電子署名の代わりにはなりません。',
    'ag.pqAuthFail': '相手方の暗号鍵が署名されていないか、署名が無効です。安全のため、解決するまでチャットはロックされます。',
    'landing.chipPq': 'ML-DSA-87 · FIPS-204',
    'landing.chipBtc': 'Bitcoin · OpenTimestamps',
    'landing.chipTrust': 'SHA-256 はブラウザ内で計算',
    'landing.chipCold': 'COLD 鍵 · エアギャップ Pi',
    'landing.chipNode': 'アンカー検証済み · 自前ノード',
    'landing.h1': '存在したことを証明する。誰も信頼せずに確かめられる。',
    'landing.h1b': 'すべての証明はビットコインにアンカーされ、私たちに依存せず独立したツールで検証できます。さらに、ネットワークに一度も接続しない機器で生成された ML-DSA-87（FIPS 204）副署名を持つことができ、X-39 が公開する鍵のフィンガープリントと照合して検証できます。',
    'landing.sub': '二人または二社が、ブラウザ内で暗号化されたチャットで合意し、双方が承諾すると、ビットコインのタイムスタンプ付き証明書が残ります。',
    'landing.ctaPrimary': '最初の合意を作成（ベータ）',
    'landing.ctaSecondary': '検証済みの証明を見る',
    'landing.ctaVerify': '証明を検証する',
    'landing.certTitle': '合意証明書',
    'landing.certHashLabel': 'コンテンツハッシュ（SHA-256）',
    'landing.certAnchorLabel': 'ビットコインアンカー',
    'landing.certMockBadge': 'ビットコインブロックで確認済み（例）',
    'landing.sealedStamp': '封印済',
    'landing.s1t': '合意を書くかアップロード',
    'landing.s1d': 'テキストまたはファイル。SHA-256 ハッシュはブラウザ内で計算されます。ファイルの場合はハッシュのみが送信され、ここにテキストを入力した場合は、合意と証拠を作成するためにテキストがサービスへ送信されます。',
    'landing.s2t': '合意して承諾',
    'landing.s2d': '両者間のブラウザ内で暗号化されたチャット。双方が承諾すると会話は凍結され、そのハッシュが証明に含まれます。',
    'landing.s3t': 'ビットコインに封印',
    'landing.s3d': 'アカウント不要・無料で、誰でも検証できる公開証明書。',
    'landing.forWhoTitle': '誰のために',
    'landing.forWho': 'ある文書が否定・押収・削除される前に確かに存在していたこと、そしてその内容を証明する必要のあるジャーナリスト、情報源、人権団体のために——圧力を受けたり停止させられたりし得るプラットフォームに依存せずに。フリーランサーとクライアント、取引を結ぶ中小企業、アイデアや特許を共有する前に日付を刻みたいすべての人にも。',
    'landing.priceTitle': '料金',
    'landing.priceBody': '無料、手数料なし。作成・承諾・封印・検証に料金はかかりません。コードは自由ソフトウェア（AGPL-3.0）です。',
    'landing.soon': '近日公開',
    'landing.honestyTitle': '検証可能な誠実さ',
    'landing.honestyBody': '資金の保管もトークンの販売も行いません。ファイルはアップロードされず、SHA-256 指紋のみが送信されます。サイトに入力したテキストはサービスへ送信されます。「確認済み」の状態は、実際のビットコインブロックの証明がある場合にのみ表示されます。',
    'landing.footer': 'X-39 Agreements — ビットコインにアンカーされた検証可能な合意のクローズドベータ。',
    'landing.certOpen': 'クリックしてこの証明書を検証',
    'landing.certRealBadgePending': '封印済 · ビットコイン確認待ち',
    'protect.title': 'あなたを守る仕組み',
    'protect.b1t': 'ビットコインにアンカー',
    'protect.b1d': '合意と凍結されたチャットは OpenTimestamps を介してビットコインのブロックにアンカーされます。証明はそのブロック以前にハッシュが存在したことを示し、私たちに依存せず検証できます。',
    'protect.b2t': 'オフライン ML-DSA-87 副署名',
    'protect.b2d': '証明には、ネットワークに一度も接続しない機器で生成された ML-DSA-87（FIPS 204）副署名を付けることができます。検証は、証拠に含まれる公開鍵だけでなく、X-39 が公開する COLD 鍵のフィンガープリントと照合して行われます。接続されたサーバーには運営者の署名鍵は存在しません。過去の WARM 署名は 2026 年 7 月に廃止されました。',
    'protect.b3t': '誰でも検証可能',
    'protect.b3d': '無料、手数料なし。.ots 証明をダウンロードし、独立したツールで検証してください。私たちを信頼する必要はありません。',
    'protect.b4t': '第二の時計：適格タイムスタンプ',
    'protect.b4d': 'ビットコインに加えて、X-39 は ANF AC が発行する RFC 3161 適格タイムスタンプを付与します。ANF AC は eIDAS に基づく適格トラストサービスプロバイダーで、そのタイムスタンプは EU 域内で日付の正確性と完全性の法的推定を受けます（eIDAS 第41条）。現在は公開 Evidence Bundle がこのタイムスタンプを備えており、bundle に同梱された ANF ルート証明書に対して openssl でオフライン検証できます。ベータ版の合意には、当面ビットコインのアンカーのみが付きます。',
    'protect.viewBlock': 'mempool.space でブロックを見る',
    'panel.kicker': 'ダッシュボード',
    'panel.title': 'マイ合意',
    'panel.new': '新しい合意',
    'panel.emptyTitle': 'まだ合意がありません。',
    'panel.emptyBody': '最初の合意を作成し、招待リンクを相手に共有しましょう。',
    'panel.emptyCta': '最初の合意を作成',
    'panel.waitingOther': '相手の参加待ち',
    'panel.badgePending': '承諾待ち',
    'panel.badgeConfirmed': '確認済み · ブロック #',
    'panel.badgeSealedPending': '封印済 · アンカー待ち',
    'crear.kicker': '新しい合意',
    'crear.title': '何を封印しますか？',
    'crear.titleLabel': '合意のタイトル',
    'crear.titlePh': '例：ウェブデザイン契約——納品と支払い',
    'crear.tabText': 'テキスト',
    'crear.tabFile': 'ファイル',
    'crear.contentLabel': '合意の内容',
    'crear.textPh': 'ここに合意の正確な条項を書いてください。\nテキストは記録され、その SHA-256 が封印された指紋になります。',
    'crear.dropTitle': 'ファイルをドラッグするかクリックして選択',
    'crear.dropNote': 'ファイルはアップロードされません：SHA-256 はブラウザ内でのみ計算されます。',
    'crear.hashLabel': 'SHA-256 指紋（あなたのデバイスで計算）',
    'crear.submit': '合意を作成して招待リンクを生成',
    'crear.submitting': '作成中…',
    'crear.afterNote': '合意を作成した後、一回限りのリンクを相手と共有します。',
    'crear.toastCreated': '合意が作成されました。招待リンクを共有してください。',
    'ag.badgePending': '承諾待ち',
    'ag.badgeConfirmedIn': 'ビットコインブロックで確認済み #',
    'ag.badgeSealedPendingBtc': '封印済 · ビットコイン確認待ち',
    'ag.kicker': '合意',
    'ag.contentLabel': '合意の内容',
    'ag.fileLabel': '封印されたファイル',
    'ag.fileNote': '（ファイルはアップロードされていません。指紋のみ）',
    'ag.hashLabel': 'コンテンツの SHA-256 指紋',
    'ag.parties': '当事者',
    'ag.partyA': '当事者 A',
    'ag.partyB': '当事者 B',
    'ag.signed': '承諾済み',
    'ag.notSigned': '未承諾',
    'ag.pendingJoin': '参加待ち',
    'ag.inviteLabel': '招待リンク（一回限り）',
    'ag.copyLink': 'リンクをコピー',
    'ag.copied': 'リンクをコピーしました',
    'ag.inviteNote': 'このリンクで最初に入った人が当事者 B として固定されます。他の誰も使用できません。',
    'ag.signBtn': 'この合意を承諾する',
    'ag.signing': '承諾を記録し、証拠を準備しています…',
    'ag.signNote': '双方が承諾すると、チャットは凍結され、証明は OpenTimestamps を介してビットコインにアンカーされます。',
    'ag.alreadySigned': '承諾済みです。封印とアンカーのため、相手方を待っています。',
    'ag.sealedProof': '封印された証明',
    'ag.sealedAt': '封印日時（UTC）',
    'ag.proofHash': '証明ハッシュ',
    'ag.chatHash': '凍結チャットのハッシュ',
    'ag.pqSig': '運営者の過去の ML-DSA-87 署名（WARM・廃止済み）',
    'ag.checkAnchor': 'ビットコインアンカーを確認',
    'ag.certPdf': 'PDF 証明書',
    'ag.otsProof': '.ots 証明',
    'ag.publicCert': '公開証明書',
    'ag.chatHead': 'ブラウザ内暗号化チャット · 当事者のみ',
    'ag.chatFrozenSuffix': ' · 凍結済み',
    'ag.chatEmpty': 'メッセージはありません。ここで条件を交渉してください：スレッドは合意と共に封印されます。',
    'ag.you': 'あなた',
    'ag.chatFrozenNote': 'スレッドは封印されました。そのハッシュは証明の一部です。',
    'ag.chatPh': 'メッセージを入力…',
    'ag.e2eWaiting': '暗号化：相手方の公開鍵を待っています…',
    'ag.chainMismatch': '署名をブロックしました：サーバーのメッセージチェーンがローカルの記録と一致しません（省略または並べ替えの可能性）。再読み込みしてチャットを確認してください。',
    'ag.chainLabel': 'チャットの完全性',
    'ag.chainOk': 'チェーンをローカルで検証済み',
    'ag.chainFail': 'チェーンがローカルの記録と一致しません',
    'ag.msgLocked': '暗号化済み — この端末に鍵がありません',
    'pay.section': '支払い（任意）',
    'pay.toggle': '合意に支払いを追加',
    'pay.amount': '金額（BTC）',
    'pay.address': 'ビットコイン受取アドレス',
    'pay.who': '誰が支払う？',
    'pay.bPaysA': '相手が私に支払う',
    'pay.aPaysB': '私が相手に支払う',
    'pay.terms': '支払い条件',
    'pay.payTo': '支払先',
    'pay.amountLabel': '金額',
    'pay.payerLabel': '支払者',
    'pay.scan': 'スキャンまたはコピーして支払う。ピアツーピア、非カストディアル。',
    'pay.copyAddr': 'アドレスをコピー',
    'pay.openWallet': 'ウォレットで開く',
    'pay.checkStatus': '支払い状況を確認',
    'pay.received': '受領済み',
    'pay.expected': '予定額',
    'pay.paid': '支払い済み',
    'pay.unpaid': '保留中',
    'pay.noncustodial': 'アプリは資金に一切触れません。支払いはビットコインネットワーク上で当事者間で直接行われます。',
    'pay.invalidAddr': '無効なビットコインアドレス',
    'verify.title': '自分で検証する（私たちを信頼せずに）',
    'verify.intro': 'これらの検証は X-39 に依存しません。誰でも自由ソフトウェアで再現できます。',
    'verify.checking': 'コンテンツをアンカーされたハッシュと照合中…',
    'verify.hashOk': 'コンテンツはビットコインにアンカーされたハッシュと一致します',
    'verify.hashFail': 'コンテンツはアンカーされたハッシュと一致しません',
    'verify.warm': '過去の ML-DSA-87 署名（WARM · 運営者、2026 年に廃止）',
    'verify.cold': 'オフラインで生成された ML-DSA-87 副署名（COLD）',
    'verify.runbook': '鍵セレモニー・ランブック（PDF）',
    'verify.btc': 'ビットコインのタイムスタンプアンカー（OpenTimestamps）',
    'verify.pubkey': '公開鍵',
    'verify.signature': '署名',
    'verify.fp': 'フィンガープリント',
    'verify.runPy': 'ML-DSA-87 署名を検証（Python）',
    'verify.runOts': 'ビットコインアンカーを検証（ots）',
    'verify.dlProof': '証明をダウンロード（.json）',
    'verify.dlOts': '.ots をダウンロード',
    'verify.noCold': 'この証明には COLD 副署名は含まれていません。',
    'verify.sovereign': '主権検証を実施：デモ合意のアンカーは 2026-07-31 に自前のプルーンド・ビットコインノードで検証済み（ブロック #957242）— エクスプローラーなし、カレンダーなし、第三者なし。',
    'verify.sovereignProof': 'スクリーンショットを見る →',
    'verify.copy': 'コピー',
    'verify.copied': 'コピーしました',
    'ag.toastSealed': '合意が封印されました。証明は OpenTimestamps に送信されました。',
    'ag.toastSigned': '承諾を記録しました。相手方を待っています。',
    'ag.toastStillPending': 'まだブロックで確認されていません。OpenTimestamps は通常数時間かかります。',
    'join.kicker': '招待',
    'join.title': '合意に招待されました',
    'join.body': 'あなたの鍵でログインすると、当事者 B として結び付けられます。このリンクは一回限り：あなたの身元に固定されます。',
    'join.cta': '自分の鍵でログインして参加',
    'join.progress': '合意に結び付けています…',
    'ver.kicker': '公開検証 · アカウント不要',
    'ver.title': '証明を検証する',
    'ver.sub': 'ファイル、テキスト、またはハッシュが封印済みの合意に対応するか確認します。Web での検証では、SHA-256 ハッシュはブラウザ内で計算されます。検証リクエストで送信されるのはそのハッシュだけで、元のファイルやテキストは送信されません。',
    'ver.tabFile': 'ファイル',
    'ver.tabText': 'テキスト',
    'ver.tabHash': 'ハッシュ',
    'ver.tabBundle': 'Evidence Bundle (.zip)',
    'ver.bundleDrop': 'x39-evidencia-<id>.zip をドラッグ',
    'ver.bundleNote': 'ブラウザ内で100%ローカル検証：どのサーバーにも送信されません。',
    'ver.bundleErr': 'ZIP が無効または不完全です',
    'ver.bverifying': '検証中…',
    'ver.bcheck.files': 'パッケージのファイル',
    'ver.bcheck.integrity': '完全性 — proof.json の SHA-256',
    'ver.bcheck.consistency': 'フィールドの整合性',
    'ver.bcheck.chain': 'チャットメッセージチェーン',
    'ver.bcheck.msgsigs': 'メッセージごとの Ed25519 署名',
    'ver.bcheck.mldsa_cold': 'ソブリン ML-DSA-87 連署（COLD）',
    'ver.bcheck.mldsa_warm': '過去の ML-DSA-87 署名（WARM）',
    'ver.bcheck.manifest': 'ファイルマニフェスト（封印時に固定された README）',
    'ver.bcheck.ots_present': 'ビットコインのアンカーがバンドルに存在（ここでは未検証）',
    'ver.bverdict.valid': '証拠は有効',
    'ver.bverdict.consistent': '整合性あり — ブラウザで確認できる範囲はすべて一致。ビットコインのアンカーはここでは未検証',
    'ver.bverdict.consistent_nocold': '整合性あり・連署なし — ソブリン連署が欠落し、ビットコインのアンカーもここでは未検証',
    'ver.bverdict.fail': '無効または改ざんの疑い',
    'ver.botsNote': 'ビットコインアンカー：ノードなしではブラウザで検証できません。.ots をダウンロードして実行：ots verify proof.json.ots',
    'ver.bdocTitle': '元の文書をリンク（任意）',
    'ver.bdocNote': '文書はデバイスから出ません：SHA-256 のみをローカルで計算します。',
    'ver.bdocOk': 'あなたの文書はアンカーされた content_hash と一致します',
    'ver.bdocBad': 'あなたの文書は content_hash と一致しません',
    'ver.dropTitle': '検証するファイルをドラッグ',
    'ver.dropNote': 'SHA-256 をローカルで計算し、封印済みの合意から検索します。',
    'ver.textPh': '合意の正確なテキストをここに貼り付けてください（バイト単位）。',
    'ver.verifyTextBtn': 'SHA-256 を計算して検証',
    'ver.verifyHashBtn': 'ハッシュを検証',
    'ver.verifying': '検証中…',
    'ver.hashPh': '64 文字の 16 進 sha-256 ハッシュ（コンテンツまたは証明）',
    'ver.invalidHash': '有効な SHA-256（64 文字の 16 進数）を入力してください。',
    'ver.foundTitle': '証明が見つかりました',
    'ver.matchedBy': '一致：',
    'ver.matchedContent': 'コンテンツハッシュ',
    'ver.matchedProof': '証明ハッシュ',
    'ver.fTitle': 'タイトル',
    'ver.anchor': 'ビットコインアンカー',
    'ver.pendingConf': '確認待ち',
    'ver.pq': 'ポスト量子署名（ML-DSA-87）',
    'ver.pqValid': '有効 — サーバー側で検証済み',
    'ver.pqInvalid': '無効',
    'ver.cold': 'ソブリン COLD 署名',
    'ver.contentHash': 'コンテンツハッシュ',
    'ver.notFoundTitle': '一致なし',
    'ver.notFoundBody': 'このハッシュに対応する封印済みの合意はありません。1 バイト違うだけで、ハッシュは完全に異なります。',
    'cert.sub': 'ビットコインにアンカーされた内容と日付の証明',
    'cert.pendingOts': '確認待ち（OpenTimestamps）',
    'cert.downloadPdf': 'PDF をダウンロード',
    'cert.payloadJson': '.json ペイロード',
    'cert.bundle': 'Evidence Bundle (.zip)',
    'cert.share': '共有',
    'cert.shareCopied': '公開リンクをコピーしました',
    'cert.indepNote': '独立検証：.json ペイロードと .ots 証明をダウンロードし、任意の OpenTimestamps クライアントで検証してください。私たちを信頼する必要はありません。',
    'cert.legalScope': '誠実な法的範囲：この証明は、存在・完全性・日付の暗号学的証拠です。ビットコインのタイムスタンプと、含まれる場合は、X-39 が運営者としてネットワークから隔離された端末で作成した耐量子 ML-DSA-87（NIST FIPS 204）の副署名から成ります。公証人の代わりにはなりません。',
    'cert.goVerify': '検証へ',
    'footer.github': 'GitHub · コードと証拠',
    'landing.codeLink': 'GitHub でコードを見る →',
    'footer.contact': '連絡先',
    'footer.privacy': 'プライバシー',
    'cert.notFound': '証明が見つかりません',
    'meta.title': 'X-39 Evidencia — ビットコインにアンカーされた存在証明',
    'meta.desc': 'ファイルの指紋と日付を OpenTimestamps でビットコインにアンカー。検証ツールはオープンソース（AGPL-3.0）で、私たちに頼らず誰でも検証できます。',
    'privacy.title': 'プライバシーとデータ',
    'privacy.p1': '保存するもの：封印する内容の SHA-256 ハッシュ、合意のタイトル、当事者の公開鍵、封印日、OpenTimestamps の証明、そして合意に支払いが含まれる場合は BTC 建ての金額と受取アドレス。サイト上で合意の本文を入力した場合、その本文は合意を有効にするために保存されます。封印または検証のためにファイルを選んだ場合、その SHA-256 ハッシュはローカルで計算されます。サービスに送信されるのはハッシュで、ファイルはアップロードされません。',
    'privacy.p2': '保存しないもの：メールアドレス、パスワード、氏名。あなたの身元はブラウザに保存された暗号鍵です。当事者間のチャットはブラウザで暗号化され、サーバーは暗号文のみを保存します。',
    'privacy.p3': 'Cookie：鍵でログインした後のセッション Cookie（httponly、7 日間）と、ブラウザ内の言語設定のみ。アナリティクスもトラッカーも第三者もありません。このサイトは他のドメインから何も読み込みません。',
    'privacy.p4': '場所と運営者：サーバーはスペインにあり、José Luis Olivares（security@x39matrix.org）が運営しています。ビットコインに記録されるのは暗号学的コミットメントであり、文書そのものが記録されることはありません。合意の公開証明には、そのタイトル、当事者の仮名識別子、日付、そして合意に支払いが含まれる場合は BTC 建ての金額と受取アドレスも含まれますが、文書やチャットの内容は含まれません。確定したアンカーは独立して検証できます。ビットコインに記録されたコミットメントはチェーンから削除できません。データに関するご質問は security@x39matrix.org まで。',
    'landing.ctaVerifySelf': '自分で検証する →',
    'comms.title': 'X-39 Comunicaciones',
    'comms.sub': '2台のスマートフォン間で暗号化された通話、ビデオ通話、メッセージ。X-39 Evidencia とは別のアプリで、同じプロジェクトによるものです。',
    'comms.howT': '仕組み',
    'comms.how1': '各通話の鍵は 2台のスマートフォンの間で ML-KEM-1024（FIPS 203）により合意され、ML-DSA-87（FIPS 204）で署名されます。音声と映像はその鍵でエンドツーエンド暗号化され、サーバーはその鍵を持ちません。これはまだ第三者による監査を受けていません。',
    'comms.how2': '通信は、任意で有効にできる WireGuard トンネルを通って当方のサーバーまで送ることができます。メールアカウントも電話番号も不要です。身元はスマートフォン上で作成され、端末の外に出ない鍵です。各連絡先には鍵のフィンガープリントが表示され、対面または電話で照合できます。',
    'comms.statusT': '状態：招待制のクローズドベータ',
    'comms.status1': 'コードと一般向けダウンロードは 2026年11月に、脅威モデル、導入ガイド、プライバシーページとともに公開されます。それまでは、希望して私たちと一緒にテストしてくれる人に、アプリを個別に手渡ししています。',
    'comms.statusMail': 'アクセスの申請：',
    'comms.dlT': '公開後',
    'comms.dl1': 'ここに APK、その SHA-256、署名証明書のフィンガープリント、それらを確認するためのコマンドを掲載します。[[Evidencia のページ]]と同様です。',
    'comms.whyT': 'なぜ 2つのアプリなのか',
    'comms.why1': 'Evidencia で封印またはアンカーする際、カレンダーに送信されるのは指紋から導出した 32 バイトのコミットメントだけです。ペアリング済みのスマートフォンにカプセルを送る場合は、選択したときに限り、原本がエンドツーエンド暗号化されて送信されます。',
    'comms.limitsT': 'できないこと',
    'comms.limits1': 'トンネルを有効にすると、あなたのネットワークを監視している者には、誰と話しているかも何を話しているかも見えません。見えるのは当方のサーバーへの暗号化された通信です。しかし、あなたが X-39 を使っていることは見え、通信のリズムから通話中であることを推測でき、すでにいくつかの国が WireGuard に対して行っているように、トンネルを遮断することもできます。サーバーは内容を知りませんが、2つの鍵が通信したこと、その時刻と長さは知っています。スマートフォンが侵害されていれば、これらはどれもあなたを守りません。匿名ではありません。外部監査を受けていないベータ版です。不具合が起きることがあります。',
    'comms.backEvidencia': '← X-39 Evidencia に戻る',
    'footer.comms': 'Comunicaciones（ベータ）',
    'appe.title': 'X-39 Evidencia Android 版',
    'appe.sub': '写真、音声、動画、あらゆるファイルを、スマートフォン上で封印します。バージョン 0.3.4、2026年10月12日公開、7言語対応。Android 9 以降。',
    'appe.whatT': 'できること',
    'appe.what1': '写真や音声、動画を撮るか、ファイルを選びます。端末内に暗号化して保存されます。封印またはアンカー時にカレンダーへ送信されるのは指紋から導出した 32 バイトのコミットメントだけです。ペアリング済み端末にカプセルを送る場合は、選択したときに限り、原本がエンドツーエンド暗号化されて送信されます。',
    'appe.what2': '各項目は、スマートフォン上で作成された鍵を使って ML-DSA-87（FIPS 204）で署名されます。アカウントもクラウド上のコピーもありません。',
    'appe.what3': 'ハッシュは OpenTimestamps を通じて Bitcoin にアンカーされます。誰でも、このアプリを使わず、私たちを信頼することもなく、公開ツールで受領証を検証できます。これは存在・完全性・日付の証明であり、公証人や適格電子署名に代わるものではありません。',
    'appe.dlT': 'ダウンロード',
    'appe.dl1': 'APK はこのサイトからダウンロードでき、GitHub でも、SHA-256、署名証明書のフィンガープリント、適格タイムスタンプ、OpenTimestamps の証明とともに公開されています。インストールする前にフィンガープリントを確認してください。',
    'appe.dlLink': 'x39-0.3.4-release.apk（6.3 MB）を x39matrix.org からダウンロード',
    'appe.dlLink2': 'GitHub 上の同じバージョン（検証用ファイル付き）',
    'appe.prevT': '以前のバージョン',
    'appe.prev1': '0.3.3（2026年10月8日）は同じ証明書で署名され、ブロック 970517 にアンカーされています。次のリリースまで引き続き提供します。',
    'appe.prevLink': 'x39-0.3.3-release.apk をダウンロード',
    'appe.prevGh': 'GitHub 上の 0.3.3（検証用ファイル付き）',
    'appe.clocksT': '同じ APK に 2つの時計',
    'appe.clock1': '適格タイムスタンプ（RFC 3161、eIDAS）。ANF AC が 2026-10-12 15:12:15 UTC に発行。APK と一緒に公開している ANF のルート証明書を使い、openssl で検証できます。',
    'appe.clock2': 'Bitcoin アンカー：ブロック 971111 (2026-10-12 15:26:58 UTC)。私たち自身のノードで確認済みです。OpenTimestamps クライアントと任意の Bitcoin ノードで検証できます。',
    'appe.verifyT': 'APK を検証する',
    'appe.verify1': 'リリースのファイルを同じフォルダーに置いて：',
    'appe.permsT': '権限（7）',
    'appe.perms1': 'INTERNET、ACCESS_NETWORK_STATE、CAMERA、RECORD_AUDIO、FOREGROUND_SERVICE、FOREGROUND_SERVICE_SPECIAL_USE、POST_NOTIFICATIONS。',
    'appe.perms2': 'インターネットは、指紋から導出した 32 バイトのコミットメントを OpenTimestamps のカレンダーへ送り証明を受け取るため（任意で Orbot による Tor のみの接続が可能）、また暗号化チャットに使います。ペアリング済み端末にカプセルを送る場合は、選択したときに限り原本がエンドツーエンド暗号化されて送信されます。',
    'appe.srcT': 'コード',
    'appe.src1': '検証ツール、ウェブサイト、API は GitHub にあります（x39-Evidencia、AGPL-3.0）。アプリのコードは専用のリポジトリで公開する予定です。各バージョンは、フィンガープリントと 2つのタイムスタンプを付けて公開されます。',
    'appe.toComms': 'X-39 Comunicaciones（別アプリ）→',
    'appe.back': '← X-39 Evidencia に戻る',
    'footer.app': 'Android アプリ',
    'landing.commsT': '姉妹アプリ：X-39 Comunicaciones',
    'landing.commsBody': '同じプロジェクトによるもの：2台のスマートフォン間の暗号化された通話、ビデオ通話、メッセージ。通話鍵は耐量子です。現在は招待制のクローズドベータ。コードと一般向けダウンロードは 2026年11月に公開されます。',
    'landing.commsLink': '詳しく見てアクセスを申請 →',
    'landing.ctaDownload': 'Evidencia をダウンロード（Android）',
    'landing.ctaCreateBeta': '合意を作成 · クローズドベータ',
    'landing.proofsT': 'X-39 Evidencia とその証明',
    'landing.proofsApk': 'Android 用 APK。SHA-256、署名証明書のフィンガープリント、2 つの時計（Bitcoin と ANF の適格タイムスタンプ）付き',
    'landing.proofsRepo': 'ソースコード（AGPL-3.0 ライセンス）',
    'landing.proofsBundle': 'Evidence Bundle v1.1、その検証ツール、自前の Bitcoin ノードで得た VALID の結果',
    'landing.proofsSevilla': 'セビリアの 40 件の文書（封印済み・検証可能）',
    'landing.leavesT': 'スマートフォンから送信されるもの',
    'landing.leaves': 'アンカー時に送信されるのは指紋だけです（指紋から導出した 32 バイトのコミットメント）。送信先は OpenTimestamps のカレンダーです。ペアリング済み端末にカプセルを送る場合は、あなたが送ったときに限り、原本がエンドツーエンド暗号化されて送信されます。',
    'landing.notProveT': '証明しないこと',
    'landing.notProve': '特定のファイルがある日付に存在し、それ以降変更されていないことを証明します。誰が書いたのか、内容が真実かどうかは証明しません。',
    'landing.commsLine': 'X-39 Comunicaciones は別のアプリで、現在クローズドベータ、11 月に公開予定です。Evidencia には開くための任意のボタンがありますが、なくても動作します。VPN は不要で、カメラとマイクは写真撮影や録音・録画のときだけ使います。',
  },
  ar: {
    'nav.verify': 'تحقّق',
    'nav.panel': 'لوحتي',
    'nav.login': 'الدخول',
    'common.loading': 'جارٍ التحميل…',
    'common.verifyingIdentity': 'جارٍ التحقق من الهوية…',
    'common.backToPanel': 'العودة إلى اللوحة',
    'common.goToPanel': 'الذهاب إلى لوحتي',

    'landing.tag': 'مثبَّت على بيتكوين · قابل للتحقق من أي شخص · توقيع مشترك ML-DSA-87 من جهاز غير متصل بالشبكة',
    'landing.betaBanner': 'نسخة تجريبية مغلقة. X-39 Agreements قيد التكامل: إنشاء الاتفاقيات غير متاح للعموم بعد. يمكن التحقق من الإثباتات الصادرة بأدوات مستقلة. لا يحل محل كاتب العدل ولا التوقيع الإلكتروني المؤهل.',
    'ag.pqAuthFail': 'مفتاح التشفير الخاص بالطرف الآخر غير موقَّع أو توقيعه غير صالح. للأمان، تبقى المحادثة مقفلة حتى يُحل ذلك.',
    'landing.h1': 'أثبِت أنه كان موجودًا. وتحقّق من ذلك دون أن تثق بأحد.',
    'landing.h1b': 'كل إثبات يُثبَّت على بيتكوين ويمكن التحقق منه بأدوات مستقلة دون الاعتماد علينا. وقد يحمل أيضًا توقيعًا مشتركًا ML-DSA-87 (FIPS 204) مُنشأً على جهاز لا يتصل بالشبكة أبدًا، ويمكن التحقق منه مقابل بصمة مفتاح X-39 المنشورة.',
    'landing.chipPq': 'ML-DSA-87 · FIPS-204',
    'landing.chipBtc': 'بيتكوين · OpenTimestamps',
    'landing.chipTrust': 'SHA-256 في متصفحك',
    'landing.chipCold': 'مفتاح COLD · جهاز معزول عن الشبكة',
    'landing.chipNode': 'مرساة مُتحقَّق منها · عقدة خاصة بنا',
    'landing.ctaVerifySelf': 'تحقّق بنفسك ←',
    'landing.sub': 'يبرم شخصان أو شركتان اتفاقية عبر محادثة مشفّرة في المتصفح، ويقبلها الطرفان، فتبقى شهادة بختم زمني على بيتكوين.',
    'landing.ctaPrimary': 'أنشئ اتفاقيتي الأولى (نسخة تجريبية)',
    'landing.ctaSecondary': 'عرض إثبات تم التحقق منه',
    'landing.ctaVerify': 'التحقق من إثبات',
    'landing.certTitle': 'شهادة اتفاقية',
    'landing.certHashLabel': 'بصمة المحتوى (SHA-256)',
    'landing.certAnchorLabel': 'مرساة بيتكوين',
    'landing.certMockBadge': 'مؤكَّد في كتلة بيتكوين (مثال)',
    'landing.sealedStamp': 'مختوم',
    'landing.s1t': 'اكتب الاتفاقية أو ارفعها',
    'landing.s1d': 'نص أو ملف. تُحسب بصمة SHA-256 في متصفحك. إذا كان ملفًا، لا يُرسل سوى البصمة؛ وإذا كتبت النص هنا، يُرسل النص إلى الخدمة لإتاحة الاتفاقية والأدلة.',
    'landing.s2t': 'اتفقا واقبلا',
    'landing.s2d': 'محادثة مشفّرة في المتصفح بين الطرفين. عندما يقبل الطرفان، تُجمَّد المحادثة وتدخل بصمتها في الإثبات.',
    'landing.s3t': 'تُختم في بيتكوين',
    'landing.s3d': 'شهادة عامة يمكن لأي شخص التحقق منها، دون حساب ودون تكلفة.',
    'landing.forWhoTitle': 'لمن هذا',
    'landing.forWho': 'الصحفيون والمصادر ومنظمات حقوق الإنسان الذين يحتاجون إلى إثبات أن وثيقةً ما كانت موجودة — وما الذي قالته — قبل أن ينكرها أحد أو يصادرها أو يحذفها، دون الاعتماد على منصة يمكن الضغط عليها أو إغلاقها. وكذلك المستقلون وعملاؤهم، والشركات الصغيرة التي تعقد الصفقات، وكل من يريد توثيق فكرة أو براءة اختراع بتاريخ ثابت قبل مشاركتها.',
    'landing.priceTitle': 'السعر',
    'landing.priceBody': 'مجاني، بلا عمولات. لا نتقاضى شيئًا مقابل الإنشاء أو القبول أو الختم أو التحقق. الشيفرة حرة (AGPL-3.0).',
    'landing.soon': 'قريبًا',
    'protect.title': 'كيف يحميك',
    'protect.b1t': 'مُرسَّخ في بيتكوين',
    'protect.b1d': 'تُثبَّت الاتفاقية والمحادثة المجمَّدة على كتلة بيتكوين عبر OpenTimestamps. يُثبت الدليل أن البصمة كانت موجودة قبل تلك الكتلة، ويمكنك التحقق منها دوننا.',
    'protect.b2t': 'توقيع مشترك ML-DSA-87 دون اتصال',
    'protect.b2d': 'قد تحمل الإثباتات توقيعًا مشتركًا ML-DSA-87 (FIPS 204) مُنشأً على جهاز لا يتصل بالشبكة أبدًا. يتم التحقق منه مقابل بصمة مفتاح COLD المنشورة لـ X-39، وليس فقط مقابل المفتاح المضمَّن في الدليل. لا يوجد أي مفتاح توقيع للمشغِّل على أي خادم متصل: فقد أُوقف توقيع WARM التاريخي في يوليو 2026.',
    'protect.b3t': 'يتحقق منه أي شخص',
    'protect.b3d': 'مجاني وبلا عمولات. نزّل إثبات .ots وتحقق منه بأدوات مستقلة: لا حاجة للثقة بنا.',
    'protect.b4t': 'الساعة الثانية: ختم زمني مؤهَّل',
    'protect.b4d': 'إلى جانب بيتكوين، يضيف X-39 ختمًا زمنيًا مؤهَّلًا وفق RFC 3161 صادرًا عن ANF AC، وهو مقدِّم خدمات ثقة مؤهَّل بموجب لائحة eIDAS، ويتمتع ختمه بقرينة قانونية على دقة التاريخ وسلامة المحتوى في عموم الاتحاد الأوروبي (المادة 41). تحمله اليوم حزمة الأدلة العامة Evidence Bundle، ويُتحقَّق منه دون اتصال عبر openssl مقابل شهادة جذر ANF المضمَّنة في الحزمة نفسها. أما اتفاقيات النسخة التجريبية فتحمل حاليًا مرساة بيتكوين فقط.',
    'protect.viewBlock': 'عرض الكتلة على mempool.space',
    'landing.certOpen': 'اضغط للتحقق من هذه الشهادة',
    'landing.certRealBadgePending': 'مختوم · بانتظار التأكيد في بيتكوين',
    'landing.honestyTitle': 'صدق قابل للتحقق',
    'landing.honestyBody': 'لا نحتفظ بأموال ولا نبيع رموزًا. لا تُرفع الملفات: تُرسل بصمتها SHA-256 فقط. النص المكتوب في الموقع يُرسل إلى الخدمة. لا تظهر حالة «مؤكَّد» إلا عند وجود إثبات حقيقي لكتلة بيتكوين.',
    'landing.footer': 'X-39 Agreements — نسخة تجريبية مغلقة لاتفاقيات قابلة للتحقق، مثبَّتة على بيتكوين.',

    'panel.kicker': 'اللوحة',
    'panel.title': 'اتفاقياتي',
    'panel.new': 'اتفاقية جديدة',
    'panel.emptyTitle': 'ليست لديك اتفاقيات بعد.',
    'panel.emptyBody': 'أنشئ الأولى وشارك رابط الدعوة مع الطرف الآخر.',
    'panel.emptyCta': 'إنشاء أول اتفاقية',
    'panel.waitingOther': 'بانتظار الطرف الآخر',
    'panel.badgePending': 'بانتظار القبول',
    'panel.badgeConfirmed': 'مؤكَّد · كتلة #',
    'panel.badgeSealedPending': 'مختوم · المرساة معلّقة',

    'crear.kicker': 'اتفاقية جديدة',
    'crear.title': 'ماذا تريدان أن تختما؟',
    'crear.titleLabel': 'عنوان الاتفاقية',
    'crear.titlePh': 'مثال: عقد تصميم موقع — التسليم والدفع',
    'crear.tabText': 'نص',
    'crear.tabFile': 'ملف',
    'crear.contentLabel': 'محتوى الاتفاقية',
    'crear.textPh': 'اكتب هنا بنود الاتفاقية بدقة.\nسيُسجَّل النص وستكون بصمته SHA-256 هي البصمة المختومة.',
    'crear.dropTitle': 'اسحب ملفًا أو انقر لاختياره',
    'crear.dropNote': 'الملف لا يُرفع: تُحسب بصمته SHA-256 في متصفحك فقط.',
    'crear.hashLabel': 'بصمة SHA-256 (محسوبة على جهازك)',
    'crear.submit': 'إنشاء الاتفاقية وتوليد رابط الدعوة',
    'crear.submitting': 'جارٍ الإنشاء…',
    'crear.afterNote': 'بعد إنشاء الاتفاقية ستشارك رابطًا يُستخدم مرة واحدة مع الطرف الآخر.',
    'crear.toastCreated': 'أُنشئت الاتفاقية. شارك رابط الدعوة.',

    'ag.badgePending': 'بانتظار القبول',
    'ag.badgeConfirmedIn': 'مؤكَّد في كتلة بيتكوين #',
    'ag.badgeSealedPendingBtc': 'مختوم · بانتظار التأكيد في بيتكوين',
    'ag.kicker': 'اتفاقية',
    'ag.contentLabel': 'محتوى الاتفاقية',
    'ag.fileLabel': 'الملف المختوم',
    'ag.fileNote': '(الملف لم يُرفع أبدًا؛ بصمته فقط)',
    'ag.hashLabel': 'بصمة SHA-256 للمحتوى',
    'ag.parties': 'الأطراف',
    'ag.partyA': 'الطرف أ',
    'ag.partyB': 'الطرف ب',
    'ag.signed': 'قَبِل',
    'ag.notSigned': 'لم يقبل',
    'ag.pendingJoin': 'بانتظار الانضمام',
    'ag.inviteLabel': 'رابط الدعوة (استخدام واحد)',
    'ag.copyLink': 'نسخ الرابط',
    'ag.copied': 'تم نسخ الرابط',
    'ag.inviteNote': 'أول من يدخل بهذا الرابط سيُثبَّت كالطرف ب. لن يستطيع أحد غيره استخدامه.',
    'ag.signBtn': 'قبول هذه الاتفاقية',
    'ag.signing': 'جارٍ تسجيل القبول وإعداد الأدلة…',
    'ag.signNote': 'عندما يقبل الطرفان، تُجمَّد المحادثة ويُثبَّت الإثبات على بيتكوين عبر OpenTimestamps.',
    'ag.alreadySigned': 'لقد قبلت. بانتظار الطرف الآخر للختم والتثبيت.',
    'ag.sealedProof': 'إثبات مختوم',
    'ag.sealedAt': 'الختم (UTC)',
    'ag.proofHash': 'بصمة الإثبات',
    'ag.chatHash': 'بصمة المحادثة المجمّدة',
    'ag.pqSig': 'توقيع ML-DSA-87 التاريخي للمشغِّل (WARM، مُوقَف)',
    'ag.checkAnchor': 'فحص مرساة بيتكوين',
    'ag.certPdf': 'شهادة PDF',
    'ag.otsProof': 'إثبات .ots',
    'ag.publicCert': 'الشهادة العامة',
    'ag.chatHead': 'محادثة مشفّرة في المتصفح · للطرفين فقط',
    'ag.chatFrozenSuffix': ' · مجمّدة',
    'ag.chatEmpty': 'لا رسائل. تفاوضا على البنود هنا: سيُختم هذا الخيط مع الاتفاقية.',
    'ag.you': 'أنت',
    'ag.chatFrozenNote': 'خيط مختوم. بصمته جزء من الإثبات.',
    'ag.chatPh': 'اكتب رسالة…',
    'ag.e2eWaiting': 'التشفير: بانتظار المفتاح العام للطرف الآخر…',
    'ag.chainMismatch': 'التوقيع محظور: سلسلة رسائل الخادم لا تطابق نسختك المحلية (احتمال حذف أو إعادة ترتيب). أعد التحميل وراجع المحادثة.',
    'ag.chainLabel': 'سلامة المحادثة',
    'ag.chainOk': 'السلسلة مُتحقَّق منها محليًا',
    'ag.chainFail': 'السلسلة لا تطابق نسختك المحلية',
    'ag.msgLocked': 'مشفّر — لا مفتاح على هذا الجهاز',
    'pay.section': 'الدفع (اختياري)',
    'pay.toggle': 'إضافة دفعة إلى الاتفاقية',
    'pay.amount': 'المبلغ (BTC)',
    'pay.address': 'عنوان بيتكوين للاستلام',
    'pay.who': 'من يدفع؟',
    'pay.bPaysA': 'الطرف الآخر يدفع لي',
    'pay.aPaysB': 'أنا أدفع للطرف الآخر',
    'pay.terms': 'شروط الدفع',
    'pay.payTo': 'الدفع إلى',
    'pay.amountLabel': 'المبلغ',
    'pay.payerLabel': 'يدفع',
    'pay.scan': 'امسح أو انسخ للدفع. ندًّا لند، دون وصاية.',
    'pay.copyAddr': 'نسخ العنوان',
    'pay.openWallet': 'فتح في المحفظة',
    'pay.checkStatus': 'فحص حالة الدفع',
    'pay.received': 'المستلَم',
    'pay.expected': 'المتوقَّع',
    'pay.paid': 'مدفوع',
    'pay.unpaid': 'معلّق',
    'pay.noncustodial': 'التطبيق لا يلمس الأموال أبدًا. الدفع مباشر بين الطرفين عبر شبكة بيتكوين.',
    'pay.invalidAddr': 'عنوان بيتكوين غير صالح',
    'verify.title': 'تحقق بنفسك (دون الثقة بنا)',
    'verify.intro': 'هذه الفحوص لا تعتمد على X-39. يمكن لأي شخص إعادتها ببرمجيات حرة.',
    'verify.checking': 'جارٍ فحص المحتوى مقابل البصمة المُرسَّخة…',
    'verify.hashOk': 'المحتوى يطابق البصمة المُرسَّخة في بيتكوين',
    'verify.hashFail': 'المحتوى لا يطابق البصمة المُرسَّخة',
    'verify.warm': 'توقيع ML-DSA-87 التاريخي (WARM · المشغِّل، أُوقف في 2026)',
    'verify.cold': 'توقيع مشترك ML-DSA-87 مُنشأ دون اتصال (COLD)',
    'verify.runbook': 'دليل المراسم (PDF)',
    'verify.btc': 'المرساة الزمنية في بيتكوين (OpenTimestamps)',
    'verify.pubkey': 'المفتاح العام',
    'verify.signature': 'التوقيع',
    'verify.fp': 'البصمة',
    'verify.runPy': 'التحقق من توقيع ML-DSA-87 (Python)',
    'verify.runOts': 'التحقق من مرساة بيتكوين (ots)',
    'verify.dlProof': 'تنزيل الإثبات (.json)',
    'verify.dlOts': 'تنزيل .ots',
    'verify.noCold': 'لا يتضمن هذا الإثبات توقيعًا مشتركًا COLD.',
    'verify.sovereign': 'تحقق سيادي مُنفَّذ: تم التحقق من مرساة الاتفاقية التجريبية في 2026-07-31 مقابل عقدة بيتكوين خاصة (الكتلة #957242) — صفر مستكشفات، صفر تقاويم، صفر أطراف ثالثة.',
    'verify.sovereignProof': 'عرض اللقطة ←',
    'verify.copy': 'نسخ',
    'verify.copied': 'تم النسخ',
    'ag.toastSealed': 'خُتمت الاتفاقية. أُرسل الإثبات إلى OpenTimestamps.',
    'ag.toastSigned': 'تم تسجيل القبول. بانتظار الطرف الآخر.',
    'ag.toastStillPending': 'لا تأكيد في كتلة بعد. عادةً يستغرق OpenTimestamps ساعات.',

    'join.kicker': 'دعوة',
    'join.title': 'تمت دعوتك إلى اتفاقية',
    'join.body': 'ادخل بمفتاحك لتُثبَّت كالطرف ب. هذا الرابط يُستخدم مرة واحدة: سيُربط بهويتك.',
    'join.cta': 'الدخول بمفتاحي والانضمام',
    'join.progress': 'جارٍ ربطك بالاتفاقية…',

    'ver.kicker': 'تحقق عام · دون حساب',
    'ver.title': 'التحقق من إثبات',
    'ver.sub': 'تحقق مما إذا كان ملف أو نص أو بصمة يطابق اتفاقية مختومة. في التحقق عبر الويب، تُحسب بصمة SHA-256 في متصفحك. لا يرسل طلب التحقق إلا هذه البصمة، لا الملف ولا النص الأصلي.',
    'ver.tabFile': 'ملف',
    'ver.tabText': 'نص',
    'ver.tabHash': 'بصمة',
    'ver.tabBundle': 'Evidence Bundle (.zip)',
    'ver.bundleDrop': 'اسحب الحزمة x39-evidencia-<id>.zip',
    'ver.bundleNote': 'تحقق محلي 100% في متصفحك: لا يُرسل شيء إلى أي خادم.',
    'ver.bundleErr': 'ملف ZIP غير صالح أو ناقص',
    'ver.bverifying': 'جارٍ التحقق…',
    'ver.bcheck.files': 'ملفات الحزمة',
    'ver.bcheck.integrity': 'السلامة — SHA-256 لملف proof.json',
    'ver.bcheck.consistency': 'اتساق الحقول',
    'ver.bcheck.chain': 'سلسلة رسائل المحادثة',
    'ver.bcheck.msgsigs': 'توقيعات Ed25519 لكل رسالة',
    'ver.bcheck.mldsa_cold': 'توقيع سيادي مشترك ML-DSA-87 (COLD)',
    'ver.bcheck.mldsa_warm': 'توقيع تاريخي ML-DSA-87 (WARM)',
    'ver.bcheck.manifest': 'بيان الملفات (README مُجمَّد عند الختم)',
    'ver.bcheck.ots_present': 'إرساء بيتكوين موجود داخل الحزمة (لم يُتحقَّق منه هنا)',
    'ver.bverdict.valid': 'الأدلة صحيحة',
    'ver.bverdict.consistent': 'متّسقة — كل ما يمكن التحقق منه هنا مطابق؛ لا يتم التحقق من الإرساء على بيتكوين في المتصفح',
    'ver.bverdict.consistent_nocold': 'متّسقة دون توقيع مشترك — التوقيع السيادي المشترك مفقود، ولم يُتحقَّق من الإرساء هنا أيضاً',
    'ver.bverdict.fail': 'غير صحيحة أو مُتلاعَب بها',
    'ver.botsNote': 'مرساة بيتكوين: لا يستطيع المتصفح التحقق منها دون عقدة. حمّل .ots ونفّذ: ots verify proof.json.ots',
    'ver.bdocTitle': 'ربط مستندك الأصلي (اختياري)',
    'ver.bdocNote': 'المستند لا يغادر جهازك أبدًا: تُحسب بصمته SHA-256 فقط.',
    'ver.bdocOk': 'مستندك يطابق content_hash المُرسَّخ',
    'ver.bdocBad': 'مستندك لا يطابق content_hash',
    'ver.dropTitle': 'اسحب الملف المراد التحقق منه',
    'ver.dropNote': 'تُحسب SHA-256 محليًا ويُبحث عنها بين الاتفاقيات المختومة.',
    'ver.textPh': 'الصق هنا نص الاتفاقية بدقة (بايتًا ببايت).',
    'ver.verifyTextBtn': 'حساب SHA-256 والتحقق',
    'ver.verifyHashBtn': 'التحقق من البصمة',
    'ver.verifying': 'جارٍ التحقق…',
    'ver.hashPh': 'بصمة sha-256 من 64 حرفًا (المحتوى أو الإثبات)',
    'ver.invalidHash': 'أدخل SHA-256 صالحًا (64 حرفًا سداسيًا عشريًا).',
    'ver.foundTitle': 'تم العثور على الإثبات',
    'ver.matchedBy': 'التطابق حسب',
    'ver.matchedContent': 'بصمة المحتوى',
    'ver.matchedProof': 'بصمة الإثبات',
    'ver.fTitle': 'العنوان',
    'ver.anchor': 'مرساة بيتكوين',
    'ver.pendingConf': 'بانتظار التأكيد',
    'ver.pq': 'توقيع ما بعد الكم (ML-DSA-87)',
    'ver.pqValid': 'صالح — تم التحقق على الخادم',
    'ver.pqInvalid': 'غير صالح',
    'ver.cold': 'توقيع COLD السيادي',
    'ver.contentHash': 'بصمة المحتوى',
    'ver.notFoundTitle': 'لا تطابق',
    'ver.notFoundBody': 'لا توجد اتفاقية مختومة تطابق هذه البصمة. بايت واحد مختلف يُنتج بصمة مختلفة تمامًا.',

    'cert.sub': 'إثبات المحتوى والتاريخ مُرسَّخ في بيتكوين',
    'cert.pendingOts': 'بانتظار التأكيد (OpenTimestamps)',
    'cert.downloadPdf': 'تنزيل PDF',
    'cert.payloadJson': 'حمولة .json',
    'cert.bundle': 'Evidence Bundle (.zip)',
    'cert.share': 'مشاركة',
    'cert.shareCopied': 'تم نسخ الرابط العام',
    'cert.indepNote': 'تحقق مستقل: حمّل حمولة .json وإثبات .ots وتحقق منهما بأي عميل OpenTimestamps. لا تحتاج إلى الوثوق بنا.',
    'cert.legalScope': 'نطاق قانوني صادق: هذا الإثبات دليل تشفيري على الوجود والسلامة والتاريخ: ختم زمني في بيتكوين، وعند توفره، توقيع مشترك مقاوم للحوسبة الكمية ML-DSA-87 (NIST FIPS 204) من X-39 بصفتها المشغّل، يُنشأ على جهاز غير متصل بالشبكة. ولا يحل محل كاتب العدل.',
    'cert.goVerify': 'اذهب للتحقق',
    'footer.github': 'GitHub · الشيفرة والأدلة',
    'landing.codeLink': 'عرض الشيفرة على GitHub →',
    'footer.contact': 'اتصل بنا',
    'footer.privacy': 'الخصوصية',
    'cert.notFound': 'لم يُعثر على الإثبات',
    'meta.title': 'X-39 Evidencia — إثبات وجود مثبت على بيتكوين',
    'meta.desc': 'بصمة ملفاتك وتاريخها مثبتان على بيتكوين عبر OpenTimestamps. أداة تحقق مفتوحة المصدر (AGPL-3.0)، يمكن لأي شخص التحقق بها دون الاعتماد علينا.',
    'privacy.title': 'الخصوصية والبيانات',
    'privacy.p1': 'ما نخزّنه: بصمة SHA-256 لما تختمه، وعنوان الاتفاقية، والمفاتيح العامة للطرفين، وتاريخ الختم، وإثبات OpenTimestamps، وإذا تضمّنت الاتفاقية دفعة، مبلغها بعملة BTC وعنوان الاستلام. إذا كتبت نص الاتفاقية في الموقع، يُحفظ هذا النص لتفعيل الاتفاقية. إذا اخترت ملفًا لختمه أو للتحقق منه، تُحسب بصمة SHA-256 الخاصة به محليًا. تُرسل البصمة إلى الخدمة دون رفع الملف.',
    'privacy.p2': 'ما لا نخزّنه: لا بريد إلكتروني، ولا كلمة مرور، ولا اسم. هويتك مفتاح تشفيري يعيش في متصفحك. المحادثة بين الطرفين مشفّرة في المتصفح، والخادم يخزّن النص المشفّر فقط.',
    'privacy.p3': 'ملفات تعريف الارتباط: ملف جلسة واحد (httponly، 7 أيام) بعد الدخول بمفتاحك، وتفضيل اللغة في متصفحك. لا تحليلات، ولا متتبّعات، ولا أطراف ثالثة: هذا الموقع لا يحمّل شيئًا من نطاقات أخرى.',
    'privacy.p4': 'أين ومن: الخادم في إسبانيا ويديره José Luis Olivares (security@x39matrix.org). يسجّل بيتكوين التزامًا تشفيريًا، لا المستند أبدًا. يتضمن الإثبات العلني للاتفاقية أيضًا عنوانها ومعرّفات مستعارة للطرفين وتواريخ، وإذا تضمّنت الاتفاقية دفعة، مبلغها بعملة BTC وعنوان الاستلام، لكنه لا يتضمن المستند ولا محتوى الدردشة. يمكن التحقق من التثبيت المؤكَّد بشكل مستقل. لا يمكن إزالة الالتزام المسجّل في بيتكوين من السلسلة. لأي سؤال عن بياناتك: security@x39matrix.org.',
    'comms.title': 'X-39 Comunicaciones',
    'comms.sub': 'مكالمات ومكالمات فيديو ورسائل مشفّرة بين هاتفين. تطبيق منفصل عن X-39 Evidencia، من المشروع نفسه.',
    'comms.howT': 'كيف يعمل',
    'comms.how1': 'يُتّفق على مفتاح كل مكالمة بين الهاتفين باستخدام ML-KEM-1024 (FIPS 203) ويُوقَّع باستخدام ML-DSA-87 (FIPS 204). يُشفَّر الصوت والفيديو من طرف إلى طرف بهذا المفتاح، الذي لا يملكه الخادم. لم يخضع هذا بعدُ لتدقيق من طرف ثالث.',
    'comms.how2': 'يمكن أن تمرّ حركة البيانات عبر نفق WireGuard اختياري إلى خادم تابع لنا. بلا حساب بريد إلكتروني ولا رقم هاتف: الهوية مفتاح يُنشأ على الهاتف ولا يغادره. تُعرض لكل جهة اتصال بصمة مفتاحها، لمقارنتها شخصيًا أو عبر الهاتف.',
    'comms.statusT': 'الحالة: نسخة تجريبية مغلقة، بالدعوة',
    'comms.status1': 'يصل الكود والتنزيل العام في نوفمبر 2026، مع نموذج التهديدات ودليل النشر وصفحة الخصوصية. وحتى ذلك الحين، يُسلَّم التطبيق يدويًا لمن يطلبه ويختبره معنا.',
    'comms.statusMail': 'لطلب الوصول:',
    'comms.dlT': 'عند النشر',
    'comms.dl1': 'ستجد هنا ملف APK وقيمة SHA-256 الخاصة به وبصمة شهادة التوقيع والأوامر اللازمة للتحقق منها، كما في [[صفحة Evidencia]].',
    'comms.whyT': 'لماذا تطبيقان',
    'comms.why1': 'عند الختم أو التثبيت من Evidencia، لا يُرسل إلى خوادم التقويم إلا التزام من 32 بايت مشتق من البصمة. إذا اخترت إرسال كبسولة إلى هاتف مقترن، يُرسل الأصل مشفّرًا من طرف إلى طرف.',
    'comms.limitsT': 'ما ليس عليه',
    'comms.limits1': 'مع تفعيل النفق، لا يرى من يراقب شبكتك مع من تتحدث ولا ما تقول: يرى حركة بيانات مشفّرة متجهة إلى خادمنا. لكنه يرى أنك تستخدم X-39، ويمكنه أن يستنتج من إيقاع حركة البيانات أن هناك مكالمة جارية، ويمكنه حجب النفق، كما تفعل عدة دول بالفعل مع WireGuard. لا يعرف الخادم المحتوى، لكنه يعرف أن مفتاحين تحادثا، ومتى، وكم من الوقت. إذا كان هاتفك مخترقًا، فلا شيء من هذا يحميك. ليس مجهول الهوية. إنه نسخة تجريبية بلا تدقيق خارجي: قد يتعطل.',
    'comms.backEvidencia': '→ العودة إلى X-39 Evidencia',
    'footer.comms': 'Comunicaciones (تجريبي)',
    'appe.title': 'X-39 Evidencia لنظام Android',
    'appe.sub': 'صور أو صوت أو فيديو أو أي ملف، تُختم على هاتفك. الإصدار 0.3.4، المنشور في 12 أكتوبر 2026، بسبع لغات. Android 9 أو أحدث.',
    'appe.whatT': 'ماذا يفعل',
    'appe.what1': 'تلتقط صورة أو تسجّل صوتًا أو فيديو أو تختار ملفًا. يُحفظ مشفّرًا على هاتفك. عند الختم أو التثبيت، لا يُرسل إلى خوادم التقويم إلا التزام من 32 بايت مشتق من البصمة. إذا اخترت إرسال كبسولة إلى هاتف مقترن، يُرسل الأصل مشفّرًا من طرف إلى طرف.',
    'appe.what2': 'يُوقَّع كل عنصر باستخدام ML-DSA-87 (FIPS 204) بمفتاح يُنشأ على الهاتف. لا حساب ولا نسخة في السحابة.',
    'appe.what3': 'تُثبَّت التجزئة في Bitcoin عبر OpenTimestamps. يمكن لأي شخص التحقق من الإيصال بأدوات عامة، من دون هذا التطبيق ومن دون الوثوق بنا. إنه إثبات للوجود والسلامة والتاريخ؛ ولا يحلّ محل كاتب العدل ولا محل التوقيع الإلكتروني المؤهَّل.',
    'appe.dlT': 'التنزيل',
    'appe.dl1': 'يُنزَّل ملف APK من هذا الموقع، ويُنشر أيضًا على GitHub مع قيمة SHA-256 الخاصة به وبصمة شهادة التوقيع والختم الزمني المؤهَّل وإثبات OpenTimestamps. تحقّق من البصمات قبل التثبيت.',
    'appe.dlLink': 'تنزيل x39-0.3.4-release.apk (6.3 MB) من x39matrix.org',
    'appe.dlLink2': 'الإصدار نفسه على GitHub، مع ملفات التحقق',
    'appe.prevT': 'الإصدار السابق',
    'appe.prev1': 'الإصدار 0.3.3 (8 أكتوبر 2026)، الموقَّع بالشهادة نفسها والمثبَّت في الكتلة 970517، يبقى متاحًا لإصدار واحد آخر.',
    'appe.prevLink': 'تنزيل x39-0.3.3-release.apk',
    'appe.prevGh': 'الإصدار 0.3.3 على GitHub، مع ملفات التحقق',
    'appe.clocksT': 'ساعتان على ملف APK نفسه',
    'appe.clock1': 'ختم زمني مؤهَّل (RFC 3161، eIDAS) أصدرته ANF AC في 2026-10-12 الساعة 15:12:15 UTC، ويمكن التحقق منه باستخدام openssl مقابل شهادة الجذر الخاصة بـ ANF، المنشورة بجانب ملف APK.',
    'appe.clock2': 'التثبيت في Bitcoin: الكتلة 971111 (2026-10-12 15:26:58 UTC)، جرى التحقق منها مقابل عقدتنا الخاصة. يمكن التحقق منه باستخدام عميل OpenTimestamps وأي عقدة Bitcoin.',
    'appe.verifyT': 'تحقّق من ملف APK',
    'appe.verify1': 'بعد وضع ملفات الإصدار في المجلد نفسه:',
    'appe.permsT': 'الأذونات (7)',
    'appe.perms1': 'INTERNET، ACCESS_NETWORK_STATE، CAMERA، RECORD_AUDIO، FOREGROUND_SERVICE، FOREGROUND_SERVICE_SPECIAL_USE و POST_NOTIFICATIONS.',
    'appe.perms2': 'يُستخدم الإنترنت لإرسال التزام من 32 بايت مشتق من البصمة إلى تقاويم OpenTimestamps وجلب الإثباتات (اختياريًا عبر Tor فقط باستخدام Orbot)، وللدردشة المشفّرة. إذا اخترت إرسال كبسولة إلى هاتف مقترن، يُرسل الأصل مشفّرًا من طرف إلى طرف.',
    'appe.srcT': 'الشيفرة',
    'appe.src1': 'أداة التحقق والموقع وواجهة API موجودة على GitHub (x39-Evidencia، AGPL-3.0). ستُنشر شيفرة التطبيق في مستودع خاص بها؛ ويصدر كل إصدار مع بصماته وختميه الزمنيين.',
    'appe.toComms': 'X-39 Comunicaciones (تطبيق منفصل) ←',
    'appe.back': '→ العودة إلى X-39 Evidencia',
    'footer.app': 'تطبيق Android',
    'landing.commsT': 'تطبيق شقيق: X-39 Comunicaciones',
    'landing.commsBody': 'من المشروع نفسه: مكالمات ومكالمات فيديو ورسائل مشفّرة بين هاتفين، بمفتاح مكالمة مقاوم للحوسبة الكمية. في نسخة تجريبية مغلقة بالدعوة؛ يصل الكود والتنزيل العام في نوفمبر 2026.',
    'landing.commsLink': 'اعرف المزيد واطلب الوصول ←',
    'landing.ctaDownload': 'تنزيل Evidencia (أندرويد)',
    'landing.ctaCreateBeta': 'إنشاء اتفاقية · نسخة تجريبية مغلقة',
    'landing.proofsT': 'X-39 Evidencia وإثباتاته',
    'landing.proofsApk': 'ملف APK لأندرويد، مع SHA-256 الخاص به وبصمة شهادة التوقيع والساعتين (بيتكوين والختم الزمني المؤهل من ANF)',
    'landing.proofsRepo': 'الشفرة المصدرية، رخصة AGPL-3.0',
    'landing.proofsBundle': 'Evidence Bundle v1.1 وأداة التحقق الخاصة به ونتيجة VALID على عقدة بيتكوين خاصة بنا',
    'landing.proofsSevilla': 'وثائق إشبيلية الأربعون، مختومة وقابلة للتحقق',
    'landing.leavesT': 'ما الذي يغادر هاتفك',
    'landing.leaves': 'عند التثبيت، لا يغادر الهاتف إلا البصمة (التزام من 32 بايت مشتق منها) ويُرسل إلى خوادم تقويم OpenTimestamps. إذا أرسلت كبسولة إلى هاتف مقترن، ينتقل الأصل مشفّرًا من طرف إلى طرف، وفقط عندما ترسلها أنت.',
    'landing.notProveT': 'ما لا يثبته',
    'landing.notProve': 'يثبت أن ملفًا بعينه كان موجودًا في تاريخ معيّن ولم يتغيّر منذ ذلك الحين. لا يثبت من كتبه، ولا أن ما يقوله صحيح.',
    'landing.commsLine': 'X-39 Comunicaciones تطبيق منفصل، في نسخة تجريبية مغلقة ويصبح متاحًا للعموم في نوفمبر؛ في Evidencia زر اختياري لفتحه، لكنه يعمل من دونه: لا يحتاج إلى VPN ولا يستخدم الكاميرا والميكروفون إلا عندما تلتقط صورة أو تسجّل.',
  },
  uk: {
    'nav.verify': 'Перевірити',
    'nav.panel': 'Панель',
    'nav.login': 'Увійти',
    'common.loading': 'Завантаження…',
    'common.verifyingIdentity': 'Перевіряємо вашу ідентичність…',
    'common.backToPanel': 'Назад до панелі',
    'common.goToPanel': 'До моєї панелі',
    'landing.tag': 'Закріплено в Bitcoin · Перевірити може будь-хто · Контрпідпис ML-DSA-87 з машини без доступу до мережі',
    'landing.betaBanner': 'Закрите бета-тестування. X-39 Agreements ще інтегрується: створення угод поки не відкрите для всіх. Уже видані докази можна перевірити незалежними інструментами. Не замінює нотаріуса чи кваліфікований електронний підпис.',
    'ag.pqAuthFail': 'Ключ шифрування іншої сторони не підписаний або його підпис недійсний. З міркувань безпеки чат залишається заблокованим, доки це не буде вирішено.',
    'landing.h1': 'Доведіть, що це існувало. Перевірте, не довіряючи нікому.',
    'landing.h1b': 'Кожен доказ закріплено в Bitcoin, і його можна перевірити незалежними інструментами, не покладаючись на нас. Він також може мати контрпідпис ML-DSA-87 (FIPS 204), створений на машині без доступу до мережі, який перевіряється за опублікованим відбитком X-39.',
    'landing.chipPq': 'ML-DSA-87 · FIPS-204',
    'landing.chipBtc': 'Bitcoin · OpenTimestamps',
    'landing.chipTrust': 'SHA-256 у вашому браузері',
    'landing.chipCold': 'Ключ COLD · Pi без доступу до мережі',
    'landing.chipNode': 'Якір перевірено · власний вузол',
    'landing.ctaVerifySelf': 'Перевірте самі →',
    'landing.sub': 'Дві людини або компанії домовляються в чаті, зашифрованому в браузері, обидві приймають угоду — і залишається сертифікат із позначкою часу в Bitcoin.',
    'landing.ctaPrimary': 'Створити мою першу угоду (бета)',
    'landing.ctaSecondary': 'Подивитися вже перевірений доказ',
    'landing.ctaVerify': 'Перевірити доказ',
    'landing.certTitle': 'Сертифікат угоди',
    'landing.certHashLabel': 'Хеш вмісту (SHA-256)',
    'landing.certAnchorLabel': 'Якір у Bitcoin',
    'landing.certMockBadge': 'Підтверджено в блоці Bitcoin (приклад)',
    'landing.sealedStamp': 'ЗАПЕЧАТАНО',
    'landing.s1t': 'Напишіть або завантажте угоду',
    'landing.s1d': 'Текст або файл. Хеш SHA-256 обчислюється у вашому браузері. Для файлу передається лише хеш; якщо ви вводите текст тут, текст надсилається сервісу, щоб створити угоду і докази.',
    'landing.s2t': 'Домовтеся і прийміть',
    'landing.s2d': 'Чат між двома сторонами, зашифрований у браузері. Коли обидві приймуть угоду, розмова заморожується, і її хеш стає частиною доказу.',
    'landing.s3t': 'Запечатано в Bitcoin',
    'landing.s3d': 'Публічний сертифікат, який може перевірити будь-хто, без облікового запису й безкоштовно.',
    'landing.forWhoTitle': 'Для кого це',
    'landing.forWho': 'Журналісти, джерела та правозахисні організації, яким треба довести, що документ існував — і що в ньому було написано, — перш ніж хтось його заперечить, конфіскує чи видалить, не покладаючись на платформу, на яку можна чинити тиск або яку можна вимкнути. А також фрилансери й клієнти, малий бізнес, що укладає угоди, і всі, хто хоче зафіксувати дату ідеї чи патенту, перш ніж ними поділитися.',
    'landing.priceTitle': 'Ціна',
    'landing.priceBody': 'Безкоштовно, без комісій. Ми не беремо плату за створення, прийняття, запечатування чи перевірку. Код вільний (AGPL-3.0).',
    'landing.soon': 'Незабаром',
    'protect.title': 'Як це вас захищає',
    'protect.b1t': 'Закріплено в Bitcoin',
    'protect.b1d': 'Угода і заморожений чат закріплюються в блоці Bitcoin через OpenTimestamps. Доказ показує, що хеш існував до цього блоку, і ви перевіряєте це без нас.',
    'protect.b2t': 'Контрпідпис ML-DSA-87 з машини без доступу до мережі',
    'protect.b2d': 'Докази можуть мати контрпідпис ML-DSA-87 (FIPS 204), створений на машині без доступу до мережі. Він перевіряється за опублікованим відбитком ключа COLD X-39, а не лише за ключем, вкладеним у докази. Жоден ключ підпису оператора не зберігається на сервері, підключеному до мережі: історичний підпис WARM виведено з ужитку в липні 2026 року.',
    'protect.b3t': 'Перевірити може будь-хто',
    'protect.b3d': 'Безкоштовно, без комісій. Завантажте доказ .ots і перевірте його незалежними інструментами: нам довіряти не потрібно.',
    'protect.b4t': 'Другий годинник: кваліфікована позначка часу',
    'protect.b4d': 'Окрім Bitcoin, X-39 додає кваліфіковану позначку часу RFC 3161, видану ANF AC — кваліфікованим надавачем довірчих послуг за eIDAS (презумпція точності дати й цілісності в усьому ЄС, ст. 41). Сьогодні її має публічний Evidence Bundle, і вона перевіряється без підключення до мережі за допомогою openssl за кореневим сертифікатом ANF, вкладеним у сам Evidence Bundle. Угоди бета-версії поки що мають якір у Bitcoin.',
    'protect.viewBlock': 'Переглянути блок на mempool.space',
    'landing.certOpen': 'Натисніть, щоб перевірити цей сертифікат',
    'landing.certRealBadgePending': 'Запечатано · Очікує підтвердження в Bitcoin',
    'landing.honestyTitle': 'Чесність, яку можна перевірити',
    'landing.honestyBody': 'Ми не зберігаємо чужих коштів і не продаємо токенів. Файли не завантажуються: передається лише їхній хеш SHA-256. Текст, введений на сайті, надсилається сервісу. Статус «Підтверджено» з’являється лише з реальною атестацією блоку Bitcoin.',
    'landing.footer': 'X-39 Agreements — закрите бета-тестування угод, які можна перевірити, закріплених у Bitcoin.',
    'panel.kicker': 'Панель',
    'panel.title': 'Мої угоди',
    'panel.new': 'Нова угода',
    'panel.emptyTitle': 'У вас ще немає угод.',
    'panel.emptyBody': 'Створіть першу й поділіться посиланням-запрошенням з іншою стороною.',
    'panel.emptyCta': 'Створити мою першу угоду',
    'panel.waitingOther': 'очікуємо іншу сторону',
    'panel.badgePending': 'Очікує прийняття',
    'panel.badgeConfirmed': 'Підтверджено · блок #',
    'panel.badgeSealedPending': 'Запечатано · якір очікується',
    'crear.kicker': 'Нова угода',
    'crear.title': 'Що ви хочете запечатати?',
    'crear.titleLabel': 'Назва угоди',
    'crear.titlePh': 'напр. Договір на вебдизайн — здача і оплата',
    'crear.tabText': 'Текст',
    'crear.tabFile': 'Файл',
    'crear.contentLabel': 'Зміст угоди',
    'crear.textPh': 'Напишіть тут точні умови угоди.\nТекст буде збережено, а його SHA-256 стане запечатаним хешем.',
    'crear.dropTitle': 'Перетягніть файл або натисніть, щоб вибрати',
    'crear.dropNote': 'Файл ніколи не завантажується: його SHA-256 обчислюється у вашому браузері.',
    'crear.hashLabel': 'Хеш SHA-256 (обчислено на вашому пристрої)',
    'crear.submit': 'Створити угоду й отримати посилання-запрошення',
    'crear.submitting': 'Створюємо…',
    'crear.afterNote': 'Після створення угоди ви надішлете іншій стороні одноразове посилання.',
    'crear.toastCreated': 'Угоду створено. Поділіться посиланням-запрошенням.',
    'ag.badgePending': 'Очікує прийняття',
    'ag.badgeConfirmedIn': 'Підтверджено в блоці Bitcoin #',
    'ag.badgeSealedPendingBtc': 'Запечатано · Очікує підтвердження в Bitcoin',
    'ag.kicker': 'Угода',
    'ag.contentLabel': 'Зміст угоди',
    'ag.fileLabel': 'Запечатаний файл',
    'ag.fileNote': '(файл ніколи не завантажувався; лише його хеш)',
    'ag.hashLabel': 'Хеш SHA-256 вмісту',
    'ag.parties': 'Сторони',
    'ag.partyA': 'Сторона A',
    'ag.partyB': 'Сторона B',
    'ag.signed': 'прийняла',
    'ag.notSigned': 'не прийняла',
    'ag.pendingJoin': 'ще не приєдналася',
    'ag.inviteLabel': 'Посилання-запрошення (одноразове)',
    'ag.copyLink': 'Копіювати посилання',
    'ag.copied': 'Посилання скопійовано',
    'ag.inviteNote': 'Перша людина, яка відкриє це посилання, буде закріплена як Сторона B. Ніхто інший не зможе ним скористатися.',
    'ag.signBtn': 'Прийняти цю угоду',
    'ag.signing': 'Фіксуємо прийняття і готуємо докази…',
    'ag.signNote': 'Коли обидві сторони приймуть угоду, чат заморожується, а доказ закріплюється в Bitcoin через OpenTimestamps.',
    'ag.alreadySigned': 'Ви прийняли угоду. Очікуємо, поки інша сторона її запечатає і закріпить.',
    'ag.sealedProof': 'Запечатаний доказ',
    'ag.sealedAt': 'Запечатано (UTC)',
    'ag.proofHash': 'Хеш доказу',
    'ag.chatHash': 'Хеш замороженого чату',
    'ag.pqSig': 'Історичний підпис оператора ML-DSA-87 (WARM, виведений з ужитку)',
    'ag.checkAnchor': 'Перевірити якір у Bitcoin',
    'ag.certPdf': 'Сертифікат PDF',
    'ag.otsProof': 'Доказ .ots',
    'ag.publicCert': 'Публічний сертифікат',
    'ag.chatHead': 'Чат, зашифрований у браузері · лише сторони',
    'ag.chatFrozenSuffix': ' · заморожено',
    'ag.chatEmpty': 'Повідомлень немає. Обговоріть умови тут: розмову буде запечатано разом з угодою.',
    'ag.you': 'ви',
    'ag.chatFrozenNote': 'Розмову запечатано. Її хеш є частиною доказу.',
    'ag.chatPh': 'Напишіть повідомлення…',
    'ag.e2eWaiting': 'Шифрування: очікуємо публічний ключ іншої сторони…',
    'ag.chainMismatch': 'Підпис заблоковано: ланцюжок повідомлень на сервері не збігається з вашою локальною копією (можливий пропуск або зміна порядку). Перезавантажте сторінку й перевірте чат.',
    'ag.chainLabel': 'Цілісність чату',
    'ag.chainOk': 'Ланцюжок перевірено локально',
    'ag.chainFail': 'Ланцюжок НЕ збігається з вашою локальною копією',
    'ag.msgLocked': 'зашифровано — на цьому пристрої немає ключа',
    'pay.section': 'Оплата (необов’язково)',
    'pay.toggle': 'Додати оплату до угоди',
    'pay.amount': 'Сума (BTC)',
    'pay.address': 'Адреса Bitcoin для отримання',
    'pay.who': 'Хто платить?',
    'pay.bPaysA': 'Інша сторона платить мені',
    'pay.aPaysB': 'Я плачу іншій стороні',
    'pay.terms': 'Умови оплати',
    'pay.payTo': 'Отримувач',
    'pay.amountLabel': 'Сума',
    'pay.payerLabel': 'Платник',
    'pay.scan': 'Відскануйте або скопіюйте, щоб оплатити. Напряму між сторонами, без посередника, що тримає кошти.',
    'pay.copyAddr': 'Копіювати адресу',
    'pay.openWallet': 'Відкрити в гаманці',
    'pay.checkStatus': 'Перевірити статус оплати',
    'pay.received': 'Отримано',
    'pay.expected': 'Очікується',
    'pay.paid': 'Оплачено',
    'pay.unpaid': 'Очікує',
    'pay.noncustodial': 'Застосунок ніколи не торкається коштів. Оплата йде напряму між сторонами через мережу Bitcoin.',
    'pay.invalidAddr': 'Недійсна адреса Bitcoin',
    'verify.title': 'Перевірте самі (не довіряючи нам)',
    'verify.intro': 'Ці перевірки не залежать від X-39. Будь-хто може їх повторити за допомогою вільного програмного забезпечення.',
    'verify.checking': 'Звіряємо вміст із закріпленим хешем…',
    'verify.hashOk': 'Вміст збігається з хешем, закріпленим у Bitcoin',
    'verify.hashFail': 'Вміст НЕ збігається із закріпленим хешем',
    'verify.warm': 'Історичний підпис ML-DSA-87 (WARM · оператор, виведений з ужитку у 2026 році)',
    'verify.cold': 'Контрпідпис ML-DSA-87 з машини без доступу до мережі (COLD)',
    'verify.runbook': 'Регламент церемонії ключів (PDF)',
    'verify.btc': 'Якір позначки часу в Bitcoin (OpenTimestamps)',
    'verify.pubkey': 'Публічний ключ',
    'verify.signature': 'Підпис',
    'verify.fp': 'Відбиток',
    'verify.runPy': 'Перевірити підпис ML-DSA-87 (Python)',
    'verify.runOts': 'Перевірити якір у Bitcoin (ots)',
    'verify.dlProof': 'Завантажити доказ (.json)',
    'verify.dlOts': 'Завантажити .ots',
    'verify.noCold': 'Цей доказ не містить контрпідпису COLD.',
    'verify.sovereign': 'Незалежну перевірку виконано: якір демонстраційної угоди перевірено 2026-07-31 на власному скороченому (pruned) вузлі Bitcoin (блок #957242) — без оглядачів блоків, без календарів, без третіх сторін.',
    'verify.sovereignProof': 'Переглянути знімок екрана →',
    'verify.copy': 'Копіювати',
    'verify.copied': 'Скопійовано',
    'ag.toastSealed': 'Угоду запечатано. Доказ надіслано до OpenTimestamps.',
    'ag.toastSigned': 'Прийняття зафіксовано. Очікуємо іншу сторону.',
    'ag.toastStillPending': 'Підтвердження в блоці ще немає. OpenTimestamps зазвичай потребує кількох годин.',
    'join.kicker': 'Запрошення',
    'join.title': 'Вас запросили до угоди',
    'join.body': 'Увійдіть зі своїм ключем, щоб стати Стороною B. Це посилання одноразове: воно буде прив’язане до вашої ідентичності.',
    'join.cta': 'Увійти з моїм ключем і приєднатися',
    'join.progress': 'Приєднуємо вас до угоди…',
    'ver.kicker': 'Публічна перевірка · без облікового запису',
    'ver.title': 'Перевірити доказ',
    'ver.sub': 'Перевірте, чи збігається файл, текст або хеш із запечатаною угодою. Під час вебперевірки хеш SHA-256 обчислюється у вашому браузері. Запит на перевірку надсилає лише цей хеш, а не оригінальний файл чи текст.',
    'ver.tabFile': 'Файл',
    'ver.tabText': 'Текст',
    'ver.tabHash': 'Хеш',
    'ver.tabBundle': 'Evidence Bundle (.zip)',
    'ver.bundleDrop': 'Перетягніть сюди Evidence Bundle x39-evidencia-<id>.zip',
    'ver.bundleNote': 'Перевірка на 100% локальна, у вашому браузері: нічого не надсилається на жоден сервер.',
    'ver.bundleErr': 'Недійсний або неповний ZIP',
    'ver.bverifying': 'Перевіряємо…',
    'ver.bcheck.files': 'Файли Evidence Bundle',
    'ver.bcheck.integrity': 'Цілісність — SHA-256 файлу proof.json',
    'ver.bcheck.consistency': 'Узгодженість полів',
    'ver.bcheck.chain': 'Ланцюжок повідомлень чату',
    'ver.bcheck.msgsigs': 'Підписи Ed25519 кожного повідомлення',
    'ver.bcheck.mldsa_cold': 'Незалежний контрпідпис ML-DSA-87 (COLD)',
    'ver.bcheck.mldsa_warm': 'Історичний підпис ML-DSA-87 (WARM)',
    'ver.bcheck.manifest': 'Перелік файлів (README, заморожений під час запечатування)',
    'ver.bcheck.ots_present': 'Якір Bitcoin присутній у пакеті (тут не перевіряється)',
    'ver.bverdict.valid': 'ДОКАЗИ ДІЙСНІ',
    'ver.bverdict.consistent': 'УЗГОДЖЕНО — усе, що можна перевірити тут, збігається; якір Bitcoin у браузері не перевіряється',
    'ver.bverdict.consistent_nocold': 'УЗГОДЖЕНО, БЕЗ КОНТРПІДПИСУ — немає суверенного контрпідпису, і якір Bitcoin тут теж не перевіряється',
    'ver.bverdict.fail': 'НЕДІЙСНО АБО ЗМІНЕНО',
    'ver.botsNote': 'Якір у Bitcoin: браузер не може перевірити його без вузла. Завантажте .ots і виконайте: ots verify proof.json.ots',
    'ver.bdocTitle': 'Додайте свій оригінальний документ (необов’язково)',
    'ver.bdocNote': 'Документ ніколи не залишає ваш пристрій: обчислюється лише його SHA-256.',
    'ver.bdocOk': 'Ваш документ збігається із закріпленим content_hash',
    'ver.bdocBad': 'Ваш документ НЕ збігається з content_hash',
    'ver.dropTitle': 'Перетягніть файл для перевірки',
    'ver.dropNote': 'SHA-256 обчислюється локально і звіряється із запечатаними угодами.',
    'ver.textPh': 'Вставте сюди точний текст угоди (байт у байт).',
    'ver.verifyTextBtn': 'Обчислити SHA-256 і перевірити',
    'ver.verifyHashBtn': 'Перевірити хеш',
    'ver.verifying': 'Перевіряємо…',
    'ver.hashPh': 'Хеш sha-256 із 64 символів (вмісту або доказу)',
    'ver.invalidHash': 'Введіть дійсний SHA-256 (64 шістнадцяткові символи).',
    'ver.foundTitle': 'Доказ знайдено',
    'ver.matchedBy': 'Збіг за',
    'ver.matchedContent': 'хешем вмісту',
    'ver.matchedProof': 'хешем доказу',
    'ver.fTitle': 'Назва',
    'ver.anchor': 'Якір у Bitcoin',
    'ver.pendingConf': 'Очікує підтвердження',
    'ver.pq': 'Постквантовий підпис (ML-DSA-87)',
    'ver.pqValid': 'Дійсний — перевірено на сервері',
    'ver.pqInvalid': 'НЕДІЙСНИЙ',
    'ver.cold': 'Незалежний підпис COLD',
    'ver.contentHash': 'Хеш вмісту',
    'ver.notFoundTitle': 'Збігів немає',
    'ver.notFoundBody': 'Жодна запечатана угода не відповідає цьому хешу. Один інший байт дає зовсім інший хеш.',
    'cert.sub': 'Доказ вмісту й дати, закріплений у Bitcoin',
    'cert.pendingOts': 'Очікує підтвердження (OpenTimestamps)',
    'cert.downloadPdf': 'Завантажити PDF',
    'cert.payloadJson': 'Дані .json',
    'cert.bundle': 'Evidence Bundle (.zip)',
    'cert.share': 'Поділитися',
    'cert.shareCopied': 'Публічне посилання скопійовано',
    'cert.indepNote': 'Незалежна перевірка: завантажте дані .json і доказ .ots та перевірте їх будь-яким клієнтом OpenTimestamps. Довіряти нам не потрібно.',
    'cert.legalScope': 'Чесно про юридичну силу: цей доказ є криптографічним свідченням існування, цілісності й дати: позначка часу в Bitcoin і, якщо він є, постквантовий контрпідпис ML-DSA-87 (NIST FIPS 204) від X-39 як оператора, створений на машині без доступу до мережі. Не замінює нотаріуса.',
    'footer.github': 'GitHub · код і докази',
    'landing.codeLink': 'Переглянути код на GitHub →',
    'footer.contact': 'Контакти',
    'footer.privacy': 'Конфіденційність',
    'cert.notFound': 'Доказ не знайдено',
    'meta.title': 'X-39 Evidencia — Доказ існування, закріплений у Bitcoin',
    'meta.desc': 'Відбиток і дата ваших файлів закріплені в Bitcoin через OpenTimestamps. Верифікатор з відкритим кодом (AGPL-3.0): будь-хто може все перевірити, не покладаючись на нас.',
    'privacy.title': 'Конфіденційність і дані',
    'privacy.p1': 'Що ми зберігаємо: хеш SHA-256 того, що ви запечатуєте, назву угоди, публічні ключі сторін, дату запечатування, доказ OpenTimestamps і, якщо угода передбачає платіж, його суму в BTC та адресу отримання. Якщо ви вводите текст угоди на сайті, цей текст зберігається, щоб створити угоду. Якщо ви обираєте файл для запечатування або перевірки, його хеш SHA-256 обчислюється локально. Сервісу надсилається хеш, без завантаження файлу.',
    'privacy.p2': 'Чого ми не зберігаємо: ні електронної пошти, ні пароля, ні імені. Ваша ідентичність — це криптографічний ключ, який живе у вашому браузері. Чат між сторонами шифрується в браузері; сервер зберігає лише зашифрований текст.',
    'privacy.p3': 'Cookies: один сеансовий cookie (httponly, 7 днів) після входу з вашим ключем і вибір мови у вашому браузері. Жодної аналітики, жодних трекерів, жодних третіх сторін: цей сайт нічого не завантажує з інших доменів.',
    'privacy.p4': 'Де і хто: сервер працює в Іспанії, ним керує José Luis Olivares (security@x39matrix.org). Bitcoin фіксує криптографічне зобов’язання, ніколи не сам документ. Публічний доказ угоди також містить її назву, псевдонімні ідентифікатори сторін, дати і, якщо угода передбачає платіж, його суму в BTC та адресу отримання, але не документ і не вміст чату. Підтверджене закріплення можна перевірити незалежно. Зобов’язання, зафіксоване в Bitcoin, неможливо вилучити з ланцюжка. З будь-яких питань щодо ваших даних: security@x39matrix.org.',
    'cert.goVerify': 'Перейти до перевірки',
    'comms.title': 'X-39 Comunicaciones',
    'comms.sub': 'Зашифровані дзвінки, відеодзвінки та повідомлення між двома телефонами. Окремий застосунок, не X-39 Evidencia, але того самого проєкту.',
    'comms.howT': 'Як це працює',
    'comms.how1': 'Ключ кожного дзвінка узгоджується між двома телефонами за допомогою ML-KEM-1024 (FIPS 203) і підписується ML-DSA-87 (FIPS 204). Аудіо й відео шифруються наскрізно цим ключем, якого сервер не має. Третя сторона цього ще не перевіряла (аудиту не було).',
    'comms.how2': 'Трафік може йти через необов’язковий тунель WireGuard до нашого сервера. Без поштової скриньки й без номера телефону: ідентичність — це ключ, який створюється на телефоні й ніколи його не залишає. Для кожного контакту видно відбиток його ключа, щоб звірити його особисто або телефоном.',
    'comms.statusT': 'Стан: закрита бета, за запрошенням',
    'comms.status1': 'Код і публічне завантаження з’являться в листопаді 2026 року разом із моделлю загроз, посібником із розгортання та сторінкою конфіденційності. До того часу застосунок передаємо особисто тим, хто про нього просить і тестує його разом із нами.',
    'comms.statusMail': 'Щоб попросити доступ:',
    'comms.dlT': 'Після публікації',
    'comms.dl1': 'Тут будуть APK, його SHA-256, відбиток сертифіката підпису й команди для їх перевірки, як на [[сторінці Evidencia]].',
    'comms.whyT': 'Чому два застосунки',
    'comms.why1': 'Під час запечатування або анкерування в Evidencia календарям надсилається лише 32-байтове зобов’язання, похідне від відбитка. Якщо ви вирішите надіслати капсулу на спарений телефон, оригінал передається із наскрізним шифруванням.',
    'comms.limitsT': 'Чим це не є',
    'comms.limits1': 'З увімкненим тунелем той, хто стежить за вашою мережею, не бачить, з ким ви розмовляєте і що кажете: він бачить зашифрований трафік до нашого сервера. Але він бачить, що ви користуєтеся X-39, може за ритмом трафіку здогадатися, що триває дзвінок, і може заблокувати тунель, як уже роблять кілька країн із WireGuard. Сервер не знає вмісту, але знає, що два ключі розмовляли, коли і як довго. Якщо ваш телефон скомпрометовано, ніщо з цього вас не захистить. Це не анонімно. Це бета без зовнішнього аудиту: вона може давати збої.',
    'comms.backEvidencia': '← Повернутися до X-39 Evidencia',
    'footer.comms': 'Comunicaciones (бета)',
    'appe.title': 'X-39 Evidencia для Android',
    'appe.sub': 'Фото, аудіо, відео або будь-який файл, запечатані на вашому телефоні. Версія 0.3.4, опублікована 12 жовтня 2026 року, сімома мовами. Android 9 або новіший.',
    'appe.whatT': 'Що робить застосунок',
    'appe.what1': 'Ви фотографуєте, записуєте аудіо чи відео або вибираєте файл. Він зберігається зашифрованим на телефоні. Під час запечатування чи анкерування календарям надсилається лише 32-байтове зобов’язання, похідне від відбитка. Якщо ви вирішите надіслати капсулу на спарений телефон, оригінал передається із наскрізним шифруванням.',
    'appe.what2': 'Кожен елемент підписується ML-DSA-87 (FIPS 204) ключем, створеним на телефоні. Без облікового запису й без копії в хмарі.',
    'appe.what3': 'Хеш закріплюється в Bitcoin через OpenTimestamps. Будь-хто може перевірити квитанцію публічними інструментами, без цього застосунку й не довіряючи нам. Це доказ існування, цілісності й дати; він не замінює нотаріуса чи кваліфікований електронний підпис.',
    'appe.dlT': 'Завантаження',
    'appe.dl1': 'APK завантажується з цього сайту, а також публікується на GitHub разом із його SHA-256, відбитком сертифіката підпису, кваліфікованою позначкою часу та доказом OpenTimestamps. Перевірте відбитки перед встановленням.',
    'appe.dlLink': 'Завантажити x39-0.3.4-release.apk (6,3 МБ) з x39matrix.org',
    'appe.dlLink2': 'Та сама версія на GitHub, з файлами для перевірки',
    'appe.prevT': 'Попередня версія',
    'appe.prev1': 'Версія 0.3.3 (8 жовтня 2026 року), підписана тим самим сертифікатом і закріплена в блоці 970517, залишається доступною ще один реліз.',
    'appe.prevLink': 'Завантажити x39-0.3.3-release.apk',
    'appe.prevGh': 'Версія 0.3.3 на GitHub, з файлами для перевірки',
    'appe.clocksT': 'Два годинники на одному APK',
    'appe.clock1': 'Кваліфікована позначка часу (RFC 3161, eIDAS), видана ANF AC 2026-10-12 о 15:12:15 UTC; її можна перевірити за допомогою openssl щодо кореневого сертифіката ANF, опублікованого поруч з APK.',
    'appe.clock2': 'Закріплення в Bitcoin: блок 971111 (2026-10-12 15:26:58 UTC), звірено з нашим власним вузлом. Перевіряється клієнтом OpenTimestamps і будь-яким вузлом Bitcoin.',
    'appe.verifyT': 'Перевірте APK',
    'appe.verify1': 'Поклавши файли релізу в одну папку:',
    'appe.permsT': 'Дозволи (7)',
    'appe.perms1': 'INTERNET, ACCESS_NETWORK_STATE, CAMERA, RECORD_AUDIO, FOREGROUND_SERVICE, FOREGROUND_SERVICE_SPECIAL_USE і POST_NOTIFICATIONS.',
    'appe.perms2': 'Інтернет використовується, щоб надсилати до календарів OpenTimestamps 32-байтове зобов’язання, похідне від відбитка, і отримувати докази (за бажанням лише через Tor з Orbot), а також для зашифрованого чату. Якщо ви вирішите надіслати капсулу на спарений телефон, оригінал передається із наскрізним шифруванням.',
    'appe.srcT': 'Код',
    'appe.src1': 'Верифікатор, сайт і API — на GitHub (x39-Evidencia, AGPL-3.0). Код застосунку буде опубліковано в окремому репозиторії; кожна версія виходить зі своїми відбитками й двома позначками часу.',
    'appe.toComms': 'X-39 Comunicaciones (окремий застосунок) →',
    'appe.back': '← Повернутися до X-39 Evidencia',
    'footer.app': 'Застосунок Android',
    'landing.commsT': 'Застосунок-побратим: X-39 Comunicaciones',
    'landing.commsBody': 'Від того самого проєкту: зашифровані дзвінки, відеодзвінки та повідомлення між двома телефонами, з постквантовим ключем дзвінка. У закритій беті за запрошенням; код і публічне завантаження з’являться в листопаді 2026 року.',
    'landing.commsLink': 'Дізнатися більше й попросити доступ →',
    'landing.ctaDownload': 'Завантажити Evidencia (Android)',
    'landing.ctaCreateBeta': 'Створити угоду · закрита бета',
    'landing.proofsT': 'X-39 Evidencia та її докази',
    'landing.proofsApk': 'APK для Android із SHA-256, відбитком сертифіката підпису та двома годинниками (Bitcoin і кваліфікована позначка часу ANF)',
    'landing.proofsRepo': 'Вихідний код, ліцензія AGPL-3.0',
    'landing.proofsBundle': 'Evidence Bundle v1.1, його верифікатор і результат VALID на нашому власному вузлі Bitcoin',
    'landing.proofsSevilla': '40 документів Севільї, запечатані й придатні до перевірки',
    'landing.leavesT': 'Що залишає ваш телефон',
    'landing.leaves': 'Під час анкерування телефон залишає лише відбиток (32-байтове зобов’язання, похідне від нього), який надсилається календарям OpenTimestamps. Якщо ви надсилаєте капсулу на спарений телефон, оригінал передається з наскрізним шифруванням, і лише тоді, коли ви її надсилаєте.',
    'landing.notProveT': 'Чого це не доводить',
    'landing.notProve': 'Доводить, що конкретний файл існував на певну дату й відтоді не змінювався. Не доводить, хто його автор, і що його зміст правдивий.',
    'landing.commsLine': 'X-39 Comunicaciones — окремий застосунок, у закритій беті, публічний у листопаді; в Evidencia є необов’язкова кнопка, щоб його відкрити, але Evidencia працює й без нього: не потребує VPN і використовує камеру та мікрофон лише тоді, коли ви фотографуєте або записуєте.',
  },
  ru: {
    'nav.verify': 'Проверить',
    'nav.panel': 'Панель',
    'nav.login': 'Войти',
    'common.loading': 'Загрузка…',
    'common.verifyingIdentity': 'Проверяем вашу идентичность…',
    'common.backToPanel': 'Назад к панели',
    'common.goToPanel': 'К моей панели',
    'landing.tag': 'Закреплено в Bitcoin · Проверить может любой · Контрподпись ML-DSA-87 с машины без доступа к сети',
    'landing.betaBanner': 'Закрытое бета-тестирование. X-39 Agreements ещё интегрируется: создание соглашений пока не открыто для всех. Уже выданные доказательства можно проверить независимыми инструментами. Не заменяет нотариуса или квалифицированную электронную подпись.',
    'ag.pqAuthFail': 'Ключ шифрования другой стороны не подписан или его подпись недействительна. В целях безопасности чат остаётся заблокированным, пока это не будет решено.',
    'landing.h1': 'Докажите, что это существовало. Проверьте, никому не доверяя.',
    'landing.h1b': 'Каждое доказательство закреплено в Bitcoin, и его можно проверить независимыми инструментами, не полагаясь на нас. Оно также может содержать контрподпись ML-DSA-87 (FIPS 204), созданную на машине без доступа к сети и проверяемую по опубликованному отпечатку X-39.',
    'landing.chipPq': 'ML-DSA-87 · FIPS-204',
    'landing.chipBtc': 'Bitcoin · OpenTimestamps',
    'landing.chipTrust': 'SHA-256 в вашем браузере',
    'landing.chipCold': 'Ключ COLD · Pi без доступа к сети',
    'landing.chipNode': 'Привязка проверена · собственный узел',
    'landing.ctaVerifySelf': 'Проверьте сами →',
    'landing.sub': 'Два человека или компании договариваются в чате, зашифрованном в браузере, обе стороны принимают соглашение — и остаётся сертификат с меткой времени в Bitcoin.',
    'landing.ctaPrimary': 'Создать моё первое соглашение (бета)',
    'landing.ctaSecondary': 'Посмотреть уже проверенное доказательство',
    'landing.ctaVerify': 'Проверить доказательство',
    'landing.certTitle': 'Сертификат соглашения',
    'landing.certHashLabel': 'Хеш содержимого (SHA-256)',
    'landing.certAnchorLabel': 'Привязка к Bitcoin',
    'landing.certMockBadge': 'Подтверждено в блоке Bitcoin (пример)',
    'landing.sealedStamp': 'ЗАПЕЧАТАНО',
    'landing.s1t': 'Напишите или загрузите соглашение',
    'landing.s1d': 'Текст или файл. Хеш SHA-256 вычисляется в вашем браузере. Для файла передаётся только хеш; если вы вводите текст здесь, текст отправляется сервису, чтобы создать соглашение и доказательства.',
    'landing.s2t': 'Договоритесь и примите',
    'landing.s2d': 'Чат между двумя сторонами, зашифрованный в браузере. Когда обе примут соглашение, переписка замораживается, и её хеш становится частью доказательства.',
    'landing.s3t': 'Запечатано в Bitcoin',
    'landing.s3d': 'Публичный сертификат, который может проверить любой, без учётной записи и бесплатно.',
    'landing.forWhoTitle': 'Для кого это',
    'landing.forWho': 'Журналисты, источники и правозащитные организации, которым нужно доказать, что документ существовал — и что в нём было написано, — прежде чем кто-то его опровергнет, конфискует или удалит, не полагаясь на платформу, на которую можно надавить или которую можно отключить. А также фрилансеры и клиенты, малый бизнес, заключающий сделки, и все, кто хочет зафиксировать дату идеи или патента, прежде чем ими поделиться.',
    'landing.priceTitle': 'Цена',
    'landing.priceBody': 'Бесплатно, без комиссий. Мы не берём плату за создание, принятие, запечатывание или проверку. Код свободный (AGPL-3.0).',
    'landing.soon': 'Скоро',
    'protect.title': 'Как это вас защищает',
    'protect.b1t': 'Закреплено в Bitcoin',
    'protect.b1d': 'Соглашение и замороженный чат закрепляются в блоке Bitcoin через OpenTimestamps. Доказательство показывает, что хеш существовал до этого блока, и вы проверяете это без нас.',
    'protect.b2t': 'Контрподпись ML-DSA-87 с машины без доступа к сети',
    'protect.b2d': 'Доказательства могут содержать контрподпись ML-DSA-87 (FIPS 204), созданную на машине без доступа к сети. Она проверяется по опубликованному отпечатку ключа COLD X-39, а не только по ключу, вложенному в доказательства. Ни один ключ подписи оператора не хранится на сервере, подключённом к сети: историческая подпись WARM выведена из использования в июле 2026 года.',
    'protect.b3t': 'Проверить может любой',
    'protect.b3d': 'Бесплатно, без комиссий. Скачайте доказательство .ots и проверьте его независимыми инструментами: доверять нам не нужно.',
    'protect.b4t': 'Вторые часы: квалифицированная метка времени',
    'protect.b4d': 'Помимо Bitcoin, X-39 добавляет квалифицированную метку времени RFC 3161, выданную ANF AC — квалифицированным поставщиком доверительных услуг по eIDAS (презумпция точности даты и целостности во всём ЕС, ст. 41). Сегодня её содержит публичный Evidence Bundle, и она проверяется без подключения к сети с помощью openssl по корневому сертификату ANF, вложенному в сам Evidence Bundle. Соглашения бета-версии пока имеют привязку к Bitcoin.',
    'protect.viewBlock': 'Посмотреть блок на mempool.space',
    'landing.certOpen': 'Нажмите, чтобы проверить этот сертификат',
    'landing.certRealBadgePending': 'Запечатано · Ожидает подтверждения в Bitcoin',
    'landing.honestyTitle': 'Честность, которую можно проверить',
    'landing.honestyBody': 'Мы не храним чужих средств и не продаём токенов. Файлы не загружаются: передаётся только их хеш SHA-256. Текст, введённый на сайте, отправляется сервису. Статус «Подтверждено» появляется только при реальной аттестации блока Bitcoin.',
    'landing.footer': 'X-39 Agreements — закрытое бета-тестирование проверяемых соглашений, закреплённых в Bitcoin.',
    'panel.kicker': 'Панель',
    'panel.title': 'Мои соглашения',
    'panel.new': 'Новое соглашение',
    'panel.emptyTitle': 'У вас пока нет соглашений.',
    'panel.emptyBody': 'Создайте первое и поделитесь ссылкой-приглашением с другой стороной.',
    'panel.emptyCta': 'Создать моё первое соглашение',
    'panel.waitingOther': 'ожидаем другую сторону',
    'panel.badgePending': 'Ожидает принятия',
    'panel.badgeConfirmed': 'Подтверждено · блок #',
    'panel.badgeSealedPending': 'Запечатано · привязка ожидается',
    'crear.kicker': 'Новое соглашение',
    'crear.title': 'Что вы хотите запечатать?',
    'crear.titleLabel': 'Название соглашения',
    'crear.titlePh': 'напр. Договор на веб-дизайн — сдача и оплата',
    'crear.tabText': 'Текст',
    'crear.tabFile': 'Файл',
    'crear.contentLabel': 'Содержание соглашения',
    'crear.textPh': 'Напишите здесь точные условия соглашения.\nТекст будет сохранён, а его SHA-256 станет запечатанным хешем.',
    'crear.dropTitle': 'Перетащите файл или нажмите, чтобы выбрать',
    'crear.dropNote': 'Файл никогда не загружается: его SHA-256 вычисляется в вашем браузере.',
    'crear.hashLabel': 'Хеш SHA-256 (вычислен на вашем устройстве)',
    'crear.submit': 'Создать соглашение и получить ссылку-приглашение',
    'crear.submitting': 'Создаём…',
    'crear.afterNote': 'После создания соглашения вы отправите другой стороне одноразовую ссылку.',
    'crear.toastCreated': 'Соглашение создано. Поделитесь ссылкой-приглашением.',
    'ag.badgePending': 'Ожидает принятия',
    'ag.badgeConfirmedIn': 'Подтверждено в блоке Bitcoin #',
    'ag.badgeSealedPendingBtc': 'Запечатано · Ожидает подтверждения в Bitcoin',
    'ag.kicker': 'Соглашение',
    'ag.contentLabel': 'Содержание соглашения',
    'ag.fileLabel': 'Запечатанный файл',
    'ag.fileNote': '(файл никогда не загружался; только его хеш)',
    'ag.hashLabel': 'Хеш SHA-256 содержимого',
    'ag.parties': 'Стороны',
    'ag.partyA': 'Сторона A',
    'ag.partyB': 'Сторона B',
    'ag.signed': 'приняла',
    'ag.notSigned': 'не приняла',
    'ag.pendingJoin': 'ещё не присоединилась',
    'ag.inviteLabel': 'Ссылка-приглашение (одноразовая)',
    'ag.copyLink': 'Копировать ссылку',
    'ag.copied': 'Ссылка скопирована',
    'ag.inviteNote': 'Первый человек, открывший эту ссылку, будет закреплён как Сторона B. Никто другой не сможет ею воспользоваться.',
    'ag.signBtn': 'Принять это соглашение',
    'ag.signing': 'Фиксируем принятие и готовим доказательства…',
    'ag.signNote': 'Когда обе стороны примут соглашение, чат замораживается, а доказательство закрепляется в Bitcoin через OpenTimestamps.',
    'ag.alreadySigned': 'Вы приняли соглашение. Ожидаем, пока другая сторона его запечатает и закрепит.',
    'ag.sealedProof': 'Запечатанное доказательство',
    'ag.sealedAt': 'Запечатано (UTC)',
    'ag.proofHash': 'Хеш доказательства',
    'ag.chatHash': 'Хеш замороженного чата',
    'ag.pqSig': 'Историческая подпись оператора ML-DSA-87 (WARM, выведена из использования)',
    'ag.checkAnchor': 'Проверить привязку к Bitcoin',
    'ag.certPdf': 'Сертификат PDF',
    'ag.otsProof': 'Доказательство .ots',
    'ag.publicCert': 'Публичный сертификат',
    'ag.chatHead': 'Чат, зашифрованный в браузере · только стороны',
    'ag.chatFrozenSuffix': ' · заморожен',
    'ag.chatEmpty': 'Сообщений нет. Обсудите условия здесь: переписка будет запечатана вместе с соглашением.',
    'ag.you': 'вы',
    'ag.chatFrozenNote': 'Переписка запечатана. Её хеш — часть доказательства.',
    'ag.chatPh': 'Напишите сообщение…',
    'ag.e2eWaiting': 'Шифрование: ожидаем публичный ключ другой стороны…',
    'ag.chainMismatch': 'Подпись заблокирована: цепочка сообщений на сервере не совпадает с вашей локальной копией (возможен пропуск или изменение порядка). Перезагрузите страницу и проверьте чат.',
    'ag.chainLabel': 'Целостность чата',
    'ag.chainOk': 'Цепочка проверена локально',
    'ag.chainFail': 'Цепочка НЕ совпадает с вашей локальной копией',
    'ag.msgLocked': 'зашифровано — на этом устройстве нет ключа',
    'pay.section': 'Оплата (необязательно)',
    'pay.toggle': 'Добавить оплату к соглашению',
    'pay.amount': 'Сумма (BTC)',
    'pay.address': 'Адрес Bitcoin для получения',
    'pay.who': 'Кто платит?',
    'pay.bPaysA': 'Другая сторона платит мне',
    'pay.aPaysB': 'Я плачу другой стороне',
    'pay.terms': 'Условия оплаты',
    'pay.payTo': 'Получатель',
    'pay.amountLabel': 'Сумма',
    'pay.payerLabel': 'Плательщик',
    'pay.scan': 'Отсканируйте или скопируйте, чтобы оплатить. Напрямую между сторонами, без посредника, который держит средства.',
    'pay.copyAddr': 'Копировать адрес',
    'pay.openWallet': 'Открыть в кошельке',
    'pay.checkStatus': 'Проверить статус оплаты',
    'pay.received': 'Получено',
    'pay.expected': 'Ожидается',
    'pay.paid': 'Оплачено',
    'pay.unpaid': 'Ожидает',
    'pay.noncustodial': 'Приложение никогда не касается средств. Оплата идёт напрямую между сторонами через сеть Bitcoin.',
    'pay.invalidAddr': 'Недействительный адрес Bitcoin',
    'verify.title': 'Проверьте сами (не доверяя нам)',
    'verify.intro': 'Эти проверки не зависят от X-39. Любой может повторить их с помощью свободного программного обеспечения.',
    'verify.checking': 'Сверяем содержимое с закреплённым хешем…',
    'verify.hashOk': 'Содержимое совпадает с хешем, закреплённым в Bitcoin',
    'verify.hashFail': 'Содержимое НЕ совпадает с закреплённым хешем',
    'verify.warm': 'Историческая подпись ML-DSA-87 (WARM · оператор, выведена из использования в 2026 году)',
    'verify.cold': 'Контрподпись ML-DSA-87 с машины без доступа к сети (COLD)',
    'verify.runbook': 'Регламент церемонии ключей (PDF)',
    'verify.btc': 'Привязка метки времени к Bitcoin (OpenTimestamps)',
    'verify.pubkey': 'Публичный ключ',
    'verify.signature': 'Подпись',
    'verify.fp': 'Отпечаток',
    'verify.runPy': 'Проверить подпись ML-DSA-87 (Python)',
    'verify.runOts': 'Проверить привязку к Bitcoin (ots)',
    'verify.dlProof': 'Скачать доказательство (.json)',
    'verify.dlOts': 'Скачать .ots',
    'verify.noCold': 'Это доказательство не содержит контрподписи COLD.',
    'verify.sovereign': 'Независимая проверка выполнена: привязка демонстрационного соглашения проверена 2026-07-31 на собственном урезанном (pruned) узле Bitcoin (блок #957242) — без обозревателей блоков, без календарей, без третьих сторон.',
    'verify.sovereignProof': 'Посмотреть снимок экрана →',
    'verify.copy': 'Копировать',
    'verify.copied': 'Скопировано',
    'ag.toastSealed': 'Соглашение запечатано. Доказательство отправлено в OpenTimestamps.',
    'ag.toastSigned': 'Принятие зафиксировано. Ожидаем другую сторону.',
    'ag.toastStillPending': 'Подтверждения в блоке пока нет. OpenTimestamps обычно занимает несколько часов.',
    'join.kicker': 'Приглашение',
    'join.title': 'Вас пригласили в соглашение',
    'join.body': 'Войдите со своим ключом, чтобы стать Стороной B. Эта ссылка одноразовая: она будет привязана к вашей идентичности.',
    'join.cta': 'Войти с моим ключом и присоединиться',
    'join.progress': 'Присоединяем вас к соглашению…',
    'ver.kicker': 'Публичная проверка · без учётной записи',
    'ver.title': 'Проверить доказательство',
    'ver.sub': 'Проверьте, совпадает ли файл, текст или хеш с запечатанным соглашением. При веб-проверке хеш SHA-256 вычисляется в вашем браузере. Запрос на проверку отправляет только этот хеш, а не исходный файл или текст.',
    'ver.tabFile': 'Файл',
    'ver.tabText': 'Текст',
    'ver.tabHash': 'Хеш',
    'ver.tabBundle': 'Evidence Bundle (.zip)',
    'ver.bundleDrop': 'Перетащите сюда Evidence Bundle x39-evidencia-<id>.zip',
    'ver.bundleNote': 'Проверка на 100% локальная, в вашем браузере: ничего не отправляется ни на какой сервер.',
    'ver.bundleErr': 'Недействительный или неполный ZIP',
    'ver.bverifying': 'Проверяем…',
    'ver.bcheck.files': 'Файлы Evidence Bundle',
    'ver.bcheck.integrity': 'Целостность — SHA-256 файла proof.json',
    'ver.bcheck.consistency': 'Согласованность полей',
    'ver.bcheck.chain': 'Цепочка сообщений чата',
    'ver.bcheck.msgsigs': 'Подписи Ed25519 каждого сообщения',
    'ver.bcheck.mldsa_cold': 'Независимая контрподпись ML-DSA-87 (COLD)',
    'ver.bcheck.mldsa_warm': 'Историческая подпись ML-DSA-87 (WARM)',
    'ver.bcheck.manifest': 'Перечень файлов (README, замороженный при запечатывании)',
    'ver.bcheck.ots_present': 'Якорь Bitcoin присутствует в пакете (здесь не проверяется)',
    'ver.bverdict.valid': 'ДОКАЗАТЕЛЬСТВА ДЕЙСТВИТЕЛЬНЫ',
    'ver.bverdict.consistent': 'СОГЛАСОВАНО — всё, что можно проверить здесь, совпадает; якорь Bitcoin в браузере не проверяется',
    'ver.bverdict.consistent_nocold': 'СОГЛАСОВАНО, БЕЗ КОНТРПОДПИСИ — нет суверенной контрподписи, и якорь Bitcoin здесь тоже не проверяется',
    'ver.bverdict.fail': 'НЕДЕЙСТВИТЕЛЬНО ИЛИ ИЗМЕНЕНО',
    'ver.botsNote': 'Привязка к Bitcoin: браузер не может проверить её без узла. Скачайте .ots и выполните: ots verify proof.json.ots',
    'ver.bdocTitle': 'Добавьте свой исходный документ (необязательно)',
    'ver.bdocNote': 'Документ никогда не покидает ваше устройство: вычисляется только его SHA-256.',
    'ver.bdocOk': 'Ваш документ совпадает с закреплённым content_hash',
    'ver.bdocBad': 'Ваш документ НЕ совпадает с content_hash',
    'ver.dropTitle': 'Перетащите файл для проверки',
    'ver.dropNote': 'SHA-256 вычисляется локально и сверяется с запечатанными соглашениями.',
    'ver.textPh': 'Вставьте сюда точный текст соглашения (байт в байт).',
    'ver.verifyTextBtn': 'Вычислить SHA-256 и проверить',
    'ver.verifyHashBtn': 'Проверить хеш',
    'ver.verifying': 'Проверяем…',
    'ver.hashPh': 'Хеш sha-256 из 64 символов (содержимого или доказательства)',
    'ver.invalidHash': 'Введите действительный SHA-256 (64 шестнадцатеричных символа).',
    'ver.foundTitle': 'Доказательство найдено',
    'ver.matchedBy': 'Совпадение по',
    'ver.matchedContent': 'хешу содержимого',
    'ver.matchedProof': 'хешу доказательства',
    'ver.fTitle': 'Название',
    'ver.anchor': 'Привязка к Bitcoin',
    'ver.pendingConf': 'Ожидает подтверждения',
    'ver.pq': 'Постквантовая подпись (ML-DSA-87)',
    'ver.pqValid': 'Действительна — проверено на сервере',
    'ver.pqInvalid': 'НЕДЕЙСТВИТЕЛЬНА',
    'ver.cold': 'Независимая подпись COLD',
    'ver.contentHash': 'Хеш содержимого',
    'ver.notFoundTitle': 'Совпадений нет',
    'ver.notFoundBody': 'Ни одно запечатанное соглашение не соответствует этому хешу. Один другой байт даёт совершенно другой хеш.',
    'cert.sub': 'Доказательство содержимого и даты, закреплённое в Bitcoin',
    'cert.pendingOts': 'Ожидает подтверждения (OpenTimestamps)',
    'cert.downloadPdf': 'Скачать PDF',
    'cert.payloadJson': 'Данные .json',
    'cert.bundle': 'Evidence Bundle (.zip)',
    'cert.share': 'Поделиться',
    'cert.shareCopied': 'Публичная ссылка скопирована',
    'cert.indepNote': 'Независимая проверка: скачайте данные .json и доказательство .ots и проверьте их любым клиентом OpenTimestamps. Доверять нам не нужно.',
    'cert.legalScope': 'Честно о юридической силе: это доказательство — криптографическое свидетельство существования, целостности и даты: метка времени в Bitcoin и, если она есть, постквантовая контрподпись ML-DSA-87 (NIST FIPS 204) от X-39 как оператора, созданная на машине без доступа к сети. Не заменяет нотариуса.',
    'footer.github': 'GitHub · код и доказательства',
    'landing.codeLink': 'Посмотреть код на GitHub →',
    'footer.contact': 'Контакты',
    'footer.privacy': 'Конфиденциальность',
    'cert.notFound': 'Доказательство не найдено',
    'meta.title': 'X-39 Evidencia — Доказательство существования, закреплённое в Bitcoin',
    'meta.desc': 'Отпечаток и дата ваших файлов закреплены в Bitcoin через OpenTimestamps. Верификатор с открытым кодом (AGPL-3.0): любой может всё проверить, не полагаясь на нас.',
    'privacy.title': 'Конфиденциальность и данные',
    'privacy.p1': 'Что мы храним: хеш SHA-256 того, что вы запечатываете, название соглашения, публичные ключи сторон, дату запечатывания, доказательство OpenTimestamps и, если соглашение предусматривает платёж, его сумму в BTC и адрес получения. Если вы вводите текст соглашения на сайте, этот текст сохраняется, чтобы создать соглашение. Если вы выбираете файл для запечатывания или проверки, его хеш SHA-256 вычисляется локально. Сервису отправляется хеш, без загрузки файла.',
    'privacy.p2': 'Чего мы не храним: ни электронной почты, ни пароля, ни имени. Ваша идентичность — это криптографический ключ, который живёт в вашем браузере. Чат между сторонами шифруется в браузере; сервер хранит только зашифрованный текст.',
    'privacy.p3': 'Cookies: один сеансовый cookie (httponly, 7 дней) после входа с вашим ключом и выбор языка в вашем браузере. Никакой аналитики, никаких трекеров, никаких третьих сторон: этот сайт ничего не загружает с других доменов.',
    'privacy.p4': 'Где и кто: сервер работает в Испании, им управляет José Luis Olivares (security@x39matrix.org). Bitcoin фиксирует криптографическое обязательство, никогда не сам документ. Публичное доказательство соглашения также содержит его название, псевдонимные идентификаторы сторон, даты и, если соглашение предусматривает платёж, его сумму в BTC и адрес получения, но не документ и не содержимое чата. Подтверждённое закрепление можно проверить независимо. Обязательство, зафиксированное в Bitcoin, невозможно удалить из цепочки. По любым вопросам о ваших данных: security@x39matrix.org.',
    'cert.goVerify': 'Перейти к проверке',
    'comms.title': 'X-39 Comunicaciones',
    'comms.sub': 'Зашифрованные звонки, видеозвонки и сообщения между двумя телефонами. Отдельное от X-39 Evidencia приложение того же проекта.',
    'comms.howT': 'Как это работает',
    'comms.how1': 'Ключ каждого звонка согласуется между двумя телефонами с помощью ML-KEM-1024 (FIPS 203) и подписывается ML-DSA-87 (FIPS 204). Аудио и видео шифруются сквозным шифрованием на этом ключе, которого у сервера нет. Сторонний аудит этого пока не проводился.',
    'comms.how2': 'Трафик может идти через необязательный туннель WireGuard до нашего сервера. Без почтового ящика и без номера телефона: идентичность — это ключ, который создаётся на телефоне и никогда его не покидает. Для каждого контакта виден отпечаток его ключа, чтобы сверить его лично или по телефону.',
    'comms.statusT': 'Статус: закрытая бета, по приглашению',
    'comms.status1': 'Код и публичная загрузка появятся в ноябре 2026 года вместе с моделью угроз, руководством по развёртыванию и страницей конфиденциальности. До тех пор приложение передаётся лично тем, кто его просит и тестирует вместе с нами.',
    'comms.statusMail': 'Чтобы запросить доступ:',
    'comms.dlT': 'После публикации',
    'comms.dl1': 'Здесь будут APK, его SHA-256, отпечаток сертификата подписи и команды для их проверки, как на [[странице Evidencia]].',
    'comms.whyT': 'Почему два приложения',
    'comms.why1': 'При запечатывании или якорении в Evidencia календарям отправляется только 32-байтовое обязательство, полученное из отпечатка. Если вы решите отправить капсулу на сопряжённый телефон, оригинал передаётся со сквозным шифрованием.',
    'comms.limitsT': 'Чем это не является',
    'comms.limits1': 'С включённым туннелем тот, кто следит за вашей сетью, не видит, с кем вы говорите и что говорите: он видит зашифрованный трафик к нашему серверу. Но он видит, что вы пользуетесь X-39, может по ритму трафика понять, что идёт звонок, и может заблокировать туннель, как уже делают несколько стран с WireGuard. Сервер не знает содержания, но знает, что два ключа общались, когда и как долго. Если ваш телефон скомпрометирован, ничто из этого вас не защитит. Это не анонимно. Это бета без внешнего аудита: она может давать сбои.',
    'comms.backEvidencia': '← Вернуться к X-39 Evidencia',
    'footer.comms': 'Comunicaciones (бета)',
    'appe.title': 'X-39 Evidencia для Android',
    'appe.sub': 'Фото, аудио, видео или любой файл, запечатанные на вашем телефоне. Версия 0.3.4, опубликована 12 октября 2026 года, на семи языках. Android 9 или новее.',
    'appe.whatT': 'Что делает приложение',
    'appe.what1': 'Вы делаете фото, записываете аудио или видео либо выбираете файл. Он хранится в зашифрованном виде на телефоне. При запечатывании или якорении календарям отправляется только 32-байтовое обязательство, полученное из отпечатка. Если вы решите отправить капсулу на сопряжённый телефон, оригинал передаётся со сквозным шифрованием.',
    'appe.what2': 'Каждый элемент подписывается ML-DSA-87 (FIPS 204) ключом, созданным на телефоне. Без учётной записи и без копии в облаке.',
    'appe.what3': 'Хеш закрепляется в Bitcoin через OpenTimestamps. Любой может проверить квитанцию общедоступными инструментами, без этого приложения и не доверяя нам. Это доказательство существования, целостности и даты; оно не заменяет нотариуса и квалифицированную электронную подпись.',
    'appe.dlT': 'Загрузка',
    'appe.dl1': 'APK скачивается с этого сайта, а также публикуется на GitHub вместе с его SHA-256, отпечатком сертификата подписи, квалифицированной меткой времени и доказательством OpenTimestamps. Проверьте отпечатки перед установкой.',
    'appe.dlLink': 'Скачать x39-0.3.4-release.apk (6,3 МБ) с x39matrix.org',
    'appe.dlLink2': 'Та же версия на GitHub, с файлами для проверки',
    'appe.prevT': 'Предыдущая версия',
    'appe.prev1': 'Версия 0.3.3 (8 октября 2026 года), подписанная тем же сертификатом и закреплённая в блоке 970517, остаётся доступной ещё один релиз.',
    'appe.prevLink': 'Скачать x39-0.3.3-release.apk',
    'appe.prevGh': 'Версия 0.3.3 на GitHub, с файлами для проверки',
    'appe.clocksT': 'Двое часов на одном APK',
    'appe.clock1': 'Квалифицированная метка времени (RFC 3161, eIDAS), выданная ANF AC 2026-10-12 в 15:12:15 UTC; её можно проверить с помощью openssl по корневому сертификату ANF, опубликованному рядом с APK.',
    'appe.clock2': 'Закрепление в Bitcoin: блок 971111 (2026-10-12 15:26:58 UTC), сверено с нашим собственным узлом. Проверяется клиентом OpenTimestamps и любым узлом Bitcoin.',
    'appe.verifyT': 'Проверьте APK',
    'appe.verify1': 'Положив файлы релиза в одну папку:',
    'appe.permsT': 'Разрешения (7)',
    'appe.perms1': 'INTERNET, ACCESS_NETWORK_STATE, CAMERA, RECORD_AUDIO, FOREGROUND_SERVICE, FOREGROUND_SERVICE_SPECIAL_USE и POST_NOTIFICATIONS.',
    'appe.perms2': 'Интернет используется для отправки в календари OpenTimestamps 32-байтового обязательства, полученного из отпечатка, и получения доказательств (по желанию только через Tor с Orbot), а также для зашифрованного чата. Если вы решите отправить капсулу на сопряжённый телефон, оригинал передаётся со сквозным шифрованием.',
    'appe.srcT': 'Код',
    'appe.src1': 'Верификатор, сайт и API — на GitHub (x39-Evidencia, AGPL-3.0). Код приложения будет опубликован в отдельном репозитории; каждая версия выходит со своими отпечатками и двумя метками времени.',
    'appe.toComms': 'X-39 Comunicaciones (отдельное приложение) →',
    'appe.back': '← Вернуться к X-39 Evidencia',
    'footer.app': 'Приложение Android',
    'landing.commsT': 'Приложение-спутник: X-39 Comunicaciones',
    'landing.commsBody': 'От того же проекта: зашифрованные звонки, видеозвонки и сообщения между двумя телефонами, с постквантовым ключом звонка. В закрытой бете по приглашению; код и публичная загрузка появятся в ноябре 2026 года.',
    'landing.commsLink': 'Узнать больше и запросить доступ →',
    'landing.ctaDownload': 'Скачать Evidencia (Android)',
    'landing.ctaCreateBeta': 'Создать соглашение · закрытая бета',
    'landing.proofsT': 'X-39 Evidencia и её доказательства',
    'landing.proofsApk': 'APK для Android с SHA-256, отпечатком сертификата подписи и двумя часами (Bitcoin и квалифицированная метка времени ANF)',
    'landing.proofsRepo': 'Исходный код, лицензия AGPL-3.0',
    'landing.proofsBundle': 'Evidence Bundle v1.1, его верификатор и результат VALID на нашем собственном узле Bitcoin',
    'landing.proofsSevilla': '40 документов Севильи, запечатанные и проверяемые',
    'landing.leavesT': 'Что покидает ваш телефон',
    'landing.leaves': 'При якорении телефон покидает только отпечаток (32-байтовое обязательство, полученное из него), который отправляется календарям OpenTimestamps. Если вы отправляете капсулу на сопряжённый телефон, оригинал передаётся со сквозным шифрованием, и только когда вы её отправляете.',
    'landing.notProveT': 'Чего это не доказывает',
    'landing.notProve': 'Доказывает, что конкретный файл существовал на определённую дату и с тех пор не менялся. Не доказывает, кто его автор и что его содержание правдиво.',
    'landing.commsLine': 'X-39 Comunicaciones — отдельное приложение, в закрытой бете, публичное в ноябре; в Evidencia есть необязательная кнопка, чтобы его открыть, но Evidencia работает и без него: не требует VPN и использует камеру и микрофон только когда вы фотографируете или записываете.',
  },
};

const LangCtx = createContext(null);

export const LANGS = [
  // Sin banderas: cada idioma con su nombre en su propio alfabeto. Ucranianos y rusos
  // exiliados leen la misma web.
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Español' },
  { code: 'uk', name: 'Українська' },
  { code: 'ru', name: 'Русский' },
  { code: 'zh', name: '中文' },
  { code: 'ja', name: '日本語' },
  { code: 'ar', name: 'العربية' },
];

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const fromUrl = new URLSearchParams(window.location.search).get('lang');
    if (LANGS.some((l) => l.code === fromUrl)) { localStorage.setItem('nt_lang', fromUrl); return fromUrl; }
    const saved = localStorage.getItem('nt_lang');
    return LANGS.some((l) => l.code === saved) ? saved : 'en';
  });
  const setLang = (code) => {
    if (!LANGS.some((l) => l.code === code)) return;
    localStorage.setItem('nt_lang', code);
    setLangState(code);
  };
  const t = (key) => STRINGS[lang][key] ?? STRINGS.es[key] ?? key;
  useEffect(() => {
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
    document.title = t('meta.title');
    const md = document.querySelector('meta[name="description"]');
    if (md) md.setAttribute('content', t('meta.desc'));
    const og = document.querySelector('meta[property="og:title"]');
    if (og) og.setAttribute('content', t('meta.title'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang]);
  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
;
